var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373, _path6374, _path6375, _path6376, _path6377, _path6378, _path6379, _path6380, _path6381, _path6382, _path6383, _path6384, _path6385, _path6386, _path6387, _path6388, _path6389, _path6390, _path6391, _path6392, _path6393, _path6394, _path6395, _path6396, _path6397, _path6398, _path6399, _path6400, _path6401, _path6402, _path6403, _path6404, _path6405, _path6406, _path6407, _path6408, _path6409, _path6410, _path6411, _path6412, _path6413, _path6414, _path6415, _path6416, _path6417, _path6418, _path6419, _path6420, _path6421, _path6422, _path6423, _path6424, _path6425, _path6426, _path6427, _path6428, _path6429, _path6430, _path6431, _path6432, _path6433, _path6434, _path6435, _path6436, _path6437, _path6438, _path6439, _path6440, _path6441, _path6442, _path6443, _path6444, _path6445, _path6446, _path6447, _path6448, _path6449, _path6450, _path6451, _path6452, _path6453, _path6454, _path6455, _path6456, _path6457, _path6458, _path6459, _path6460, _path6461, _path6462, _path6463, _path6464, _path6465, _path6466, _path6467, _path6468, _path6469, _path6470, _path6471, _path6472, _path6473, _path6474, _path6475, _path6476, _path6477, _path6478, _path6479, _path6480, _path6481, _path6482, _path6483, _path6484, _path6485, _path6486, _path6487, _path6488, _path6489, _path6490, _path6491, _path6492, _path6493, _path6494, _path6495, _path6496, _path6497, _path6498, _path6499, _path6500, _path6501, _path6502, _path6503, _path6504, _path6505, _path6506, _path6507, _path6508, _path6509, _path6510, _path6511, _path6512, _path6513, _path6514, _path6515, _path6516, _path6517, _path6518, _path6519, _path6520, _path6521, _path6522, _path6523, _path6524, _path6525, _path6526, _path6527, _path6528, _path6529, _path6530, _path6531, _path6532, _path6533, _path6534, _path6535, _path6536, _path6537, _path6538, _path6539, _path6540, _path6541, _path6542, _path6543, _path6544, _path6545, _path6546, _path6547, _path6548, _path6549, _path6550, _path6551, _path6552, _path6553, _path6554, _path6555, _path6556, _path6557, _path6558, _path6559, _path6560, _path6561, _path6562, _path6563, _path6564, _path6565, _path6566, _path6567, _path6568, _path6569, _path6570, _path6571, _path6572, _path6573, _path6574, _path6575, _path6576, _path6577, _path6578, _path6579, _path6580, _path6581, _path6582, _path6583, _path6584, _path6585, _path6586, _path6587, _path6588, _path6589, _path6590, _path6591, _path6592, _path6593, _path6594, _path6595, _path6596, _path6597, _path6598, _path6599, _path6600, _path6601, _path6602, _path6603, _path6604, _path6605, _path6606, _path6607, _path6608, _path6609, _path6610, _path6611, _path6612, _path6613, _path6614, _path6615, _path6616, _path6617, _path6618, _path6619, _path6620, _path6621, _path6622, _path6623, _path6624, _path6625, _path6626, _path6627, _path6628, _path6629, _path6630, _path6631, _path6632, _path6633, _path6634, _path6635, _path6636, _path6637, _path6638, _path6639, _path6640, _path6641, _path6642, _path6643, _path6644, _path6645, _path6646, _path6647, _path6648, _path6649, _path6650, _path6651, _path6652, _path6653, _path6654, _path6655, _path6656, _path6657, _path6658, _path6659, _path6660, _path6661, _path6662, _path6663, _path6664, _path6665, _path6666, _path6667, _path6668, _path6669, _path6670, _path6671, _path6672, _path6673, _path6674, _path6675, _path6676, _path6677, _path6678, _path6679, _path6680, _path6681, _path6682, _path6683, _path6684, _path6685, _path6686, _path6687, _path6688, _path6689, _path6690, _path6691, _path6692, _path6693, _path6694, _path6695, _path6696, _path6697, _path6698, _path6699, _path6700, _path6701, _path6702, _path6703, _path6704, _path6705, _path6706, _path6707, _path6708, _path6709, _path6710, _path6711, _path6712, _path6713, _path6714, _path6715, _path6716, _path6717, _path6718, _path6719, _path6720, _path6721, _path6722, _path6723, _path6724, _path6725, _path6726, _path6727, _path6728, _path6729, _path6730, _path6731, _path6732, _path6733, _path6734, _path6735, _path6736, _path6737, _path6738, _path6739, _path6740, _path6741, _path6742, _path6743, _path6744, _path6745, _path6746, _path6747, _path6748, _path6749, _path6750, _path6751, _path6752, _path6753, _path6754, _path6755, _path6756, _path6757, _path6758, _path6759, _path6760, _path6761, _path6762, _path6763, _path6764, _path6765, _path6766, _path6767, _path6768, _path6769, _path6770, _path6771, _path6772, _path6773, _path6774, _path6775, _path6776, _path6777, _path6778, _path6779, _path6780, _path6781, _path6782, _path6783, _path6784, _path6785, _path6786, _path6787, _path6788, _path6789, _path6790, _path6791, _path6792, _path6793, _path6794, _path6795, _path6796, _path6797, _path6798, _path6799, _path6800, _path6801, _path6802, _path6803, _path6804, _path6805, _path6806, _path6807, _path6808, _path6809, _path6810, _path6811, _path6812, _path6813, _path6814, _path6815, _path6816, _path6817, _path6818, _path6819, _path6820, _path6821, _path6822, _path6823, _path6824, _path6825, _path6826, _path6827, _path6828, _path6829, _path6830, _path6831, _path6832, _path6833, _path6834, _path6835, _path6836, _path6837, _path6838, _path6839, _path6840, _path6841, _path6842, _path6843, _path6844, _path6845, _path6846, _path6847, _path6848, _path6849, _path6850, _path6851, _path6852, _path6853, _path6854;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPensAndMarkers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 102v-1h-1v-1h2v1h1v-1h1v1h4v-1h4v1h7v1h-1v1h-4v-1h-1v2h-2v-2h-6v1h-1v-1zm-74-3h6v2h-6zm30-79h-1v-1h-4v-1h8v1h-3zm-10 0v-2h4v1h-2v1zm60 2v1h-4v-1h1v-1h1v1zm-66-3h-2v-1h3v2h-1zm55 81v1h-3v-1zm-73-1h1v1h-2v-1zm87 6v1h-2v-1h1zM31 18h1v1h-1zm12 2v1h-1v-1zm16 1h-1v-1h1zm35-1v1h-1v-1zm-36 2h-1v-1h1zm39 0h1v1h-1zm11 0h1v1h-1zM96 95v-1h1v1zm-72 5h-1v-1h1zm73 2h-1v-1h1zm20 1v-1h1v1zm-95 3v-1h1v1zm80-1v1h-1v-1zm7 0h1v1h-1zm-19 3v-1h1v1zm5 0v-1h1v1zm-73 2v1h-1v-1zm3 1h-1v-1h1zm5 2h-1v-1h1z",
    fill: "#010302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 101v-1h4v2h-1v-1h-1v1h-6v-1h3zm24 3v1h-11v-1h2zM54 19v1h-2v1h-1v-1h-1v1h-1v-1h-2v-1zm49 3v-1h6v1zm-5-1v1h-4v-1h1zm3 84v1h-3v-1zm-10 9v-1h3v1zM39 19v1h-2v-1h1zm18 1h-2v-1h2zm-26 85h-1v-1h2v1zm0-86h-1v-1h1zm47 0h-1v-1h1zm12 1h1v1h-1zm-2 2h-1v-1h1zm2-1v1h-1v-1zm20 2h-1v-1h1zm-79 2v1h-1v-1zM20 99v-1h1v1zm80 2v-1h1v1zm17 1v1h-1v-1zm-12 3v1h-1v-1z",
    fill: "#000201"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102 101v-1h4v1h-1zm6 2h-2v-1h3v2h-1zm15-1h-3v-1h3zm-10 3v1h-3v-1zm-22 2h3v1h-3zm5-84h-1v-1h2v1zm4 70h1v1h-2v-1zm19 9h-2v-1h2zm-5 1v1h-2v-1h1zm4 1h-1v-1h2v1zm-2 2h-1v-1h2v1zm-87 8v-1h2v1h-1zm45-95v-1h1v1zm15 3h-1v-1h1zm10 0v1h-1v-1zm-66 4v-1h1v1zm64 67v1h-1v-1zm-76 1v1h-1v-1zm75 0v1h-1v-1zm-78 4v-1h1v1zm11 1h-1v-1h1zm68 1h-1v-1h1zm19 1h-1v-1h1zm-85 0v1h-1v-1zm71 1v1h-1v-1zm17 1v-1h1v1zm-88 3h-1v-1h1zm72 0h-1v-1h1zm5-1h1v1h-1zm-8 1h1v1h-1zm-71 6v-1h1v1zm79 1h1v1h-1zm3 0h1v1h-1z",
    fill: "#020403"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22v-1h17v1zm24-1v1h-6v-1zm-18-2h-1v-1h5v1zm-42 6h1v1h-4v-1zm65 83h-1v-3h1v1zm-59 3h1v2h-1v-1zm68-91v1h-1v-1zm-60 7v-1h1v1zm73 0h1v1h-1zm-80 78v-1h1v1zm58 9h-1v-1h1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 106v-1h-1v-1h3v1h4v1zM33 19v-1h1v-1h1v2zm70 86v-1h3v1zm-10 7h2v2h-1v-1h-1zM59 22v-1h2v1h-1zm54 7h-2v-1h2zM31 16v1h-1v-1zm-5 2v-1h1v1zm10 2v-1h1v1zm19 0v1h-1v-1zm30 2v-1h1v1zm-56 3h1v1h-1zm11 2v1h-1v-1zm49 73h1v1h-1zm31 4v1h-1v-1zm-29 2h-1v-1h1zm-77 4h1v1h-1zm17 4v-1h1v1zm67 0h-1v-1h1z",
    fill: "#010101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102 114v-1h4v1h-1zm-9-92h1v1h-2v-1zm1 78h-2v-1h2zm18 0h2v1h-2zm3 13v1h-2v-1h1zm3 0v1h-2v-1h1zm2 1h1v1h-2v-1zM24 18v-1h1v1zm4-1v1h-1v-1zm8 2h-1v-1h1zm28 0v-1h1v1zm40 1h-1v-1h1zm8-1h1v1h-1zm-2 2v-1h1v1zm-84 4h1v1h-1zm73 75v-1h1v1zm2 0v-1h1v1zm-8 2v1h-1v-1zm-67 9v1h-1v-1zm2 0h1v1h-1zm69 1h-1v-1h1zm4 0h1v1h-1z",
    fill: "#030303"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 93v1h-1v1h-1v-1h-1v-1h2zm-68 9h-3v-1h3zm70 1v-1h3v1zm2-80h-1v-1h2v1zM90 93h2v1h-2zm5 7h-1v-1h2v1zm22 1h-1v-1h2v1zm0 2v1h-2v-1h1zm-2 2v1h-2v-1h1zm2 0h2v1h-2zM90 22v1h-1v-1zM27 93v1h-1v-1zm-6 4h1v1h-1zm86 7v-1h1v1zm-8 3v-1h1v1zm-5 0h1v1h-1z",
    fill: "#030504"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101 113h1v1h-4v-1h-1v1h-2v-2h6zm-6-8h-1v-1h2v1zm-83 5h2v1h-2zm81 2v1h-2v-1h1zM34 16h1v1h-1zm-8 2h-1v-1h1zm10 1v-1h1v1zm78 0h1v1h-1zM31 97h1v1h-1zm81 3v1h-1v-1zm-82 13v-1h1v1zm88 1v1h-1v-1z",
    fill: "#020202"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54 21h3v1h-3zm51 2v-1h3v1zm-72-4h-1v-2h1v1zm-8-2h-1v-1h1zm15 3v1h-1v-1zm7 0h1v1h-1zm6 0v1h-1v-1zm5 1h1v1h-1zm28 0h1v1h-1zm5 0h1v1h-1zm-1 84v-1h1v1zm17 0h-1v-1h1zm11-1h1v1h-1z",
    fill: "#010201"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104h5v1h-5zm6-5h1v3h-1v-1zm24-79h2v1h-2zm3 0h-1v-1h1zm20 1h1v1h-1zm13 1h-1v-1h1zm-60 4v-1h1v1zm11 0h1v1h-1zm54 81h1v1h-1zm-75 3v1h-1v-1zm11 1h-1v-1h1z",
    fill: "#000100"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112v-1h4v1h-1zm8 0h-1v-1h4v1zm-7-89h-1v-1h2v1zm-25-5v1h-1v-1zm34 80h1v1h-1zm-9 1v1h-1v-1zm24 1v1h-1v-1zm-19 11v1h-1v-1zm19 2h1v1h-1zm3 1v-1h1v1z",
    fill: "#040404"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98v1h-2v-1h1zm-2 14v-1h2v1h-1zm6-95v1h-1v-1zm66 3v1h-1v-1zm-4 3v-1h1v1zm3 70h1v1h-1zm-85 6v-1h1v1zm89 0v1h-1v-1zm-10 3h1v1h-1zm6 1v-1h1v1zm-72 8v-1h1v1zm81 3v-1h1v1zm11 0v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#020303"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97 20v1h-3v-1h1zm-57 0v-2h1v2zm5-1h-1v-1h1zm12 2v-1h1v1zm46-1h1v1h-1zm10 0v1h-1v-1zm-59 2h-1v-1h1zM31 98h1v1h-1zm-6 3h-1v-1h1zm65 0v-1h1v1zm12 3h1v1h-1zm2 2h-1v-1h1zm1 0v-1h1v1z",
    fill: "#010202"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-9v-1zm35 0h-1v-1h1zm2 0h-1v-1h1zm10 0h-1v-1h1zm4 0v-1h1v1zm10 0v-1h1v1zm5-1h1v1h-1zm-61 2h-1v-1h1z",
    fill: "#ffff7e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111 112v1h-8v-1h2zM35 17h2v1h-2zm53 2h-1v-1h1zm-28 1v1h-1v-1zm2 1h-1v-1h1zm36 77h1v1h-1zm3 14v-1h1v1z",
    fill: "#060606"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116 100v-1h3v1zM62 18h-1v-1h1zm-3 1h-1v-1h1zm6 3v1h-1v-1zm7 1h-1v-1h1zm24 1h-1v-1h1zm7-1v1h-1v-1zm5 1v-1h1v1zm4 68h1v1h-1zm2 1v-1h1v1zm-19 3v-1h1v1zm12 10h1v1h-1zm2 1v-1h1v1z",
    fill: "#090b0a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107 24h-3v-1h3zm8 68h1v2h-2v-1h1zm-10 2v-1h3v1zm5-71v1h-1v-1zm-6 71h-1v-1h1zm8-1h1v1h-1zm6 1h-1v-1h1zm-17 1v-1h1v1zm-5 0h1v1h-1z",
    fill: "#070908"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v-1h9v1zm16-78v-1h1v1zm-56 4h-1v-1h1zm109 36v1h-1v-1zm-11 38h-1v-1h1zm-4 25h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14h4v1h-4zm23 2h-1v-1h1zm15 30h1v1h-1zm1 25v1h-1v-1zm-15 22h-1v-1h1zm7 1v1h-1v-1zm9 0v1h-1v-1zm-18 5v-1h1v1zm6-1h1v1h-1zm-5 10v-1h1v1zm-79 2v-1h1v1z",
    fill: "#121413"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h1v1h-2v-1zm64 4v-1h2v1h-1zm-15-1v-1h1v1zm-34 1v1h-1v-1zm68 0v1h-1v-1zm-10 2h-1v-1h1zM13 99v-1h1v1zm97 1h1v1h-1zm-20 2h1v1h-1zm21 2v-1h1v1zm4 0h-1v-1h1zm-84 1h1v1h-1z",
    fill: "#020302"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24v-1h3v1h-1zm6 0h-2v-1h2zm-39-7v1h-1v-1zm0 6h-1v-1h1zm8-1v1h-1v-1zm41 70v1h-1v-1zm1 1v-1h1v1zm-19 2h1v1h-1zm15 11v1h-1v-1zm10 1h-1v-1h1zm-105 3v-1h1v1z",
    fill: "#0a0c0b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-5v-1h2zm38 1v1h-2v-1h1zm15-9h1v1h-1zm-68 7v1h-1v-1zm6 1v1h-1v-1zm1 0h1v1h-1zm58 1h1v1h-1zm7 0v1h-1v-1zM13 98h-1v-1h1z",
    fill: "#040402"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121 100h1v1h-2v-1zM41 19v-1h1v1zM31 94h-1v-1h1zm62 0h-1v-1h1zm-66 4h-1v-1h1zm-8 1h-1v-1h1zm78-1h1v1h-1zm22 3h-1v-1h1zm1 1h-1v-1h1zm-13 1v1h-1v-1zm-7 5v-1h1v1zm7 7h-1v-1h1z",
    fill: "#040605"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87 27v-1h3v1h-1zm16-12v1h-1v-1zm18 57v-1h1v1zM97 93h-1v-1h1zm3 0h-1v-1h1zm12 1v1h-1v-1zm-19 1v1h-1v-1zm5 0h1v1h-1zm6 3v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#131514"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109 24h1v1h-2v-1zm-1 71h-1v-1h2v1zm-2-80v1h-1v-1zM84 26h1v1h-1zm36 37v1h-1v-1zm-16 29h1v1h-1zm-80 2h-1v-1h1zm79 0h1v1h-1zm7 1v-1h1v1zm-7 4h-1v-1h1z",
    fill: "#101211"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18v-1h1v1zm12 2v-1h1v1zm57 74v1h-1v-1zm-67 5h-1v-1h1zm68 1h-1v-1h1zm-4 2v1h-1v-1zm2 1h-1v-1h1zm22 1v-1h1v1zm1 2h-1v-1h1zm-23 0h1v1h-1zm18 9v-1h1v1zm7 0h-1v-1h1z",
    fill: "#030404"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25 114v-1h2v1h-1zm51-95v-1h1v1zm34 1v1h-1v-1zM30 93v1h-1v-1zm69 1h-1v-1h1zm-10 1v-1h1v1zm-78 4v-1h1v1zm80 0h1v1h-1zm2 3h1v1h-1zm-75 7h1v1h-1zm95 5h-1v-1h1z",
    fill: "#030403"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106 100h-1v-1h2v1zm4 0h-2v-1h2zm1-75h-1v-1h1zm-7 69v-1h1v1zm5 0h-1v-1h1zm5 0h-1v-1h1zm2 0v-1h1v1zm-17 0h1v1h-1zm-73 3v1h-1v-1zm93 4v-1h1v1z",
    fill: "#060807"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108 16h-2v-1h2zM86 26v1h-1v-1zm34 54v-1h1v1zM96 92v1h-1v-1zm11 3h-1v-1h1zm6-1h1v1h-1zm2 1v-1h1v1zm-15 1v-1h1v1zm6 3v-1h1v1zm9 12v1h-1v-1z",
    fill: "#111312"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20h2v1h-2zm48 2h-1v-1h2v1zm-63-4v-1h1v1zm44 0v1h-1v-1zm-25 2v1h-1v-1zm1 0h1v1h-1zm3 1v-1h1v1zm68 84h-1v-1h1zm-105 5v1h-1v-1z",
    fill: "#000101"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92 19h2v1h-2zM27 94v-1h2v1h-1zm0 20v-1h2v1h-1zm22-96h1v1h-1zm63 7v-1h1v1zm-88 75v-1h1v1zm66 0h-1v-1h1zm-69 6v-1h1v1z",
    fill: "#020402"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96 99h-1v-1h2v1zm8 0h1v1h-2v-1zM90 21h-1v-1h1zm9 0h1v1h-1zm-11 2h-1v-1h1zm11 72h-1v-1h1zm2 0h-1v-1h1zm-72 2h1v1h-1zm79 3h-1v-1h1z",
    fill: "#050706"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v1h-2v-1h1zm-4 0h1v1h-1zm6 0h1v1h-1zm31 42h-1v-1h1zm-1 6v1h-1v-1zm-26 41v1h-1v-1zm16 8h1v1h-1zm7 0h1v1h-1zm3 0h1v1h-1z",
    fill: "#131313"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119 94v1h-3v-1zm-10-78h-1v-1h1zM69 27v1h-1v-1zm34 65h1v1h-1zm17 1v-1h1v1zm-16 1h1v1h-1zm6 0v1h-1v-1zm10 1v-1h1v1z",
    fill: "#0f1110"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h3v1zM44 17h1v1h-1zm41 1v1h-1v-1zm24 1h1v1h-1zm-60 7h1v1h-1zm4 1h-1v-1h1zm-16 1v-1h1v1zm72 1v1h-1v-1z",
    fill: "#060604"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111 106h3v1h-3zM30 93h-1v-1h2v1zm85 13h2v1h-2zM63 19h-1v-1h1zm55 73h1v1h-1zm1 14h1v1h-1z",
    fill: "#0c0e0d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23h-2v-1h2zm31 0h1v1h-1zM32 93h-1v-1h1zm85 0v-1h1v1zm-97 2h-1v-1h1zm100 5h-1v-1h1zm-10 7v-1h1v1zm4-1h1v1h-1zm4 0v1h-1v-1z",
    fill: "#0b0d0c"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M110 93h2v1h-2zm10 7v-1h2v1h-1zM72 23v-1h1v1zm31 0h1v1h-1zm5 1h-1v-1h1zm9 68v1h-1v-1zm-19 4h-1v-1h1zm17 4v-1h1v1z",
    fill: "#080a09"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M116 95h1v1h-2v-1zm-7-68h-1v-1h1zm-6 69h-1v-1h1zm9-1v1h-1v-1zm2 0v1h-1v-1zm6 1v-1h1v1zm-21 1h1v1h-1zm7 12h-1v-1h1zm8-1h1v1h-1z",
    fill: "#272928"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97 107h-3v-1h3zM44 18v1h-1v-1zm-11 6v1h-1v-1zm-10 77h-1v-1h1zm69 6v-1h1v1zm-65 4v-1h1v1zm4 0h-1v-1h1z",
    fill: "#040504"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104 102h1v1h-2v-1zm7 11v1h-2v-1h1zM92 21v-1h1v1zm20 81v1h-1v-1zm6 0h1v1h-1zm3 1h-1v-1h1zm-14 11v-1h1v1z",
    fill: "#010403"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M105 24h1v1h-2v-1zm2 83h1v1h-2v-1zM48 14v-1h1v1zm72 33h1v1h-1zm1 51v1h-1v-1zm-7 9h1v1h-1z",
    fill: "#171918"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h-1v-1h1zm82 2v1h-1v-1zm-84 8h-1v-1h1zm33 0h1v1h-1zm48 1v-1h1v1zm3 0h-1v-1h1zM14 98h-1v-1h1zm76 7h-1v-1h1z",
    fill: "#010100"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M115 16h1v1h-1zm-24 3v-1h1v1zm7-1v1h-1v-1zm-63 9h-1v-1h1zm26 0h-1v-1h1zm43 0v1h-1v-1zm-18 1h1v1h-1zm16 2v-1h1v1z",
    fill: "#090907"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M107 109v-1h2v1h-1zm3-84v1h-1v-1zm4 73v-1h1v1zm-10 11v-1h1v1zm9-1h1v1h-1zm6 1v-1h1v1zm-9 0h1v1h-1z",
    fill: "#2f3130"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M121 46h-1v-1h1zm0 6v1h-1v-1zm-1 19v-1h1v1zM98 92h1v1h-1zm10 6v1h-1v-1zm7 0h1v1h-1zm4 0h1v1h-1zm-15 9h1v1h-1z",
    fill: "#151716"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M105 107h-2v-1h2zM35 15h-1v-1h1zm-2 9h-1v-1h1zm34 4h-1v-1h1zm40 79h-1v-1h1zm-93 2v1h-1v-1z",
    fill: "#070a09"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M103 16v-1h1v1zm5 8v1h-1v-1zm14 49h-1v-1h1zm-22 19h1v1h-1zm9 6v1h-1v-1zm-6 10v-1h1v1zm10 3h1v1h-1z",
    fill: "#141615"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117 113v-1h3v1h-1zM35 17v-1h1v1zm7 3v1h-1v-1zM18 98v1h-1v-1zm104 15h-1v-1h1z",
    fill: "#090909"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M112 16h1v1h-1zm-8 8v1h-1v-1zm3 0v1h-1v-1zm13 40v1h-1v-1zm-6 34h1v1h-1zm-4 10h-1v-1h1zm8-1h1v1h-1z",
    fill: "#161817"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M97 18v1h-4v-1h1zm8 10h-1v-1h1zm4-1v1h-1v-1zm-23 1v1h-1v-1z",
    fill: "#0a0a08"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93 28h-1v-1h2v1zm20-9v-1h1v1zm-11 8h1v1h-1zm-15 1h1v1h-1zm19 2h-1v-1h1zm17 73h-1v-1h1z",
    fill: "#070705"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20v1h-1v-1zm15 76v1h-1v-1zm7 0v1h-1v-1zm-18 1v1h-1v-1zm12 0v1h-1v-1zm-11 12h1v1h-1zm12 0h1v1h-1z",
    fill: "#363837"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15 98h1v1h-2v-1zm8 13h2v1h-2zm24-90v1h-1v-1zm5 0v1h-1v-1zm38 72v1h-1v-1z",
    fill: "#010303"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M110 115v-1h2v1h-1zM33 22v1h-1v-1zm-1 3h1v1h-1zm-2 73v1h-1v-1zm-6 8h-1v-1h1zm5 5h-1v-1h1z",
    fill: "#020404"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100 98v-1h2v1h-1zm5-72v-1h1v1zm-23 2h-1v-1h1zm21 80h1v1h-1zm9 1h-1v-1h1zm3 0v1h-1v-1z",
    fill: "#2e302f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-6v-1h6zm-9-1h1v1h-1z",
    fill: "#bae3f0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66h-1v-1h1zm-18 29v1h-1v-1zm15 4h-1v-1h1zm1 0v-1h1v1zm-8 8h1v1h-1zm7 0v1h-1v-1zm2 1v-1h1v1z",
    fill: "#1a1c1b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16 97v1h-1v-1zm6 2h1v1h-1zm83 4v-1h1v1zm-73 3v-1h1v1zm-12 1v-1h1v1zm78 1h-1v-1h1zm-76 3v-1h1v1z",
    fill: "#010402"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M119 114v-1h3v1zm-17-16v1h-1v-1zm-79 9h-1v-1h1zm68-1v1h-1v-1zm12 7h-1v-1h1z",
    fill: "#050505"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66 23h-1v-1h2v1zm-33-9h1v1h-1zm34 14v-1h1v1zm52 66h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#080b0a"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-2v-1h1zm19 1h1v1h-1zm2 1v-1h1v1zm3-1h1v1h-1zm-4 10v-1h1v1z",
    fill: "#2d3331"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M76 15v-1h2v1h-1zm25 1h-1v-1h2v1zm-4 77v-1h1v1zm15 5v1h-1v-1z",
    fill: "#131615"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M112 16v1h-1v-1zm-2 11h-1v-1h1zm7 69v-1h1v1zm-7 1h1v1h-1zm-2 13h1v1h-1zm9 0v1h-1v-1z",
    fill: "#282a29"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v1h-3v-1h1zm2 0h1v1h-2v-1zm-9 1h-1v-1h1z",
    fill: "#090b08"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1zm37 4h1v1h-1zm-32 1v1h-1v-1zm16 2h1v1h-1zm41 51v1h-1v-1zm-1 4v1h-1v-1z",
    fill: "#1e201f"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21h-1v-1h2v1zm-7 5h1v1h-2v-1zm64 2h1v1h-1zM22 98v1h-1v-1z",
    fill: "#010200"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1zm26 75v1h-1v-1zm9 1h-1v-1h1zm-6 1h-1v-1h1zm7 0h-1v-1h1zm0 10v1h-1v-1z",
    fill: "#323433"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h2v1zm-4 0v-1h1v1zm6 0v-1h1v1zm-62 2h1v1h-1zm-3 85v1h-1v-1z",
    fill: "#050607"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M102 25h3v1h-3zm6 0h1v1h-2v-1zm8 84v-1h1v1z",
    fill: "#303231"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M63 31v-1h2v1h-1zM44 49h1v1h-1zm-14 7v1h-1v-1zm16 20h-1v-1h1zm61 9h1v1h-1z",
    fillOpacity: 0.004
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M45 42v-1h3v1zm-3-1h1v1h-1zm9 0v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43h-1v-1h2v1zm-46-1h1v1h-1zm5 0v1h-1v-1zm28 0v1h-1v-1zm6 1h-1v-1h1z",
    fill: "#ffff79"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v1h-2v-1h1zm-10 1v-1h1v1zm4-1h1v1h-1zm28 0v1h-1v-1zm4 1h-1v-1h1z",
    fill: "#ffff7c"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1zm8 0h1v1h-1zm6 1h-1v-1h1zm14-1v1h-1v-1zm-73 2v-1h1v1zm12 0v-1h1v1z",
    fill: "#ffff7f"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-1v-1h1zm71 16h1v1h-1zm33 23v1h-1v-1zM68 84h1v1h-1zM10 99h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-2v-1zm48-2v-1h1v1zM83 27v-1h1v1zM27 92h1v1h-1z",
    fill: "#0d0f0e"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17v-1h1v1zm40 4v-1h1v1zm38 0h1v1h-1zm10 78v1h-1v-1zm-7 5v-1h1v1z",
    fill: "#070807"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M107 21h-1v-1h2v1zm-78-5h1v1h-1zm54 11h1v1h-1zM22 99v-1h1v1z",
    fill: "#020301"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M112 19v1h-2v-1h1zm-79-2h-1v-1h1zm55 11h-1v-1h1zm15 86h1v1h-1z",
    fill: "#050504"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-2v-1h1zm-19-9v-1h1v1zm76 3h-1v-1h1zm-22 8h-1v-1h1z",
    fill: "#050503"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94h1v1h-2v-1zM38 18h-1v-1h1zm62 89v1h-1v-1zm-75 7h-1v-1h1z",
    fill: "#040604"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v-1h4v1h-1zM39 17h1v1h-1z",
    fill: "#050704"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17h1v1h-2v-1zm-6 1v-1h1v1zm-7 7h1v1h-1zm62 5v-1h1v1z",
    fill: "#070906"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M88 18h1v1h-1zm32 31h-1v-1h1zm-8 51h-1v-1h1zm0 12v1h-1v-1zm4 1h-1v-1h1z",
    fill: "#070707"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M112 112h2v1h-2zM89 18h1v1h-1zm24 11h1v1h-1zm3 83h1v1h-1z",
    fill: "#080808"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20h-1v-1h1zm14 4v1h-1v-1zm13 2v-1h1v1zm-17 2h1v1h-1zm27 71h-1v-1h1z",
    fill: "#1c1e1c"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M105 115h-1v-1h2v1zM90 19v1h-1v-1zm-2 3h1v1h-1zm4 85h-1v-1h1z",
    fill: "#050605"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M112 100v-1h3v1zM63 20v1h-1v-1zm36 91h-1v-1h1z",
    fill: "#090a09"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1zm21 0v-1h1v1zm-19 7h-1v-1h1zm41 54h1v1h-1zm-15 29h-1v-1h1z",
    fill: "#212221"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M101 21v-1h1v1zm-2 75v1h-1v-1zm15 0h1v1h-1zm-17 1v1h-1v-1zm15 12v1h-1v-1z",
    fill: "#3a3c3b"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22 112h-2v-1h2zm84-92v1h-1v-1zm6 1h-1v-1h1zm1 8v-1h1v1z",
    fill: "#020203"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46 21v1h-3v-1zm3 0v1h-2v-1h1z",
    fill: "#010404"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-2v-1h1zm66-2h-1v-1h1zm-78 2v-1h1v1zm50 1h-1v-1h1z",
    fill: "#030402"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-2v-1h1zm3 1h-1v-1h2v1zm5 1v-1h1v1z",
    fill: "#020401"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h2v1h-1zm49 67v1h-2v-1h1zm-77 3v1h-1v-1z",
    fill: "#030502"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1zM23 48h-1v-1h1zm23 1v1h-1v-1zm-11 9v-1h1v1zm-10 7h-1v-1h1z",
    fillOpacity: 0.016
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1zm3 0h1v1h-1zm4 0v1h-1v-1zm2 1v-1h1v1zm39 0h-1v-1h1z",
    fill: "#ff7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h2v1h-1zm14 0h-2v-1h2zm47 0v1h-1v-1z",
    fill: "#ffff75"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1zm21 0v-1h1v1zm15 0h-1v-1h1zm5-1h1v1h-1zm-60 1h1v1h-1z",
    fill: "#ffff7b"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-2v-1zm39 0h-1v-1h1zm8 0h-1v-1h1zm5 0v-1h1v1z",
    fill: "#ffff7d"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M121 55v-1h1v1zm-27 48v1h-1v-1zm9 8v1h-1v-1zm3 0v1h-1v-1zm13 5v-1h1v1z",
    fill: "#0e0e0e"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-2v-1h2zm3-1h1v1h-2v-1zm-9 1h-1v-1h1z",
    fill: "#71bdf8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h1v1h-5v-1z",
    fill: "#52a7f3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1zm23 2h-1v-1h1zm2 0h-1v-1h1zm1 7h1v1h-1zm67 35v-1h1v1z",
    fillOpacity: 0.012
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M121 108h-1v-1h2v1zm2-35v1h-1v-1zm-14 35h-1v-1h1zm8-1h1v1h-1z",
    fill: "#181a19"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-5v-1h2z",
    fill: "#84a382"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M82 94v1h-5v-1z",
    fill: "#416912"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M107 96v-1h2v1h-1zm-4-1h1v1h-1zm16 0h1v1h-1zm4 1h-1v-1h1z",
    fill: "#242625"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M119 97v1h-2v-1h1zm-13 0h-1v-1h1zm6 0h-1v-1h1zm-4 13v-1h1v1z",
    fill: "#3c3e3d"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M109 97v1h-2v-1h1zm-3 0v-1h1v1zm12 11v1h-1v-1zm1 2v-1h1v1z",
    fill: "#343635"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M120 98h-1v-1h1zm-20 10h1v1h-1zm7 3v-1h1v1zm2-1h1v1h-1zm5 0v1h-1v-1z",
    fill: "#292b2a"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M102 100v-1h1v1zm-77 1v1h-1v-1zm70 2v-1h1v1zm-2 4v-1h1v1zm-66 3v1h-1v-1z",
    fill: "#040505"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M29 113h-5v-1h5z",
    fill: "#000303"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-1v-1zm53 3h-1v-1h1zM78 27h1v1h-1zm44 44h-1v-1h1z",
    fill: "#151817"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15h2v1h-2zm-4 1h-1v-1h1zm2-1h1v1h-1z",
    fill: "#202424"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h-4v-1h4z",
    fill: "#1b1f1e"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h-1v-1h1zm71 82v-1h1v1zm7 5h-1v-1h1zm-86 2v-1h1v1z",
    fill: "#060706"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M93 17h-1v-1h2v1zm-3 0v-1h1v1zm0 8h1v1h-1z",
    fill: "#2a2e2d"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18h-2v-1h2zm-4-1h1v1h-1zm32 27v-1h1v1z",
    fill: "#1b1c1b"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h2v1h-2zm22-7h-1v-1h1zm13 93h-1v-1h1z",
    fill: "#292a29"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h2v1zm32-9v1h-1v-1zm14 12h-1v-1h1z",
    fill: "#080806"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M105 19h-1v-1h1zM78 29h-1v-1h1zm4-1h1v1h-1zm29 1v1h-1v-1z",
    fill: "#0c0c0a"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1zm53 78h-1v-1h1zm7 0v-1h1v1zm0 13h-1v-1h1z",
    fill: "#404241"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M97 19v1h-3v-1zm13 10v-1h1v1z",
    fill: "#030302"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1zm4 0h1v1h-1zm7 0v1h-1v-1zm14 73h-1v-1h1z",
    fill: "#0c0d0c"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1zm15 75h1v1h-1zm9 0h1v1h-1zm4 13h1v1h-1z",
    fill: "#3e403f"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22v-1h1v1zm60 77v1h-1v-1zm22 6h1v1h-1zm-90 5v1h-1v-1z",
    fill: "#020504"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22v-1h1v1zm3-1h1v1h-1zm9 0v1h-1v-1zm60 1h-1v-1h1z",
    fill: "#000202"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21h1v1h-1zm49 80v1h-1v-1zm-70 10h-1v-1h1zm70 2h1v1h-1z",
    fill: "#000102"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-2v-1h1zm-36 0h-1v-1h1zm48 69v1h-1v-1z",
    fill: "#0d100f"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1zm57 57v1h-1v-1zM89 92h1v1h-1zm15 11v1h-1v-1z",
    fill: "#090a0a"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-2v-1h1zm5 0h1v1h-2v-1z",
    fill: "#040506"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h2v1h-2zM28 93v-1h1v1zm93 1v-1h1v1z",
    fill: "#0c0f0e"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23h1v1h-1zm26 69v1h-1v-1zm1 14v1h-1v-1zm-106 4v-1h1v1z",
    fill: "#0a0d0c"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M46 24h1v1h-2v-1zm5 1h-1v-1h1zm12-1v1h-1v-1z",
    fill: "#2d312f"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M111 24h1v1h-1zM15 98h-1v-1h1zm10 1h-1v-1h1zm-7 9h1v1h-1z",
    fill: "#010301"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26v-1h1v1zm6 0h-1v-1h1zm4 71h1v1h-1zm1 11h1v1h-1z",
    fill: "#2d2f2e"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M113 26h-1v-1h1zm-41 2v-1h1v1zm39 79h1v1h-1zm4 1v-1h1v1z",
    fill: "#1c1e1d"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28v1h-2v-1h1zm-59-1v-1h1v1zm50 1h-1v-1h1z",
    fill: "#030301"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1zm-19 1h1v1h-1zm9 1v-1h1v1zm20 1h-1v-1h1z",
    fill: "#161715"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M108 26v1h-1v-1zm-1 69v1h-1v-1zm12 0v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#252726"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1zm43 55v-1h1v1zm-9 13h-1v-1h1zm4-1v1h-1v-1z",
    fill: "#212322"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-3v-1zm61 2v-1h1v1z",
    fill: "#10100e"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42v-1h2v1h-1zm3-1h2v1h-2z",
    fill: "#dadada",
    fillOpacity: 0.027
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1zm1 0v-1h1v1zm38-1v1h-1v-1zm3 1v-1h1v1z",
    fill: "#ffff78"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1zm-43 1v-1h1v1zm6-1v1h-1v-1zm14 0v1h-1v-1z",
    fill: "#ffff80"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M112 43h-1v-1h1zm-81 0h1v1h-1zm4 0v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#ffff81"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52h-2v-1h2zm-4-1h1v1h-1zm5 0h1v1h-1z",
    fill: "#fff2b5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M37 53v-1h2v1h-1zm5 0h-2v-1h2z",
    fill: "#faeebd"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M45 59v-1h4v1h-1z",
    fill: "#aacad7",
    fillOpacity: 0.153
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h2v1zm-5-1h1v1h-1zm3 0v1h-1v-1z",
    fill: "#d0f6ff"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v-1h3v1zm4-1h1v1h-1z",
    fill: "#d4f4fc"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-2v-1h2zm-10 0v-1h1v1zm12 0h-1v-1h1z",
    fill: "#d0f3fc"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M122 64h-1v-1h1zm-2 17v-1h1v1zm-25 22v1h-1v-1zm20 9v-1h1v1z",
    fill: "#111"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v-1h2v1h-1zm-6-1h1v1h-1zm3 1h-1v-1h1z",
    fill: "#72bef9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h3v1zm5-1h1v1h-1z",
    fill: "#839d79"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90v1h-2v-1h1zm2 1v-1h1v1zm10 0v-1h1v1z",
    fill: "#898989",
    fillOpacity: 0.051
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h1v1h-1zm-3 2v1h-1v-1zm-12 2h-1v-1h1zm17 15v1h-1v-1z",
    fill: "#101110"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-2v-1h1zm-6 0v1h-1v-1zm9 1v-1h1v1z",
    fill: "#3e660f"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M102 96h1v1h-1zm20 1v1h-1v-1zm-13 12h1v1h-1zm7 1h-1v-1h1z",
    fill: "#393b3a"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M97 98v-1h1v1zm5 0v-1h1v1zm14 0h-1v-1h1zm-5 10v1h-1v-1z",
    fill: "#2a2c2b"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M70 103h1v1h-2v-1zm4 1h-2v-1h2z",
    fill: "#094230"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M111 112h-1v-1h2v1zm-4 0h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#101010"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90h1v1h-2v-1zm18-77v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14h-1v-1h2v1zM25 92v1h-1v-1z",
    fill: "#181a1a"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M98 15v1h-2v-1h1zm-32 0v-1h1v1z",
    fill: "#171b1a"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M94 15h2v1h-2zm-19 0h-1v-1h1z",
    fill: "#1a1e1d"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14v1h-1v-1zm33 66v-1h1v1zm0 31h1v1h-1z",
    fill: "#121212"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M91 15h-1v-1h2v1zm29 47v1h-1v-1z",
    fill: "#121312"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M94 14v1h-1v-1zm23 98h-1v-1h1zm4-1v1h-1v-1z",
    fill: "#141414"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M95 14v1h-1v-1zm25 59v-1h1v1zM91 95h1v1h-1z",
    fill: "#131513"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15h-1v-1h1zm-76 1v1h-1v-1zm98 39h1v1h-1z",
    fill: "#131412"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16v-1h1v1zm54 9h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#232727"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M49 16h-2v-1h2zm-14 8h-1v-1h1z",
    fill: "#303735"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16h-1v-1h2v1zm3-1h1v1h-1z",
    fill: "#303634"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1zm-1 10h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#2c3230"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h2v1h-1zm25-9h1v1h-1z",
    fill: "#1e2221"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M110 16v-1h1v1zm-75 9v1h-1v-1zm-22 85h-1v-1h1z",
    fill: "#0b0d0b"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v1h-2v-1h1zm-3 0v1h-1v-1z",
    fill: "#1b1f1c"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1zm4 9v-1h1v1zm2 0v-1h1v1z",
    fill: "#292d2c"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M95 17v-1h3v1z",
    fill: "#2c2f2e"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M107 17v-1h1v1zm2-1h1v1h-1zm-15 93v-1h1v1z",
    fill: "#2c2e2e"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M111 17h-1v-1h1zm-2 92v-1h1v1zm9 0v-1h1v1z",
    fill: "#2b2d2c"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M114 16h1v1h-1zm-47 5v-1h1v1zm24 72v-1h1v1z",
    fill: "#0b0c0b"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h1v1h-1zm61 3h-1v-1h1zm33 54v1h-1v-1z",
    fill: "#151616"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1zm80 4v-1h1v1zm-93 90v1h-1v-1z",
    fill: "#010102"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1zm40 1v-1h1v1zm44 82h-1v-1h1z",
    fill: "#050705"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1zm1 0h1v1h-1zM28 98h-1v-1h1z",
    fill: "#060805"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1zm2-1v1h-1v-1zm2 0h1v1h-1z",
    fill: "#080a07"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1zm27 78h1v1h-1zm-5 3h-1v-1h1z",
    fill: "#262827"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h-3v-1h3z",
    fill: "#1e1f1d"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M119 112h-2v-1h2zM73 19h-1v-1h1z",
    fill: "#151515"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1zM18 98h-1v-1h1zm81 8v1h-1v-1z",
    fill: "#030503"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M106 18h2v1h-2zM79 29v-1h1v1z",
    fill: "#0f100d"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M115 18v1h-1v-1zm-4 9v1h-1v-1zm-16 85h-1v-1h1z",
    fill: "#040403"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M116 18v1h-1v-1zM90 92h1v1h-1zm1 11h1v1h-1z",
    fill: "#0b0b0b"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1zm39 78h1v1h-1zm2 1v-1h1v1z",
    fill: "#333534"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1zm53 36v-1h1v1zm0 25h1v1h-1z",
    fill: "#111212"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M112 110v-1h2v1h-1zM82 20h1v1h-1z",
    fill: "#373938"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1zm23 75v-1h1v1zm5 15v-1h1v1z",
    fill: "#222423"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M114 20h1v1h-1zm-91 81v-1h1v1zm92 14h-1v-1h1z",
    fill: "#030304"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1zm2 0h1v1h-1zM16 98h1v1h-1z",
    fill: "#010203"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22h-1v-1h1zm8 71h1v1h-1zm-3 13v1h-1v-1z",
    fill: "#060908"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23h-2v-1h2zm16 88h-1v-1h1z",
    fill: "#080809"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1zm5 1v-1h1v1zm9 75h1v1h-1z",
    fill: "#060607"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-2v-1h1zm-3 1h-1v-1h1z",
    fill: "#0f1314"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1zm-6 80v1h-1v-1zm65 5h1v1h-1z",
    fill: "#090a0b"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M57 24v1h-3v-1h1z",
    fill: "#2c3332"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h2v1h-2zm-12 0h-1v-1h1z",
    fill: "#272b2a"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-2v-1h2zm-4 0v-1h1v1z",
    fill: "#212524"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26v-1h1v1zm96 60h-1v-1h1zm14 17v1h-1v-1z",
    fill: "#3f3f3f",
    fillOpacity: 0.016
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1zm-10 2v1h-1v-1zm57 2v1h-1v-1z",
    fill: "#0c0e0a"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M61 25v1h-3v-1z",
    fill: "#191d1a"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27h-1v-1h1zm4 0v-1h1v1zm9 0h1v1h-1z",
    fill: "#020201"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1zm34 19v1h-1v-1zm3 9v1h-1v-1z",
    fill: "#131414"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M96 27h-1v-1h1zm-19 0v1h-1v-1zm44 18v-1h1v1z",
    fill: "#151715"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1zm50-1h1v1h-1zm-6 1v1h-1v-1z",
    fill: "#040502"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M57 27v1h-3v-1h1z",
    fill: "#030501"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1zm-32 1v1h-1v-1zm75 20v-1h1v1z",
    fill: "#131411"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M105 29h-1v-1h2v1zm-14-1h1v1h-1z",
    fill: "#050402"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30v-1h3v1z",
    fill: "#0c0c09"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1zm2 0v1h-1v-1zm1 0h1v1h-1z",
    fill: "#e2e2c6",
    fillOpacity: 0.035
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h2v1h-1zm-1 0h-1v-1h1z",
    fill: "#f5f686",
    fillOpacity: 0.827
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v-1h2v1h-1zm-8 0v-1h1v1z",
    fill: "#ffff76"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1zm26-1h1v1h-1zm5 0h1v1h-1z",
    fill: "#ffff7a"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h-1v-1h2v1zm3 0h-1v-1h1z",
    fill: "#fcfd83"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1zm5 0h-1v-1h1zm5-1h1v1h-1z",
    fill: "#fdfe82"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h2v1zm-6-1v1h-1v-1z",
    fill: "#e0dc32"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51v1h-3v-1z",
    fill: "#feecae"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h1v1h-2v-1zm5 1h-1v-1h1z",
    fill: "#f9edbc"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1zm1 0h1v1h-1zm2 0h1v1h-1z",
    fill: "#f9ecb9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53v-1h3v1h-1z",
    fill: "#f4e4ab"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h2v1h-2zm3 0h1v1h-1z",
    fill: "#e9d090"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M46 55v1h-3v-1z",
    fill: "#c8ac74"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h2v1zm5-1v1h-1v-1z",
    fill: "#b29869"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1zm41 1v-1h1v1zm7 0v-1h1v1z",
    fill: "#d0f5ff"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-2v-1h2zm4 0h-1v-1h1z",
    fill: "#d7f5fe"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61v-1h3v1z",
    fill: "#ccf1fa"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h-1v-1h2v1zm-3-1h1v1h-1z",
    fill: "#cbf0fa"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M43 62h-2v-1h2zm69-1v-1h1v1z",
    fill: "#d0f2fd"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M119 62v-1h1v1zM22 94v-1h1v1zm-7 1h-1v-1h1z",
    fill: "#171919"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M123 66v1h-1v-1zm-13 19h1v1h-1zm7 0v1h-1v-1z",
    fill: "#633",
    fillOpacity: 0.02
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-2v-1zm2 0h1v1h-1z",
    fill: "#486d9d",
    fillOpacity: 0.082
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-3v-1z",
    fill: "#53adff"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v2h-1v-2zm2 0h1v1h-1z",
    fill: "#57abf6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M124 70h-1v-1h1zM52 83h1v1h-1zm61 33v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.047
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M45 72v-1h3v1h-1z",
    fill: "#5ca6ec"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M61 71v1h-3v-1h1z",
    fill: "#4f9fee"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v1h-3v-1h1z",
    fill: "#4383cd"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M48 72v1h-3v-1h1z",
    fill: "#4385d0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M58 72h3v1h-3z",
    fill: "#458bda"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M123 73h-1v-1h1zm-3 1h1v1h-1zm-11 25v-1h1v1z",
    fill: "#151615"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-3v-1z",
    fill: "#3467a2"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h3v1h-3z",
    fill: "#3468a5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1zm-20 7h-1v-1h1zm81 4h-1v-1h1z",
    fillOpacity: 0.008
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M36 78h1v1h-2v-1zm-3 1v-1h1v1z",
    fill: "#9eb998"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h2v1h-2zm-2 1v-1h1v1z",
    fill: "#849f7d"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M111 78h2v1h-2zm5 0v1h-1v-1z",
    fill: "#7d9d79"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M122 79h-1v-1h1zm-9 28v1h-1v-1zm-88 3h-1v-1h1z",
    fill: "#1d1f1e"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M44 80v-1h3v1z",
    fill: "#86a17e"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h2v1zm12 0h-1v-1h1z",
    fill: "#7e9873"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1zm1 0v-1h1v1zm4 0h-1v-1h1z",
    fill: "#7f9975"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-2v-1h2zm2-1v1h-1v-1z",
    fill: "#6b8161"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v-1h3v1z",
    fill: "#718966"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v1h-2v-1h1zm43 1v1h-1v-1z",
    fill: "#728a67"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M109 84v-1h3v1z",
    fill: "#4d5b44"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M44 91v-1h2v1h-1zm-17 0v-1h1v1z",
    fill: "#949494",
    fillOpacity: 0.047
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h-1v-1h2v1zm-10-1v1h-1v-1z",
    fill: "#416720"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h1v1h-2v-1zm-5 0h1v1h-1z",
    fill: "#3d6416"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M102 93h-1v-1h1zm18 2h-1v-1h1zm-92 14v1h-1v-1z",
    fill: "#101312"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h1v1h-1zm6 1v-1h1v1zm6-1h1v1h-1z",
    fill: "#3d660e"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v1h-3v-1z",
    fill: "#3d660f"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M114 98v1h-2v-1h1zm-98-3h-1v-1h1z",
    fill: "#161918"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1zm-3 2h1v1h-1zm10 9h-1v-1h1z",
    fill: "#080909"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M106 95h-1v-1h1zm9 0h-1v-1h1zm-92 11h1v1h-1z",
    fill: "#0e100f"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h1v1h-1zm19 3v1h-1v-1zm3 1v-1h1v1z",
    fill: "#191b1a"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M104 96h1v1h-1zm3 1v-1h1v1zm10 0h-1v-1h1z",
    fill: "#434544"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M113 98h-1v-1h1zm3 11h-1v-1h1zm5 0v-1h1v1z",
    fill: "#313332"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1zm-2 13h-1v-1h1zm89 3v-1h1v1z",
    fill: "#020304"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h2v1h-2zm5 1v-1h1v1z",
    fill: "#294d17"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106h-1v-1h2v1zm-7 0h-1v-1h1z",
    fill: "#5bf2df"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h3v1h-3z",
    fill: "#55f0dc"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1zm18 1v-1h1v1zm3-1v1h-1v-1z",
    fill: "#66f3e2"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1zm6-1h1v1h-1zm5 0h1v1h-1z",
    fill: "#66f3e3"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1zm4 1v-1h1v1zm5 0h-1v-1h1z",
    fill: "#66f2e2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110v1h-3v-1z",
    fill: "#65f0dc"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M108 115v-1h2v1h-1zm-18-5v1h-1v-1z",
    fill: "#020605"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M68 116h-1v-1h2v1zm9-1h1v1h-1z",
    fill: "#467466",
    fillOpacity: 0.353
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1zm66 39v-1h1v1z",
    fill: "#343434",
    fillOpacity: 0.133
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13h-1v-1h1zM38 115v1h-1v-1z",
    fill: "#5a5a5a",
    fillOpacity: 0.067
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h1v1h-1zM24 59h1v1h-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1zm64 11h1v1h-1z",
    fill: "#1c1d1c"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M112 13v1h-1v-1zM12 106h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.039
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14h1v1h-1zM12 95h1v1h-1z",
    fill: "#2f3434"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1zm12 10v-1h1v1z",
    fill: "#2a302f"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#252c2e"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1zm-24 9h-1v-1h1z",
    fill: "#191f1e"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1zm7 9v1h-1v-1z",
    fill: "#1a1e1e"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M64 14h1v1h-1zm9 1v-1h1v1z",
    fill: "#1a1d1d"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#171a19"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h-1v-1h2v1z",
    fill: "#141717"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14h1v1h-1zm-58 93h1v1h-1z",
    fill: "#0f1312"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14v1h-1v-1zm42 31v1h-1v-1z",
    fill: "#121513"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M80 15v-1h2v1h-1z",
    fill: "#111513"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15h-2v-1h2z",
    fill: "#121512"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15h1v1h-1zM8 95H7v-1h1z",
    fill: "#7f7f7f",
    fillOpacity: 0.031
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15v1h-1v-1zm7 75h1v1h-1z",
    fill: "#b2b2b2",
    fillOpacity: 0.039
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15v1h-2v-1h1z",
    fill: "#313836"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-2v-1z",
    fill: "#303936"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-2v-1h2z",
    fill: "#2c3431"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1zm-11 7v1h-1v-1z",
    fill: "#242a29"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1zm6 0v-1h1v1z",
    fill: "#252a2a"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1zm-18 8h1v1h-1z",
    fill: "#232827"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M82 15v1h-2v-1h1z",
    fill: "#212526"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M112 16h-1v-1h1zm-28 2v1h-1v-1z",
    fill: "#0b0c0a"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v-1h1v1zm53 11h1v1h-1z",
    fill: "#0c0d0b"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-2v-1h1z",
    fill: "#141713"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16v1h-1v-1zm12 10v-1h1v1z",
    fill: "#181c18"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1zm-28 93v-1h1v1z",
    fill: "#1b1d1a"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h1v1h-2v-1z",
    fill: "#1c1e1b"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1zm43 8v-1h1v1z",
    fill: "#1d201e"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1zm56 9h1v1h-1z",
    fill: "#1e201e"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1zm18 5h-1v-1h1z",
    fill: "#1d1f1d"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1zm3 0h-1v-1h1z",
    fill: "#1f2320"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1zm-3 7v1h-1v-1z",
    fill: "#222524"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1zM26 95v-1h1v1z",
    fill: "#3d4243"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1zm4 1v-1h1v1z",
    fill: "#2a2f2d"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1zm3 8v1h-1v-1z",
    fill: "#2b2f2e"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M99 16v1h-1v-1zm-22 1v1h-1v-1z",
    fill: "#323636"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M103 16h1v1h-1zm-1 92h1v1h-1z",
    fill: "#2e3030"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M109 17h-1v-1h1zm-13 91h1v1h-1z",
    fill: "#2b2c2d"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M114 16v1h-1v-1zm-40 6v1h-1v-1z",
    fill: "#070909"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17v1h-1v-1zm9 2v1h-1v-1z",
    fill: "#222",
    fillOpacity: 0.059
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17v1h-1v-1zm-5 11v-1h1v1z",
    fill: "#050604"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1zm45 3v1h-1v-1z",
    fill: "#090b09"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1zm24 11v-1h1v1z",
    fill: "#090a08"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1zm19 79v-1h1v1z",
    fill: "#535554"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h-1v-1h1zm7 8h1v1h-1z",
    fill: "#171816"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1zm36 34v1h-1v-1z",
    fill: "#1a1a1a"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M108 18h-1v-1h1zm-8 90v1h-1v-1z",
    fill: "#292b29"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M110 18h-1v-1h1zm-33 2h-1v-1h1z",
    fill: "#2c2e2c"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M112 17v1h-1v-1zm-44 3v-1h1v1z",
    fill: "#313230"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18h1v1h-1zm-9 79h1v1h-1z",
    fill: "#080a08"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1zm33 77h1v1h-1z",
    fill: "#0e100e"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1zm40 76h-1v-1h1z",
    fill: "#080908"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M81 19v-1h1v1zm12-1v1h-1v-1z",
    fill: "#0a0a07"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M108 18h2v1h-2z",
    fill: "#0e100c"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#050404"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1zm58 77v-1h1v1z",
    fill: "#444645"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1zm60 77v1h-1v-1z",
    fill: "#3d3f3e"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1zm48 77v1h-1v-1z",
    fill: "#424443"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#191a19"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#2e302e"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1zm-42 5h1v1h-1z",
    fill: "#0d0f0c"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1zM19 94v1h-1v-1z",
    fill: "#252725"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1zm21 75v1h-1v-1z",
    fill: "#232524"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1zm-64 91h-1v-1h1z",
    fill: "#1b1e1c"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h-1v-1h1zm33 54h-1v-1h1z",
    fill: "#181919"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19v1h-1v-1zm10 7h1v1h-1z",
    fill: "#333433"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M104 19h1v1h-1zm9 96v-1h1v1z",
    fill: "#030305"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M105 19h1v1h-1zm-75 92h1v1h-1z",
    fill: "#040203"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20v1h-1v-1zm59 12v-1h1v1z",
    fill: "#2a2a2a",
    fillOpacity: 0.024
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1zm58 95h-1v-1h1z",
    fill: "#0b0b0b",
    fillOpacity: 0.09
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1zM32 93v1h-1v-1z",
    fill: "#050606"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1zm56 92h-1v-1h1z",
    fill: "#0a0a0a"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1zm51 26v-1h1v1z",
    fill: "#141514"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21h-1v-1h1zm44 35h1v1h-1z",
    fill: "#1f201f"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1zm44 48v1h-1v-1z",
    fill: "#212321"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h-1v-1h1zm18 1h-1v-1h1z",
    fill: "#000302"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M105 21h-1v-1h1zm-15 82h-1v-1h1z",
    fill: "#010204"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M117 21h-1v-1h1zm-5 64v1h-1v-1z",
    fill: "#333",
    fillOpacity: 0.039
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v-1h1v1zm1 59h1v1h-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.035
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1zm-17 85h1v1h-1z",
    fill: "#030604"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v-1h1v1zm-6 83v-1h1v1z",
    fill: "#040606"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1zm34 1v-1h1v1z",
    fill: "#0e1213"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1zm33 1h1v1h-1z",
    fill: "#0d1112"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h-1v-1h2v1z",
    fill: "#0c0f0f"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-2v-1h2z",
    fill: "#080b0b"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1zm29 3h1v1h-1z",
    fill: "#899190"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1zm40 74v-1h1v1z",
    fill: "#2d3332"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1zm4 0v1h-1v-1z",
    fill: "#2c3231"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#1b2020"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h2v1h-1z",
    fill: "#161a1b"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M88 24h-1v-1h2v1z",
    fill: "#0e1211"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25v-1h1v1zm73 1h-1v-1h1z",
    fill: "#2a2e2c"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h1v1h-1zm21 1h1v1h-1z",
    fill: "#121411"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1zm1 0v-1h1v1z",
    fill: "#272c28"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v1h-2v-1h1z",
    fill: "#2d312e"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1zm11 0v1h-1v-1z",
    fill: "#2c312f"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1zm25 2v-1h1v1z",
    fill: "#2b302e"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25v-1h2v1h-1z",
    fill: "#282c2d"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#222625"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M102 24v1h-1v-1zm19 42h-1v-1h1z",
    fill: "#1c1d1d"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25v1h-1v-1zm65 79h-1v-1h1z",
    fill: "#0c0c0c"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1zm13 3v-1h1v1z",
    fill: "#0e0e0c"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1zm4 1h-1v-1h1z",
    fill: "#10120f"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1zm-25 82v1h-1v-1z",
    fill: "#11120f"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1zm32 2v1h-1v-1z",
    fill: "#121310"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-2v-1h2z",
    fill: "#141613"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1zm38 1h1v1h-1z",
    fill: "#151714"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h2v1z",
    fill: "#161a17"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-2v-1h1z",
    fill: "#2b2f30"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1zm-16 84h-1v-1h1z",
    fill: "#000200"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1zm43 1h1v1h-1z",
    fill: "#0a0a09"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1zm32 66h-1v-1h1z",
    fill: "#141513"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M103 27v-1h1v1zm2-1h1v1h-1z",
    fill: "#212320"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1zm89 45v1h-1v-1z",
    fill: "#0e0f0d"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1zm74 3v-1h1v1z",
    fill: "#060603"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1zm4-1h1v1h-1z",
    fill: "#020400"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1zm47 2v-1h1v1z",
    fill: "#030401"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1zM24 99h-1v-1h1z",
    fill: "#020300"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1zm20 1v1h-1v-1z",
    fill: "#0b0c09"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28h-1v-1h1zm2 0v-1h1v1z",
    fill: "#0b0b09"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29v-1h1v1zm95 51v-1h1v1z",
    fill: "#252521",
    fillOpacity: 0.212
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h-2v-1h2z",
    fill: "#22221f",
    fillOpacity: 0.38
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1zm7 0v1h-1v-1z",
    fill: "#12120f"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-2v-1h2z",
    fill: "#121210"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h2v1h-1z",
    fill: "#0f0f0d"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1zm14 1h-1v-1h1z",
    fill: "#0c0d0a"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1zm8 0h-1v-1h1z",
    fill: "#0a0c08"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M108 29v1h-2v-1h1z",
    fill: "#070704"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1zM51 75v1h-1v-1z",
    fillOpacity: 0.035
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M115 31h-1v-1h1zm9 85h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.012
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1zM39 58h-1v-1h1z",
    fill: "#242424",
    fillOpacity: 0.055
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31v1h-1v-1zm-2 85h-1v-1h1z",
    fill: "#141414",
    fillOpacity: 0.098
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1zM23 51v1h-1v-1z",
    fill: "#ffffdf",
    fillOpacity: 0.031
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h-2v-1h2z",
    fill: "#dadab6",
    fillOpacity: 0.027
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1zm5 1h-1v-1h1z",
    fill: "#ccf",
    fillOpacity: 0.02
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1zm6 0v1h-1v-1z",
    fill: "#efef96",
    fillOpacity: 0.384
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-2v-1h1z",
    fill: "#f6f684",
    fillOpacity: 0.843
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-2v-1h1z",
    fill: "#f4f684",
    fillOpacity: 0.82
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1zm1 1v1h-1v-1z",
    fill: "#ffff74"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M122 43v-1h1v1zm0 17h1v1h-1z",
    fill: "#3c3c3c",
    fillOpacity: 0.067
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1zm3 0h-1v-1h1z",
    fill: "#ffff82"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M59 43v1h-2v-1h1z",
    fill: "#fdfe6a"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#fdfd6d"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M105 44h-1v-1h2v1z",
    fill: "#fafb6a"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1zm10 1v-1h1v1z",
    fill: "#fdfe81"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h2v1h-1z",
    fill: "#fefe82"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h2v1h-1z",
    fill: "#fbfd69"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#fcfd70"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1zm3 0h-1v-1h1z",
    fill: "#fcfd6f"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M108 44h1v1h-1zm8 0v1h-1v-1z",
    fill: "#fbfb96"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M41 45v1h-2v-1h1z",
    fill: "#f8f86e"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45h2v1h-2z",
    fill: "#f7f96e"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h2v1h-2z",
    fill: "#f7f86f"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M60 46v-1h2v1h-1z",
    fill: "#f7f860"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M109 46h-1v-1h1zm4 0v-1h1v1z",
    fill: "#f8fa88"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h-1v-1h2v1z",
    fill: "#f1ef55"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h2v1h-1z",
    fill: "#f3f250"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46h1v1h-1zm1 17v-1h1v1z",
    fill: "#121213"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-2v-1z",
    fill: "#e5e43f"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-2v-1z",
    fill: "#d0bc12"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1zm2 0v-1h1v1z",
    fill: "#c2b313"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h2v1h-2z",
    fill: "#bfb412"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1zm3 1v-1h1v1z",
    fill: "#d4c821"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-2v-1z",
    fill: "#d4c923"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#cac42b"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1zm3 26v1h-1v-1z",
    fillOpacity: 0.024
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-2v-1z",
    fill: "#e8d19b",
    fillOpacity: 0.573
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M47 50h2v1h-2z",
    fill: "#e9d199",
    fillOpacity: 0.51
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1zm9 1h-1v-1h1z",
    fill: "#fff1b5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1zm5 0v-1h1v1z",
    fill: "#fff2b4"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#fff1b4"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M105 52h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#fbecb0"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M110 52h-2v-1h2z",
    fill: "#fbecaf"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h2v1h-1z",
    fill: "#faeebc"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1zm2 1v-1h1v1z",
    fill: "#faeebb"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M99 52v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#f7e6ae"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M108 52h2v1h-2z",
    fill: "#f3e4aa"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1zm3-1v1h-1v-1z",
    fill: "#f2e1a8"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1zm6 0v1h-1v-1z",
    fill: "#f5e3ac"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1zm8 0v-1h1v1z",
    fill: "#f5e4ad"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1zm4 1v-1h1v1z",
    fill: "#f6e4af"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54v-1h2v1h-1z",
    fill: "#f5e3af"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h2v1z",
    fill: "#f2dda0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1zm3 0h-1v-1h1z",
    fill: "#f4dca0"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55v-1h2v1h-1z",
    fill: "#e5cd90"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M67 54h2v1h-2z",
    fill: "#ecd395"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h-1v-1h2v1z",
    fill: "#efd69e"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M36 55h1v1h-2v-1z",
    fill: "#c4a572"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#caad76"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h1v1h-2v-1z",
    fill: "#d8b97a"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h2v1h-1z",
    fill: "#d9ba7b"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55v1h-1v-1zm1 0h1v1h-1z",
    fill: "#e0c687"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55h1v1h-1zm3 0v1h-1v-1z",
    fill: "#e1c788"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1zm8 0v1h-1v-1z",
    fill: "#b29768"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1zm7 1v-1h1v1z",
    fill: "#ad976c"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1zm14-1v1h-1v-1z",
    fill: "#b39b6b"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M101 56h1v1h-2v-1z",
    fill: "#c5a66d"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1zm4 0v1h-1v-1z",
    fill: "#998562"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h2v1h-2z",
    fill: "#aac8d4",
    fillOpacity: 0.165
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M119 59v-1h1v1zM53 76v-1h1v1z",
    fillOpacity: 0.086
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h2v1z",
    fill: "#c4e6f4",
    fillOpacity: 0.988
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-2v-1z",
    fill: "#c1e3ef",
    fillOpacity: 0.984
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1zm41 0h1v1h-1z",
    fill: "#cff4ff"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1zm46 0v1h-1v-1z",
    fill: "#cff5ff"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1zm4 1h-1v-1h1z",
    fill: "#d6f4fd"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1zm-16 0h1v1h-1z",
    fill: "#d0f2fb"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1zm47 2h-1v-1h1z",
    fill: "#cef0fa"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1zm3 1h-1v-1h1z",
    fill: "#cbf1fd"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1zm-9 2v-1h1v1z",
    fill: "#c7edf9"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1zm-42 2v-1h1v1z",
    fill: "#c5eaf3"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61v-1h2v1h-1z",
    fill: "#cff3fe"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M114 60h1v1h-1zm-70 1h1v1h-1z",
    fill: "#d0f1fc"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1zm49 1h-1v-1h1z",
    fill: "#cff1fc"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1zm45 1h-1v-1h1z",
    fill: "#cff1fb"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1zm57 1v-1h1v1z",
    fill: "#cef0f9"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1zm10 1v-1h1v1z",
    fill: "#d1f2fc"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1zm9 0h1v1h-1z",
    fill: "#d0f2fc"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1zm46 0v1h-1v-1z",
    fill: "#cef2fa"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1zm5 0v-1h1v1z",
    fill: "#c7eefb"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-2v-1z",
    fill: "#c6edfa"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h-2v-1h2z",
    fill: "#c7edfb"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1zm26 1h-1v-1h1z",
    fill: "#cdeff7"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62h-2v-1h2z",
    fill: "#cdedf6"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1zm47 0v-1h1v1z",
    fill: "#bbe2f1"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1zm2 1v-1h1v1z",
    fill: "#b9e1ef"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h2v1h-1z",
    fill: "#b9e4f0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1zm2 0h1v1h-1z",
    fill: "#bce5f2"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1zm59 1v1h-1v-1z",
    fill: "#bee6f4"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1zm3 1v-1h1v1z",
    fill: "#bce7f7"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-2v-1h1z",
    fill: "#bde8f7"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1zm39 2h-1v-1h1z",
    fill: "#bae4f2"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-2v-1h1z",
    fill: "#d2f0f8"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h-1v-1h1zm1 0v-1h1v1z",
    fill: "#dbf6f9"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h1v1h-1zm-16 41h1v1h-1z",
    fill: "#0a0b0b"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M38 63h2v1h-2z",
    fill: "#9ccbe1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1zm2 1v-1h1v1z",
    fill: "#9ecde2"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1zm3 0v-1h1v1z",
    fill: "#aad8ea"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64h-2v-1h2z",
    fill: "#aad9ea"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1zm17 0v-1h1v1z",
    fill: "#bae4f3"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M100 64h-2v-1h2z",
    fill: "#b7e1f1"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1zm2-1h1v1h-1z",
    fill: "#6b97bd"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v1h-2v-1h1z",
    fill: "#72a1c6"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65h-1v-1h2v1z",
    fill: "#acd6e7"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M121 64v1h-1v-1zM91 97h1v1h-1z",
    fill: "#151617"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-2v-1z",
    fill: "#648bad"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v-1h2v1h-1z",
    fill: "#84aecb"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1zm2 0h1v1h-1z",
    fill: "#4f6f9f",
    fillOpacity: 0.063
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1zm7 0v1h-1v-1z",
    fill: "#4c72a5",
    fillOpacity: 0.078
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h2v1h-1z",
    fill: "#4573a2",
    fillOpacity: 0.086
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67v1h-2v-1h1z",
    fill: "#224a86"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M61 69h-2v-1h2z",
    fill: "#52aefe"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-2v-1h2z",
    fill: "#51abfc"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1zm5 0h-1v-1h1z",
    fill: "#4da2f3"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68v1h-2v-1h1z",
    fill: "#4da3f3"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M101 69h-2v-1h2z",
    fill: "#4aa2f1"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-2v-1h1z",
    fill: "#68b8fb"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69h2v1h-2z",
    fill: "#67b7fa"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1zm2 0h1v1h-1z",
    fill: "#67b8fa"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h1v1h-2v-1z",
    fill: "#64b6fb"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h2v1h-2z",
    fill: "#54aaf5"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1zm48-1v1h-1v-1z",
    fill: "#54abf7"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-2v-1z",
    fill: "#54aaf8"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-2v-1h2z",
    fill: "#57abf7"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M122 69v1h-1v-1zm-17 27v-1h1v1z",
    fill: "#202221"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1zm8-1v1h-1v-1z",
    fill: "#70bcf7"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-2v-1h1z",
    fill: "#56aaf5"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v1h-2v-1h1z",
    fill: "#60a8ed"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h2v1h-2z",
    fill: "#5da6ed"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1zm2 0v-1h1v1z",
    fill: "#5ca7ed"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1zm6-1h1v1h-1z",
    fill: "#4f9fec"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72v-1h1v1zm2 0v-1h1v1z",
    fill: "#81b9ec"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M20 73h-1v-1h1zm31 10h1v1h-1z",
    fill: "#242424",
    fillOpacity: 0.027
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1zm1-1h1v1h-1z",
    fill: "#4285d0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h2v1h-2z",
    fill: "#4387d2"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#458bdb"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#5592d8"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M34 73h2v1h-2z",
    fill: "#31629a"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-2v-1h2z",
    fill: "#3671b8"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73h1v1h-2v-1z",
    fill: "#3971b9"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73h2v1h-2z",
    fill: "#3b7dc9"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M116 73h1v1h-2v-1z",
    fill: "#4087d4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M122 74h-1v-1h1zM12 94h1v1h-1z",
    fill: "#191a1a"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h2v1z",
    fill: "#2a5483"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h2v1z",
    fill: "#2b598d"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M104 75h-1v-1h2v1z",
    fill: "#3165a6"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75h-1v-1h2v1z",
    fill: "#3269ab"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1zm-1 41h-1v-1h1z",
    fill: "red",
    fillOpacity: 0.004
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#243a47"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1zm1 0v-1h1v1z",
    fill: "#233a4a"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M81 75v1h-2v-1h1z",
    fill: "#233b4f"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75h1v1h-2v-1z",
    fill: "#244663"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1zm3-1h1v1h-1z",
    fill: "#6d8971",
    fillOpacity: 0.82
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-2v-1z",
    fill: "#708b72"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-2v-1h2z",
    fill: "#93b091"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-2v-1h1z",
    fill: "#92af90"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h1v1h-2v-1z",
    fill: "#8cab8b"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v1h-2v-1h1z",
    fill: "#8aa888"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1zm19-1v1h-1v-1z",
    fill: "#86a38a"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M101 77h1v1h-2v-1z",
    fill: "#7f9e81"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M108 77v1h-2v-1h1z",
    fill: "#7e9b80"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M44 78h1v1h-2v-1z",
    fill: "#98b593"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1zm1 1v-1h1v1z",
    fill: "#9ab795"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v1h-2v-1h1z",
    fill: "#9bb695"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1zm3 0v1h-1v-1z",
    fill: "#84a07d"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79v-1h1v1zm2-1h1v1h-1z",
    fill: "#839f7e"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M100 78h2v1h-2z",
    fill: "#829e7d"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79h-1v-1h1zm6 0h-1v-1h1z",
    fill: "#7f9d7a"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M39 80h-2v-1h2z",
    fill: "#849e7a"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-2v-1h1z",
    fill: "#839d7a"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1zm6 0v-1h1v1z",
    fill: "#86a07d"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-2v-1h1z",
    fill: "#87a17e"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79h1v1h-2v-1z",
    fill: "#7f9974"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1zm1 1v-1h1v1z",
    fill: "#7e9974"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1zm1 0h1v1h-1z",
    fill: "#859f81"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80h-1v-1h2v1z",
    fill: "#a0ba9f"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M102 79h1v1h-1zm2 1v-1h1v1z",
    fill: "#a8bea6"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M110 79v1h-1v-1zm5 1h-1v-1h1z",
    fill: "#a1b8a0"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h2v1z",
    fill: "#6e8463"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h2v1h-2z",
    fill: "#738c68"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1zm46 1v1h-1v-1z",
    fill: "#748d69"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M121 80h1v1h-1zm-16 32h-1v-1h1z",
    fill: "#0f0e0e"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M122 80h1v1h-1zm0 1v1h-1v-1z",
    fill: "#121111"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1zm73 2v1h-1v-1z",
    fill: "#4b5841"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1zm74 2v1h-1v-1z",
    fill: "#4c5943"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-2v-1z",
    fill: "#516147"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81v1h-2v-1h1z",
    fill: "#56684b"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h2v1z",
    fill: "#5f7455"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h2v1h-1z",
    fill: "#607555"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h2v1h-2z",
    fill: "#617958"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M97 81h1v1h-1zm2 1v-1h1v1z",
    fill: "#728865"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81h2v1h-2z",
    fill: "#738866"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M120 82h-1v-1h1zm-17 29h1v1h-1z",
    fill: "#0f0f0f"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M65 83h-2v-1h2z",
    fill: "#4a5b41"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-2v-1z",
    fill: "#54654d"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#586a50"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M101 82h1v1h-2v-1z",
    fill: "#627557"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83h-1v-1h2v1z",
    fill: "#627758"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1zm36 0v1h-1v-1z",
    fill: "#3f4236",
    fillOpacity: 0.314
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M115 85v1h-2v-1h1z",
    fill: "#443",
    fillOpacity: 0.059
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h2v1h-2z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#586e44",
    fillOpacity: 0.725
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M119 92h-1v-1h1zm4 19h-1v-1h1z",
    fill: "#2c2c2c"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-2v-1z",
    fill: "#3c6315"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1zm3 0h1v1h-1z",
    fill: "#3e6318"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#3f6419"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92h1v1h-1zm15 20v-1h1v1z",
    fill: "#0f1010"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h1v1h-1zm91 19v1h-1v-1z",
    fill: "#070808"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1zm13-1h1v1h-1z",
    fill: "#517838"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94h-1v-1h2v1z",
    fill: "#3e670f"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1zm1-1h1v1h-1z",
    fill: "#49701d"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97v-1h1v1zm5-1h1v1h-1z",
    fill: "#575958"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96h2v1h-2z",
    fill: "#606261"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M4 98H3v-1h1zm118 6h1v1h-1z",
    fill: "#363636",
    fillOpacity: 0.055
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1zm34 0v1h-1v-1z",
    fill: "#3e6613"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h2v1h-1z",
    fill: "#436a17"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v-1h1v1zm15-1v1h-1v-1z",
    fill: "#353736"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M92 99v-1h2v1h-1z",
    fill: "#050506"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v1h-1v-1zm-69 7h1v1h-1z",
    fill: "#050707"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v-1h1v1zm79 1h1v1h-1z",
    fill: "#000301"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1zm4 0v1h-1v-1z",
    fill: "#4d6e34"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1zm1 0h1v1h-1z",
    fill: "#4d6e36"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1zm2 0h1v1h-1z",
    fill: "#274b15"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1zm11 0h1v1h-1z",
    fill: "#205135"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#204f34"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-2v-1h1z",
    fill: "#2b5b3a"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M122 103h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#020503"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M44 104h-2v-1h2z",
    fill: "#0a5b47"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h2v1h-1z",
    fill: "#074b37"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#094431"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h2v1h-2z",
    fill: "#30bfa7"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M25 106h-1v-1h1zm72 5v-1h1v1z",
    fill: "#030405"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105h1v1h-1zm70 3h-1v-1h1z",
    fill: "#060806"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106h-1v-1h1zm7 0v-1h1v1z",
    fill: "#5ef1df"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105v1h-2v-1h1z",
    fill: "#5ff1df"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#5ef1e0"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106h-1v-1h2v1z",
    fill: "#5df1e0"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-2v-1h1z",
    fill: "#5df2e0"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h2v1z",
    fill: "#5bf1de"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1zm2 1v-1h1v1z",
    fill: "#5af1de"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M63 106h-1v-1h2v1z",
    fill: "#5af2df"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h-2v-1h2z",
    fill: "#57f2de"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M67 106h-1v-1h2v1z",
    fill: "#58f1dd"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1zm5 0v1h-1v-1z",
    fill: "#54f0db"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M19 107v-1h1v1zm83-1h1v1h-1z",
    fill: "#080a0a"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M27 106h1v1h-1zm-3 3v1h-1v-1z",
    fill: "#1f2022"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1zm8-1v1h-1v-1z",
    fill: "#6cf2e3"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1zm11 2v-1h1v1z",
    fill: "#70f4e5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1zm10 0v-1h1v1z",
    fill: "#65f2e2"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107h-1v-1h2v1z",
    fill: "#65f3e3"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M79 106h2v1h-2z",
    fill: "#65f4e3"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M82 107h-1v-1h2v1z",
    fill: "#64f4e3"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M87 107v-1h1v1zm-20 3v-1h1v1z",
    fill: "#7af3e4"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1zm25 1v-1h1v1z",
    fill: "#76f7e7"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1zm17 2v1h-1v-1z",
    fill: "#7bf5e6"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1zm-16 1v1h-1v-1z",
    fill: "#75f3e3"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1zm5 1h1v1h-1z",
    fill: "#78f5e5"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h2v1h-2z",
    fill: "#6ff6e7"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h2v1h-2z",
    fill: "#6cf4e6"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M63 108v1h-1v-1zm5 0v1h-1v-1z",
    fill: "#7bf3e2"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h1v1h-2v-1z",
    fill: "#82f3e5"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1zm1 1v-1h1v1z",
    fill: "#76f7e8"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M21 110v-1h2v1h-1z",
    fill: "#121315"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M55 110v-1h2v1h-1z",
    fill: "#6ef1e1"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109v1h-1v-1zm5 0v1h-1v-1z",
    fill: "#4d4e50"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M93 110v-1h2v1h-1z",
    fill: "#58595c"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1zm27-1v1h-1v-1z",
    fill: "#64efdc"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v1h-1zm16 1h-1v-1h1z",
    fill: "#63eeda"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1zm6 1h-1v-1h1z",
    fill: "#66eddb"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h-1v-1h1zm9 0v-1h1v1z",
    fill: "#64efdd"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M69 111h-1v-1h1zm5 0h-1v-1h1z",
    fill: "#65f0dd"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1zm7-1v1h-1v-1z",
    fill: "#65f0e0"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M105 110v1h-1v-1zm1 0h1v1h-1z",
    fill: "#232424"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M116 111h-1v-1h1zm3 0v-1h1v1z",
    fill: "#252625"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M42 112h-2v-1h2z",
    fill: "#50e6cf"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M72 112h-1v-1h2v1z",
    fill: "#71ead6"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112h-2v-1h2z",
    fill: "#5cecd9"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M89 112v-1h1v2h-1z",
    fill: "#010000"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M55 112h1v1h-1zm4 1h-1v-1h1z",
    fill: "#4ad4bb"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M20 113v1h-1v-1zm91 3h1v1h-1z",
    fill: "#55552a",
    fillOpacity: 0.024
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114h-2v-1h2z",
    fill: "#31bca2"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114h1v1h-2v-1z",
    fill: "#2f8f7b"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M71 114h1v1h-2v-1z",
    fill: "#2d8f79"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M48 116h-2v-1h2z",
    fill: "#516e62",
    fillOpacity: 0.173
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h-1v-1h1zm7-1v1h-1v-1z",
    fill: "#457665",
    fillOpacity: 0.345
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116v-1h1v1zm7 0v-1h1v1z",
    fill: "#447466",
    fillOpacity: 0.353
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M66 115h1v1h-1zm9 1h-1v-1h1z",
    fill: "#467463",
    fillOpacity: 0.353
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v1h-1v-1z",
    fill: "#b0b09c",
    fillOpacity: 0.051
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h1v1h-1z",
    fill: "#94948a",
    fillOpacity: 0.094
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13v-1h1v1z",
    fill: "#909090",
    fillOpacity: 0.09
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12h1v1h-1z",
    fill: "#969696",
    fillOpacity: 0.086
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-1v-1h1z",
    fill: "#747474",
    fillOpacity: 0.094
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1z",
    fill: "#93a193",
    fillOpacity: 0.075
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1z",
    fill: "#626b62",
    fillOpacity: 0.102
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1z",
    fill: "#323634",
    fillOpacity: 0.459
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h1v1z",
    fill: "#363632",
    fillOpacity: 0.459
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M38 13v-1h1v1z",
    fill: "#333330",
    fillOpacity: 0.412
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#333530",
    fillOpacity: 0.392
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#2f312f",
    fillOpacity: 0.38
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1z",
    fill: "#2f322f",
    fillOpacity: 0.357
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12h1v1h-1z",
    fill: "#323232",
    fillOpacity: 0.337
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1z",
    fill: "#2e2e2e",
    fillOpacity: 0.325
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.31
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1z",
    fill: "#353932",
    fillOpacity: 0.298
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1z",
    fill: "#343430",
    fillOpacity: 0.267
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13h-1v-1h1z",
    fill: "#2e332e",
    fillOpacity: 0.235
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M49 13h-1v-1h1z",
    fill: "#30302b",
    fillOpacity: 0.227
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h1v1h-1z",
    fill: "#2d322d",
    fillOpacity: 0.22
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1z",
    fill: "#2f332f",
    fillOpacity: 0.212
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1z",
    fill: "#31312c",
    fillOpacity: 0.204
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12v1h-1v-1z",
    fill: "#33332d",
    fillOpacity: 0.196
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1z",
    fill: "#363630",
    fillOpacity: 0.184
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#352f2f",
    fillOpacity: 0.169
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1z",
    fill: "#343434",
    fillOpacity: 0.153
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1z",
    fill: "#393939",
    fillOpacity: 0.122
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#3d3d34",
    fillOpacity: 0.114
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#3f3f3f",
    fillOpacity: 0.11
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#444",
    fillOpacity: 0.102
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#47473d",
    fillOpacity: 0.098
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1z",
    fill: "#4d4d4d",
    fillOpacity: 0.09
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1z",
    fill: "#555548",
    fillOpacity: 0.082
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.059
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1z",
    fill: "#6a6a6a",
    fillOpacity: 0.047
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#717171",
    fillOpacity: 0.035
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1z",
    fill: "#916d6d",
    fillOpacity: 0.027
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.024
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13v1h-1v-1z",
    fill: "#525952",
    fillOpacity: 0.145
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14h-1v-1h1z",
    fill: "#1e201c",
    fillOpacity: 0.808
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13h1v1h-1z",
    fill: "#1d1e1c",
    fillOpacity: 0.914
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13h1v1h-1z",
    fill: "#1d1d1a",
    fillOpacity: 0.906
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h-1v-1h1z",
    fill: "#20211d",
    fillOpacity: 0.902
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h1v1z",
    fill: "#1b1b1a",
    fillOpacity: 0.91
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h1v1h-1z",
    fill: "#1e1d1c",
    fillOpacity: 0.886
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1z",
    fill: "#21201f",
    fillOpacity: 0.886
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1z",
    fill: "#181c1a"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1z",
    fill: "#191d1b"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1z",
    fill: "#161a18"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v1h-1v-1z",
    fill: "#262928"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13h1v1h-1z",
    fill: "#585d5c"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h-1v-1h1z",
    fill: "#2a302e"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-1h1v1z",
    fill: "#4f5553"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h1v1h-1z",
    fill: "#2e3332"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14h-1v-1h1z",
    fill: "#151a17"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1z",
    fill: "#151a18",
    fillOpacity: 0.996
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1z",
    fill: "#161a18",
    fillOpacity: 0.992
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v1h-1v-1z",
    fill: "#161a18",
    fillOpacity: 0.988
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h-1v-1h1z",
    fill: "#181a19",
    fillOpacity: 0.98
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1z",
    fill: "#181a19",
    fillOpacity: 0.973
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1z",
    fill: "#171918",
    fillOpacity: 0.965
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#181918",
    fillOpacity: 0.949
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#181b19",
    fillOpacity: 0.937
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1z",
    fill: "#171918",
    fillOpacity: 0.933
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1z",
    fill: "#191c1b",
    fillOpacity: 0.925
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#191b1a",
    fillOpacity: 0.918
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#181b19",
    fillOpacity: 0.914
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1z",
    fill: "#191c1a",
    fillOpacity: 0.906
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13v1h-1v-1z",
    fill: "#1a1d1a",
    fillOpacity: 0.894
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13v1h-1v-1z",
    fill: "#1a1b1a",
    fillOpacity: 0.878
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v-1h1v1z",
    fill: "#1a1b1a",
    fillOpacity: 0.867
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1z",
    fill: "#1a1c1a",
    fillOpacity: 0.855
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1z",
    fill: "#191b1a",
    fillOpacity: 0.831
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#1c1d1c",
    fillOpacity: 0.82
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v-1h1v1z",
    fill: "#1b1d1b",
    fillOpacity: 0.808
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1z",
    fill: "#1c1e1a",
    fillOpacity: 0.796
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1z",
    fill: "#1d1f1a",
    fillOpacity: 0.784
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#1d1f1b",
    fillOpacity: 0.769
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1z",
    fill: "#1d1e1a",
    fillOpacity: 0.753
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M75 13v1h-1v-1z",
    fill: "#1d1f1d",
    fillOpacity: 0.741
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14v-1h1v1z",
    fill: "#1f2121",
    fillOpacity: 0.725
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M76 14v-1h1v1z",
    fill: "#202220",
    fillOpacity: 0.702
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M78 13v1h-1v-1z",
    fill: "#202120",
    fillOpacity: 0.682
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14h-1v-1h1z",
    fill: "#1f211e",
    fillOpacity: 0.663
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v-1h1v1z",
    fill: "#1e221e",
    fillOpacity: 0.647
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M81 13v1h-1v-1z",
    fill: "#1f211f",
    fillOpacity: 0.631
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14v-1h1v1z",
    fill: "#1f201f",
    fillOpacity: 0.608
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h1v1h-1z",
    fill: "#1f2020",
    fillOpacity: 0.576
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M84 13v1h-1v-1z",
    fill: "#1e2020",
    fillOpacity: 0.553
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M85 14h-1v-1h1z",
    fill: "#212321",
    fillOpacity: 0.537
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M85 13h1v1h-1z",
    fill: "#222424",
    fillOpacity: 0.522
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14v-1h1v1z",
    fill: "#222",
    fillOpacity: 0.494
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h1v1h-1z",
    fill: "#232321",
    fillOpacity: 0.475
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14h-1v-1h1z",
    fill: "#252525",
    fillOpacity: 0.459
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14v-1h1v1z",
    fill: "#262624",
    fillOpacity: 0.439
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v-1h1v1z",
    fill: "#252523",
    fillOpacity: 0.424
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M91 14v-1h1v1z",
    fill: "#272725",
    fillOpacity: 0.404
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M93 13v1h-1v-1z",
    fill: "#272724",
    fillOpacity: 0.38
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M93 14v-1h1v1z",
    fill: "#262626",
    fillOpacity: 0.365
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M94 13h1v1h-1z",
    fill: "#262926",
    fillOpacity: 0.341
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13v1h-1v-1z",
    fill: "#252825",
    fillOpacity: 0.318
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13h1v1h-1z",
    fill: "#272a27",
    fillOpacity: 0.306
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M98 13v1h-1v-1z",
    fill: "#2c2c2c",
    fillOpacity: 0.294
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M98 14v-1h1v1z",
    fill: "#2f2f2c",
    fillOpacity: 0.294
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M100 14h-1v-1h1z",
    fill: "#31312e",
    fillOpacity: 0.282
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M101 14h-1v-1h1z",
    fill: "#30302c",
    fillOpacity: 0.271
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M102 14h-1v-1h1z",
    fill: "#303030",
    fillOpacity: 0.247
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M103 14h-1v-1h1z",
    fill: "#303430",
    fillOpacity: 0.227
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M104 14h-1v-1h1z",
    fill: "#373733",
    fillOpacity: 0.216
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M104 13h1v1h-1z",
    fill: "#383833",
    fillOpacity: 0.196
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M105 14v-1h1v1z",
    fill: "#353b35",
    fillOpacity: 0.169
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M107 14h-1v-1h1z",
    fill: "#393933",
    fillOpacity: 0.157
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M108 14h-1v-1h1z",
    fill: "#3e3e3e",
    fillOpacity: 0.145
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M108 14v-1h1v1z",
    fill: "#45453d",
    fillOpacity: 0.129
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M110 13v1h-1v-1z",
    fill: "#4c4c44",
    fillOpacity: 0.118
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M110 14v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.094
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-1h1v1z",
    fill: "#36362d",
    fillOpacity: 0.11
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h-1v-1h1z",
    fill: "#303030",
    fillOpacity: 0.29
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15v-1h1v1z",
    fill: "#343636",
    fillOpacity: 0.608
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15v-1h1v1z",
    fill: "#343737",
    fillOpacity: 0.745
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15v-1h1v1z",
    fill: "#252827",
    fillOpacity: 0.741
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h-1v-1h1z",
    fill: "#1e2122",
    fillOpacity: 0.745
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15v-1h1v1z",
    fill: "#252526",
    fillOpacity: 0.725
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15v-1h1v1z",
    fill: "#363b3a",
    fillOpacity: 0.859
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15v-1h1v1z",
    fill: "#1d2123"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14v1h-1v-1z",
    fill: "#171b1d"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v-1h1v1z",
    fill: "#191d1d"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#191e1c"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15h-1v-1h1z",
    fill: "#2f3633"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h-1v-1h1z",
    fill: "#3c4241"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1z",
    fill: "#6e7775"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#4e5755"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h1v1h-1z",
    fill: "#77807f"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h-1v-1h1z",
    fill: "#384140"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1z",
    fill: "#272e30"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#252b2e"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#242c2b"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h1v1z",
    fill: "#222b29"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15v-1h1v1z",
    fill: "#212827"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1z",
    fill: "#212726"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1z",
    fill: "#202525"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1z",
    fill: "#212625"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1z",
    fill: "#1f2423"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#1d2322"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#1e2222"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#1d2121"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1z",
    fill: "#1c2020"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#1b1f1f"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1z",
    fill: "#1a1f1f"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1z",
    fill: "#191c1b"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v1h-1v-1z",
    fill: "#181b1a"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#0f1212"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v1h-1v-1z",
    fill: "#131614"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15v-1h1v1z",
    fill: "#131512"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15v-1h1v1z",
    fill: "#141412"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M100 14h1v1h-1z",
    fill: "#131311"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M102 14v1h-1v-1z",
    fill: "#131312"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M103 15h-1v-1h1z",
    fill: "#121411",
    fillOpacity: 0.992
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M103 14h1v1h-1z",
    fill: "#131511",
    fillOpacity: 0.988
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M105 14v1h-1v-1z",
    fill: "#131511",
    fillOpacity: 0.98
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M105 14h1v1h-1z",
    fill: "#131511",
    fillOpacity: 0.969
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M106 15v-1h1v1z",
    fill: "#131411",
    fillOpacity: 0.961
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M107 15v-1h1v1z",
    fill: "#141412",
    fillOpacity: 0.957
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M109 15h-1v-1h1z",
    fill: "#151614",
    fillOpacity: 0.945
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M109 14h1v1h-1z",
    fill: "#161615",
    fillOpacity: 0.937
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M111 15h-1v-1h1z",
    fill: "#161714",
    fillOpacity: 0.922
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M111 15v-1h1v1z",
    fill: "#191a15",
    fillOpacity: 0.839
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M113 14v1h-1v-1z",
    fill: "#2f332b",
    fillOpacity: 0.275
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M114 14v1h-1v-1z",
    fill: "#727f72",
    fillOpacity: 0.078
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M114 14h1v1h-1z",
    fill: "#66665b",
    fillOpacity: 0.098
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M116 14v1h-1v-1z",
    fill: "#666",
    fillOpacity: 0.078
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.071
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v-1h1v1z",
    fill: "#41433e",
    fillOpacity: 0.384
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v1h-1v-1z",
    fill: "#3c3f3a",
    fillOpacity: 0.773
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16h-1v-1h1z",
    fill: "#363833",
    fillOpacity: 0.922
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v-1h1v1z",
    fill: "#323430"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h1v1h-1z",
    fill: "#585a58"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16v-1h1v1z",
    fill: "#656767"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h-1v-1h1z",
    fill: "#404242"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16v-1h1v1z",
    fill: "#292a2c"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h1v1h-1z",
    fill: "#363839"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15h1v1h-1z",
    fill: "#242725"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15h1v1h-1z",
    fill: "#191e1f"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v1h-1v-1z",
    fill: "#111617"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15h1v1h-1z",
    fill: "#333836"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#181b18"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#090c0b"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#181f1c"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1z",
    fill: "#2b352e"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16v-1h1v1z",
    fill: "#2d332f"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#303531"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#303632"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15v1h-1v-1z",
    fill: "#2f3431"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h1v1h-1z",
    fill: "#323836"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1z",
    fill: "#3a413e"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16v-1h1v1z",
    fill: "#353c39"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-1v-1h1z",
    fill: "#323a37"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15h1v1h-1z",
    fill: "#2f3734"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#2f3433"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1z",
    fill: "#313735"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#2f3533"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#2e3231"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1z",
    fill: "#2c3030"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#272d2c"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#272c2c"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1z",
    fill: "#3d4242"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h1v1h-1z",
    fill: "#34393a"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1z",
    fill: "#4e5353"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#4e5354"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#565b5b"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1z",
    fill: "#3e4443"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h-1v-1h1z",
    fill: "#212525"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v1h-1v-1z",
    fill: "#1f2223"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v-1h1v1z",
    fill: "#1f2322"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#1e2120"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M90 16h-1v-1h1z",
    fill: "#1c201f"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15h1v1h-1z",
    fill: "#141716"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M113 15v1h-1v-1z",
    fill: "#0d0f0c",
    fillOpacity: 0.949
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M113 15h1v1h-1z",
    fill: "#141613",
    fillOpacity: 0.894
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M115 16h-1v-1h1z",
    fill: "#121311",
    fillOpacity: 0.918
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M115 16v-1h1v1z",
    fill: "#121211",
    fillOpacity: 0.867
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M116 15h1v1h-1z",
    fill: "#262626",
    fillOpacity: 0.157
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17v-1h1v1z",
    fill: "#555550",
    fillOpacity: 0.2
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17h-1v-1h1z",
    fill: "#6b706b",
    fillOpacity: 0.196
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17h-1v-1h1z",
    fill: "#7f7f7f",
    fillOpacity: 0.227
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16v1h-1v-1z",
    fill: "#2d2d2b",
    fillOpacity: 0.667
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16v1h-1v-1z",
    fill: "#1d1e1c"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h-1v-1h1z",
    fill: "#1a1b18"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16h1v1h-1z",
    fill: "#161914"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#161915"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1z",
    fill: "#171a15"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h1z",
    fill: "#1b1f1b"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1z",
    fill: "#656c67"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1z",
    fill: "#171b17"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#1a1c19"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#1a1f1c"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1z",
    fill: "#1e211f"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#1e221f"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#1f2220"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1z",
    fill: "#202422"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#202523"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#202222"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#363b39"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#78807f"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#798082"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#7f8688"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1z",
    fill: "#7f8686"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#979e9c"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#5e6664"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#a1a9a7"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#8e9594"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#94999a"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1z",
    fill: "#999f9f"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17h-1v-1h1z",
    fill: "#424748"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M77 16h1v1h-1z",
    fill: "#595e5f"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16v1h-1v-1z",
    fill: "#575e61"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h1v1h-1z",
    fill: "#575d5f"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h1v1h-1z",
    fill: "#44494a"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#4d5457"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v1h-1v-1z",
    fill: "#4f5657"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1z",
    fill: "#383d3e"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#2a2f2e"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#292e2d"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h1v1h-1z",
    fill: "#2b2e2d"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M100 16v1h-1v-1z",
    fill: "#323737"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M100 16h1v1h-1z",
    fill: "#313535"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M101 16h1v1h-1z",
    fill: "#2c2f30"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M103 16v1h-1v-1z",
    fill: "#2f3334"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M105 16v1h-1v-1z",
    fill: "#2d2e2d"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M105 17v-1h1v1z",
    fill: "#2e2f30"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M106 16h1v1h-1z",
    fill: "#2c2d2f"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M116 16h1v1h-1z",
    fill: "#191916",
    fillOpacity: 0.314
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17v1h-1v-1z",
    fill: "#191919",
    fillOpacity: 0.318
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17v1h-1v-1z",
    fill: "#141816",
    fillOpacity: 0.576
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h1v1h-1z",
    fill: "#0c0c0c",
    fillOpacity: 0.824
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18h-1v-1h1z",
    fill: "#040405",
    fillOpacity: 0.969
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1z",
    fill: "#090c09"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#535a56"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h1v1h-1z",
    fill: "#070907"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#0b0c0c"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#0b0a0a"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#161917"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#5b605e"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#5d6163"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#565a5b"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#656969"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#636767"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#4c5150"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#929796"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#5c6161"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#5a5e5e"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#515555"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#414646"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18v-1h1v1z",
    fill: "#5d6366"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v1z",
    fill: "#6a6f70"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M81 18h-1v-1h1z",
    fill: "#3d403f"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M83 17v1h-1v-1z",
    fill: "#696f70"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1z",
    fill: "#747878"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1z",
    fill: "#191919"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#1a1b1b"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18v-1h1v1z",
    fill: "#1c1d1b"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M96 17h1v1h-1z",
    fill: "#1f201e"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h1v1h-1z",
    fill: "#222422"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M99 17v1h-1v-1z",
    fill: "#696d6d"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M99 18v-1h1v1z",
    fill: "#7a8080"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M100 17h1v1h-1z",
    fill: "#5d6263"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v-1h1v1z",
    fill: "#717777"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M102 17h1v1h-1z",
    fill: "#666b6b"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v-1h1v1z",
    fill: "#282b29"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M104 18v-1h1v1z",
    fill: "#252723"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M106 18v-1h1v1z",
    fill: "#292a2a"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M108 17h1v1h-1z",
    fill: "#2a2c2a"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M111 18h-1v-1h1z",
    fill: "#2f302e"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M112 17h1v1h-1z",
    fill: "#474947"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M114 17v1h-1v-1z",
    fill: "#464846"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M115 18h-1v-1h1z",
    fill: "#3a3b39"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M115 17h1v1h-1z",
    fill: "#474745"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M117 18h-1v-1h1z",
    fill: "#4a4a4a",
    fillOpacity: 0.322
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18h1v1h-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.031
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19v-1h1v1z",
    fill: "#15151a",
    fillOpacity: 0.188
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19h-1v-1h1z",
    fill: "#0a0a0a",
    fillOpacity: 0.286
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v1h-1v-1z",
    fill: "#0a0a06",
    fillOpacity: 0.298
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h1v1h-1z",
    fill: "#060603",
    fillOpacity: 0.302
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19h-1v-1h1z",
    fill: "#050502",
    fillOpacity: 0.349
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19h-1v-1h1z",
    fill: "#1a1c1a",
    fillOpacity: 0.745
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19h-1v-1h1z",
    fill: "#3f4543"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1z",
    fill: "#141515"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18h1v1h-1z",
    fill: "#060704"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1z",
    fill: "#040503"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1z",
    fill: "#060503"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#070606"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M98 19v-1h1v1z",
    fill: "#393c3c"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19h-1v-1h1z",
    fill: "#5c6162"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v1h-1v-1z",
    fill: "#5d6363"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18h1v1h-1z",
    fill: "#5e6766"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v1h-1v-1z",
    fill: "#444947"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18h1v1h-1z",
    fill: "#0c0e0b"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M106 19h-1v-1h1z",
    fill: "#0e0d0b"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M110 19v-1h1v1z",
    fill: "#11120e"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M111 18h1v1h-1z",
    fill: "#10100d"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M113 19h-1v-1h1z",
    fill: "#080906"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M117 18v1h-1v-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.278
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19v1h-1v-1z",
    fill: "#090b07",
    fillOpacity: 0.518
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20v-1h1v1z",
    fill: "#020402",
    fillOpacity: 0.686
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-1z",
    fill: "#020402",
    fillOpacity: 0.725
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20h-1v-1h1z",
    fill: "#020302",
    fillOpacity: 0.792
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1z",
    fill: "#030303",
    fillOpacity: 0.867
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1z",
    fill: "#020202",
    fillOpacity: 0.906
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1z",
    fill: "#030303",
    fillOpacity: 0.957
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1z",
    fill: "#151918"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19h1v1h-1z",
    fill: "#020102"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#2a2a2a"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#3f3f40"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#454645"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#292a28"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#3d3e3b"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#383937"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#3b3c3b"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1z",
    fill: "#393b39"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1z",
    fill: "#373937"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19v1h-1v-1z",
    fill: "#272825"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19h1v1h-1z",
    fill: "#282927"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#242623"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19h1v1h-1z",
    fill: "#121313"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M97 20v-1h1v1z",
    fill: "#040303"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20h-1v-1h1z",
    fill: "#323231"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20h-1v-1h1z",
    fill: "#3a3e3d"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M101 19h1v1h-1z",
    fill: "#505554"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20h-1v-1h1z",
    fill: "#363937"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M108 19v1h-1v-1z",
    fill: "#050502"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M115 19h1v1h-1z",
    fill: "#040404",
    fillOpacity: 0.965
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M116 20v-1h1v1z",
    fill: "#181818",
    fillOpacity: 0.165
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20h1v1h-1z",
    fill: "#030307",
    fillOpacity: 0.275
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20h1v1h-1z",
    fill: "#020303",
    fillOpacity: 0.827
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1z",
    fill: "#080708"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#0e0e0f"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#171817"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#161716"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#222322"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#2e2e2e"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#323332"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#343535"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#232525"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h1v1h-1z",
    fill: "#383a39"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M116 21h-1v-1h1z",
    fill: "#050505",
    fillOpacity: 0.851
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22h-1v-1h1z",
    fill: "#12120f",
    fillOpacity: 0.333
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h-1v-1h1z",
    fill: "#0b0b08",
    fillOpacity: 0.345
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h1v1h-1z",
    fill: "#0b0808",
    fillOpacity: 0.337
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21h1v1h-1z",
    fill: "#0a0805",
    fillOpacity: 0.365
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-1z",
    fill: "#060604",
    fillOpacity: 0.447
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v-1h1v1z",
    fill: "#090707",
    fillOpacity: 0.51
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1z",
    fill: "#070707",
    fillOpacity: 0.702
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22h-1v-1h1z",
    fill: "#050505",
    fillOpacity: 0.859
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#050707",
    fillOpacity: 0.973
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1z",
    fill: "#010304"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M112 21v1h-1v-1z",
    fill: "#020203",
    fillOpacity: 0.949
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M113 21v1h-1v-1z",
    fill: "#060603",
    fillOpacity: 0.769
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M114 21v1h-1v-1z",
    fill: "#070707",
    fillOpacity: 0.824
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M114 21h1v1h-1z",
    fill: "#0f0d0f",
    fillOpacity: 0.863
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M115 22v-1h1v1z",
    fill: "#121212",
    fillOpacity: 0.439
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23v-1h1v1z",
    fill: "#131313",
    fillOpacity: 0.153
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h-1v-1h1z",
    fill: "#12120d",
    fillOpacity: 0.216
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23h-1v-1h1z",
    fill: "#0d0d0d",
    fillOpacity: 0.22
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-1h1v1z",
    fill: "#13130e",
    fillOpacity: 0.208
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v1h-1v-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.196
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22h1v1h-1z",
    fill: "#1b1f1f",
    fillOpacity: 0.608
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22v1h-1v-1z",
    fill: "#0a0d0d"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-1h1v1z",
    fill: "#07090a"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h1v1h-1z",
    fill: "#060708"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v1h-1z",
    fill: "#050807"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23v-1h1v1z",
    fill: "#121715"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22h1v1h-1z",
    fill: "#191f1d"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v-1h1v1z",
    fill: "#1a201e"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h1v1h-1z",
    fill: "#1a2020"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22h1v1h-1z",
    fill: "#494e50"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1z",
    fill: "#2a3032"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#3a4141"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#343b3b"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#0f1716"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#101818"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#111717"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1z",
    fill: "#101617"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h1z",
    fill: "#0f1515"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#0e1414"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#0d1012"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#0c1011"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#0d1010"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#0a0e0d"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#0b0f0d"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#0b0e0d"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#090b0b"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#040706"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M111 22v1h-1v-1z",
    fill: "#020302",
    fillOpacity: 0.769
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M111 23v-1h1v1z",
    fill: "#050505",
    fillOpacity: 0.18
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M114 22h1v1h-1z",
    fill: "#45452e",
    fillOpacity: 0.043
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23v1h-1v-1z",
    fill: "#383838",
    fillOpacity: 0.106
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24h-1v-1h1z",
    fill: "#2b2e27",
    fillOpacity: 0.325
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24h-1v-1h1z",
    fill: "#222622",
    fillOpacity: 0.518
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24v-1h1v1z",
    fill: "#272a27",
    fillOpacity: 0.729
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v1h-1v-1z",
    fill: "#424642",
    fillOpacity: 0.949
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24v-1h1v1z",
    fill: "#4a4d4a",
    fillOpacity: 0.988
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h1v1h-1z",
    fill: "#3e4441",
    fillOpacity: 0.988
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v1h-1v-1z",
    fill: "#313636",
    fillOpacity: 0.984
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h-1v-1h1z",
    fill: "#303333",
    fillOpacity: 0.98
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23v1h-1v-1z",
    fill: "#363939"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23h1v1h-1z",
    fill: "#454b4c"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23h1v1h-1z",
    fill: "#3d4545"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v1h-1v-1z",
    fill: "#343a3a"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#252929"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#131917"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#323b38"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#353e39"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#373d3a"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#3c4341"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#818786"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#656c6b"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1z",
    fill: "#747c7a"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#2d3533"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1z",
    fill: "#313938"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#323837"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#303636"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#2f3534"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1z",
    fill: "#2e3433"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#2a3030"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#282f2f"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#272f2e"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#272e2e"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#252d2c"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#242927"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#212423"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#202423"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#1c2120"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#1b2021"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#1a1e1c"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#191d1c"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#181c1b"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#161a19"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#15191a"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#141819"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#111516"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#101415"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#101315"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#0e1111"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M99 23h1v1h-1z",
    fill: "#0a0c0c"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M110 23h1v1h-1z",
    fill: "#040605",
    fillOpacity: 0.741
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M111 23h1v1h-1z",
    fill: "#080805",
    fillOpacity: 0.365
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M113 23v1h-1v-1z",
    fill: "#080805",
    fillOpacity: 0.337
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M113 24v-1h1v1z",
    fill: "#0b0b0b",
    fillOpacity: 0.271
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M115 23v1h-1v-1z",
    fill: "#131313",
    fillOpacity: 0.051
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24h1v1h-1z",
    fill: "#434343",
    fillOpacity: 0.075
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25h-1v-1h1z",
    fill: "#363634",
    fillOpacity: 0.514
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25v-1h1v1z",
    fill: "#5a5a56",
    fillOpacity: 0.267
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24v1h-1v-1z",
    fill: "#61615e",
    fillOpacity: 0.286
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25h-1v-1h1z",
    fill: "#21221f",
    fillOpacity: 0.835
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24v1h-1v-1z",
    fill: "#353733"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25h-1v-1h1z",
    fill: "#232521"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24v1h-1v-1z",
    fill: "#232421"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24h1v1h-1z",
    fill: "#393c39"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25v-1h1v1z",
    fill: "#383b38"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25h-1v-1h1z",
    fill: "#303532"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24h1v1h-1z",
    fill: "#292f2d"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24h1v1h-1z",
    fill: "#0f1210"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25h-1v-1h1z",
    fill: "#0b0f0c"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25h-1v-1h1z",
    fill: "#101310"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1z",
    fill: "#262825"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#1f2121"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#252926"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#262c28"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#3d413f"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#333936"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#404442"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#383c3a"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#292e2b"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1z",
    fill: "#2c302d"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#2c312e"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#2d322f"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#2b3331"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#2e3130"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#2a2d2d"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#2b2f2f"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#292f2f"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#292e2f"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#2a2f30"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#2a2f2f"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1z",
    fill: "#323736"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#575c5b"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#272b2c"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#262a2c"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v-1h1v1z",
    fill: "#272a2a"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1z",
    fill: "#272b2b"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#262929"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#242727"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#252828"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#232627"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#1f2422"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#1f2523"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#1e2322"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M95 24v1h-1v-1z",
    fill: "#1d2120"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25v-1h1v1z",
    fill: "#1d201f"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M98 24h1v1h-1z",
    fill: "#1c1f1d"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M103 25h-1v-1h1z",
    fill: "#1a1c1c"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M115 24v1h-1v-1z",
    fill: "#090b09",
    fillOpacity: 0.502
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26h-1v-1h1z",
    fill: "#393939",
    fillOpacity: 0.173
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25h1v1h-1z",
    fill: "#4c4c47",
    fillOpacity: 0.196
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26v-1h1v1z",
    fill: "#4f4f4a",
    fillOpacity: 0.227
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25v1h-1v-1z",
    fill: "#131313",
    fillOpacity: 0.502
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25v1h-1v-1z",
    fill: "#0d0c0d",
    fillOpacity: 0.804
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25h1v1h-1z",
    fill: "#080809",
    fillOpacity: 0.965
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25v1h-1v-1z",
    fill: "#000001"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#0d0f0b"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#0d100d"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#3f433f"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#1d201c"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#10120e"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#151613"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#161916"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#151a16"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#191e1a"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#1a1e1b"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#383b3a"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#333838"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#3b4040"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#343939"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#626667"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#434948"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#89918f"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#7d8384"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#707675"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1z",
    fill: "#929694"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#404444"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#2e3233"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#313638"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#2c3234"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#333637"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#262a2a"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#313333"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#272927"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#282c2b"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#2c302f"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26h-1v-1h1z",
    fill: "#2c302e"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25v1h-1v-1z",
    fill: "#2d3130"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25h1v1h-1z",
    fill: "#282c2a"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26h-1v-1h1z",
    fill: "#2b2f2d"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M101 25v1h-1v-1z",
    fill: "#2a2d2c"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M110 26v-1h1v1z",
    fill: "#353735"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M114 25h1v1h-1z",
    fill: "#181916",
    fillOpacity: 0.663
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h1v1h-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.027
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26h1v1h-1z",
    fill: "#282e2e",
    fillOpacity: 0.173
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27v-1h1v1z",
    fill: "#1c1f21",
    fillOpacity: 0.384
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26v1h-1v-1z",
    fill: "#0d0f0f",
    fillOpacity: 0.647
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27v-1h1v1z",
    fill: "#090a09",
    fillOpacity: 0.729
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26h1v1h-1z",
    fill: "#080805",
    fillOpacity: 0.702
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26v1h-1v-1z",
    fill: "#060604",
    fillOpacity: 0.659
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26h1v1h-1z",
    fill: "#0f0f0f",
    fillOpacity: 0.71
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v-1h1v1z",
    fill: "#181817",
    fillOpacity: 0.98
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#040302"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#4d524e"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#212421"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#070805"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#080907"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#070806"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#7a7e7d"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#868c8b"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#949a9a"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#8a9090"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#a1a7a7"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#424948"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#7d8285"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#7d8283"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#6e7271"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#505250"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#4b4f4e"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#6a7270"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#767e7d"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1z",
    fill: "#4e5253"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1z",
    fill: "#3c4041"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#65696a"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#777b7c"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#484b4a"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1z",
    fill: "#171917"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26h1v1h-1z",
    fill: "#343737"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M98 27h-1v-1h1z",
    fill: "#606463"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M98 26h1v1h-1z",
    fill: "#4b4f51"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26v1h-1v-1z",
    fill: "#414749"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M100 27v-1h1v1z",
    fill: "#4e5453"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26h1v1h-1z",
    fill: "#373a38"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v-1h1v1z",
    fill: "#1d1f1c"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26v1h-1v-1z",
    fill: "#222421"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M106 26h1v1h-1z",
    fill: "#232523"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M112 26v1h-1v-1z",
    fill: "#3f403d"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M112 27v-1h1v1z",
    fill: "#323230"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M114 26v1h-1v-1z",
    fill: "#383936"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M114 26h1v1h-1z",
    fill: "#41413f",
    fillOpacity: 0.659
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27h1v1h-1z",
    fill: "#1f1d1a",
    fillOpacity: 0.447
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27h1v1h-1z",
    fill: "#11100d",
    fillOpacity: 0.976
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1z",
    fill: "#100f0d"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#0f0f0c"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#0d0e09"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#090905"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#070604"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#343734"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#20211f"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#030400"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#010300"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#070706"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#0c0f0d"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#111412"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#4b4e4d"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#1b1e1f"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#060504"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28v-1h1v1z",
    fill: "#070804"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28v-1h1v1z",
    fill: "#232624"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M97 27h1v1h-1z",
    fill: "#5c6061"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27v1h-1v-1z",
    fill: "#5c5e61"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v-1h1v1z",
    fill: "#55595a"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M101 28h-1v-1h1z",
    fill: "#5b6160"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v1h-1v-1z",
    fill: "#1a1c1a"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M106 27v1h-1v-1z",
    fill: "#0a0b08"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M114 27h1v1h-1z",
    fill: "#060505",
    fillOpacity: 0.576
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v1h-1v-1z",
    fill: "#272424",
    fillOpacity: 0.353
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#1b1d18",
    fillOpacity: 0.404
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#1e1e1a",
    fillOpacity: 0.459
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#171712",
    fillOpacity: 0.71
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#131311",
    fillOpacity: 0.918
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#131310",
    fillOpacity: 0.961
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#121410",
    fillOpacity: 0.976
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#12120f",
    fillOpacity: 0.984
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#232420"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#20201e"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#11110f"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#0d0e0a"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#0e0f0a"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#0c0c08"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#161713"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#3a3c37"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#393c37"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#353732"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#363833"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#323530"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#1a1d18"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#2e2e2b"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#2f2f2c"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#262623"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#1b1c17"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#262723"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#21231e"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#262823"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#12130f"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#1b1c19"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#20201d"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#1a1a16"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#161813"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#181915"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#0d0e0b"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#0e0f0c"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-1v-1h1z",
    fill: "#030300"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#454848"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#383939"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M99 29v-1h1v1z",
    fill: "#4d504d"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v-1h1v1z",
    fill: "#4c504d"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M103 28v1h-1v-1z",
    fill: "#030201"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28v1h-1v-1z",
    fill: "#040401"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M108 29v-1h1v1z",
    fill: "#040301"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M114 29v-1h1v1z",
    fill: "#0b0b0b",
    fillOpacity: 0.431
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#27271d",
    fillOpacity: 0.102
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#24241e",
    fillOpacity: 0.165
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#1f1f1a",
    fillOpacity: 0.192
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#1c1c17",
    fillOpacity: 0.212
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#292926",
    fillOpacity: 0.263
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#262620",
    fillOpacity: 0.31
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#1f221c",
    fillOpacity: 0.349
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#2d2d28",
    fillOpacity: 0.392
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#1c1c19",
    fillOpacity: 0.357
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#1d1d1a",
    fillOpacity: 0.373
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#1e1e19",
    fillOpacity: 0.424
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#1c1c1a",
    fillOpacity: 0.455
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#1c1a18",
    fillOpacity: 0.486
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#1a1a18",
    fillOpacity: 0.482
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#1b1b19",
    fillOpacity: 0.478
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#1b1b17",
    fillOpacity: 0.502
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#1b1b17",
    fillOpacity: 0.514
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#1a1a17",
    fillOpacity: 0.522
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#191916",
    fillOpacity: 0.541
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#1a1a15",
    fillOpacity: 0.565
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#181914",
    fillOpacity: 0.58
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#1b1b17",
    fillOpacity: 0.592
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#292926",
    fillOpacity: 0.624
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#2a2c26",
    fillOpacity: 0.675
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#252722",
    fillOpacity: 0.686
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#2c2d27",
    fillOpacity: 0.702
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#2b2c27",
    fillOpacity: 0.714
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#242521",
    fillOpacity: 0.745
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#32332e",
    fillOpacity: 0.757
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#363732",
    fillOpacity: 0.757
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#2f302b",
    fillOpacity: 0.784
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#262721",
    fillOpacity: 0.827
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#353530",
    fillOpacity: 0.839
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#373733",
    fillOpacity: 0.859
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#3b3c38",
    fillOpacity: 0.875
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#252822",
    fillOpacity: 0.875
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#30312c",
    fillOpacity: 0.886
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#3a3c36",
    fillOpacity: 0.91
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#383a35",
    fillOpacity: 0.933
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#363733",
    fillOpacity: 0.957
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#3b3c37",
    fillOpacity: 0.973
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#21221d",
    fillOpacity: 0.984
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#2b2c27",
    fillOpacity: 0.992
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#3d3d38"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#3e3e3a"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#43443f"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#42433e"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#3b3d38"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#393b36"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1z",
    fill: "#242621"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#3f413c"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#424440"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#1f211d"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#0b0d09"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#171915"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M99 30h-1v-1h1z",
    fill: "#30312e"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v1h-1v-1z",
    fill: "#434542"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30h-1v-1h1z",
    fill: "#2b2d2a"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M104 30h-1v-1h1z",
    fill: "#090806"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M113 30h-1v-1h1z",
    fill: "#0d0d0c"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M115 29v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.208
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fillOpacity: 0.039
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fillOpacity: 0.051
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fillOpacity: 0.063
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#0f0f0f",
    fillOpacity: 0.063
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fillOpacity: 0.067
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fillOpacity: 0.09
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#111108",
    fillOpacity: 0.118
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#140d0d",
    fillOpacity: 0.145
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#11110b",
    fillOpacity: 0.173
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#1d1813",
    fillOpacity: 0.204
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#1a1611",
    fillOpacity: 0.224
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#181410",
    fillOpacity: 0.247
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#1f1c18",
    fillOpacity: 0.282
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#1c1916",
    fillOpacity: 0.314
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#1e1e18",
    fillOpacity: 0.333
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#1b1b18",
    fillOpacity: 0.361
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#1b1b16",
    fillOpacity: 0.396
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1z",
    fill: "#1b1b16",
    fillOpacity: 0.439
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#1f1f1b",
    fillOpacity: 0.475
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#23211d",
    fillOpacity: 0.502
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#1e1e18",
    fillOpacity: 0.529
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#1a1a15",
    fillOpacity: 0.569
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#1b1b16",
    fillOpacity: 0.62
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#1b1b15",
    fillOpacity: 0.686
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#191914",
    fillOpacity: 0.737
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#1a1a15",
    fillOpacity: 0.784
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#1a1a14",
    fillOpacity: 0.82
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1z",
    fill: "#1a1914",
    fillOpacity: 0.831
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#1a1914",
    fillOpacity: 0.863
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#181713",
    fillOpacity: 0.882
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#1d1c17",
    fillOpacity: 0.89
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#21201c",
    fillOpacity: 0.898
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31h-1v-1h1z",
    fill: "#22221e",
    fillOpacity: 0.91
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M101 31h-1v-1h1z",
    fill: "#1b1b18",
    fillOpacity: 0.925
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31h-1v-1h1z",
    fill: "#161513",
    fillOpacity: 0.933
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M102 30h1v1h-1z",
    fill: "#171715",
    fillOpacity: 0.949
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M104 31h-1v-1h1z",
    fill: "#151513",
    fillOpacity: 0.965
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M104 30h1v1h-1z",
    fill: "#161614",
    fillOpacity: 0.984
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M106 30v1h-1v-1z",
    fill: "#161613",
    fillOpacity: 0.996
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M106 31v-1h1v1z",
    fill: "#151513"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M108 31h-1v-1h1z",
    fill: "#151512"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M109 30v1h-1v-1z",
    fill: "#141510",
    fillOpacity: 0.988
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M110 30v1h-1v-1z",
    fill: "#14150f",
    fillOpacity: 0.929
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M110 30h1v1h-1z",
    fill: "#1b1b17",
    fillOpacity: 0.718
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M111 31v-1h1v1z",
    fill: "#23231f",
    fillOpacity: 0.627
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M113 31h-1v-1h1z",
    fill: "#232320",
    fillOpacity: 0.651
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M114 31h-1v-1h1z",
    fill: "#232121",
    fillOpacity: 0.475
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#3f1f1f",
    fillOpacity: 0.031
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#2a2a1c",
    fillOpacity: 0.071
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1z",
    fill: "#262619",
    fillOpacity: 0.078
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.082
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M100 32v-1h1v1z",
    fill: "#231a1a",
    fillOpacity: 0.114
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.125
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M102 32v-1h1v1z",
    fill: "#22221b",
    fillOpacity: 0.145
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M103 31h1v1h-1z",
    fill: "#22221c",
    fillOpacity: 0.173
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31v1h-1v-1z",
    fill: "#21211c",
    fillOpacity: 0.208
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M105 32v-1h1v1z",
    fill: "#22221d",
    fillOpacity: 0.235
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M106 31h1v1h-1z",
    fill: "#22221e",
    fillOpacity: 0.263
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M107 32v-1h1v1z",
    fill: "#21211e",
    fillOpacity: 0.267
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M109 32h-1v-1h1z",
    fill: "#202520",
    fillOpacity: 0.216
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M109 31h1v1h-1z",
    fill: "#26261e",
    fillOpacity: 0.129
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#e7e7b9",
    fillOpacity: 0.043
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#e5e5b2",
    fillOpacity: 0.039
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#ffdada",
    fillOpacity: 0.027
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#d4d4ff",
    fillOpacity: 0.024
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#f0f0a5",
    fillOpacity: 0.2
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#f7f597",
    fillOpacity: 0.424
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#f0f390",
    fillOpacity: 0.424
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#f0f391",
    fillOpacity: 0.42
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#eef08e",
    fillOpacity: 0.42
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#eeee8e",
    fillOpacity: 0.42
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#eef08f",
    fillOpacity: 0.412
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#eded92",
    fillOpacity: 0.404
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#eaea92",
    fillOpacity: 0.396
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#e8e88f",
    fillOpacity: 0.404
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#ebeb90",
    fillOpacity: 0.408
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#e8e891",
    fillOpacity: 0.4
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#ecef95",
    fillOpacity: 0.38
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#ecec97",
    fillOpacity: 0.376
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#ecec93",
    fillOpacity: 0.38
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#ecef8c",
    fillOpacity: 0.384
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#eff194",
    fillOpacity: 0.384
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#f0f093",
    fillOpacity: 0.4
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#f0f09b",
    fillOpacity: 0.404
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#eef096",
    fillOpacity: 0.412
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#f0f29a",
    fillOpacity: 0.408
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#edf09b",
    fillOpacity: 0.4
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#edf296",
    fillOpacity: 0.392
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#eef496",
    fillOpacity: 0.373
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#eef194",
    fillOpacity: 0.365
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#f0f09a",
    fillOpacity: 0.357
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#f1f199",
    fillOpacity: 0.365
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#efef94",
    fillOpacity: 0.376
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#efef99",
    fillOpacity: 0.384
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#f0f29b",
    fillOpacity: 0.4
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#e9ee98",
    fillOpacity: 0.42
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#f0f09b",
    fillOpacity: 0.424
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#eef597",
    fillOpacity: 0.435
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#eff19b",
    fillOpacity: 0.451
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#edef99",
    fillOpacity: 0.451
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#e9e998",
    fillOpacity: 0.459
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#e9e998",
    fillOpacity: 0.467
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#e9e992",
    fillOpacity: 0.471
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#ecec91",
    fillOpacity: 0.475
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#eae894",
    fillOpacity: 0.478
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#e8e892",
    fillOpacity: 0.478
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#e6e692",
    fillOpacity: 0.486
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#e7e78d",
    fillOpacity: 0.475
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v1h-1v-1z",
    fill: "#ebeb8d",
    fillOpacity: 0.467
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M100 42v-1h1v1z",
    fill: "#e9e98b",
    fillOpacity: 0.475
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41v1h-1v-1z",
    fill: "#eaea92",
    fillOpacity: 0.486
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42v-1h1v1z",
    fill: "#eaea94",
    fillOpacity: 0.498
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M104 41v1h-1v-1z",
    fill: "#eaea91",
    fillOpacity: 0.494
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41v1h-1v-1z",
    fill: "#eaea92",
    fillOpacity: 0.49
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41h1v1h-1z",
    fill: "#e8e88e",
    fillOpacity: 0.49
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M107 41v1h-1v-1z",
    fill: "#ebeb99",
    fillOpacity: 0.514
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42h-1v-1h1z",
    fill: "#eded9c",
    fillOpacity: 0.518
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42h-1v-1h1z",
    fill: "#ebef91",
    fillOpacity: 0.502
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v-1h1v1z",
    fill: "#edf194",
    fillOpacity: 0.506
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M110 41h1v1h-1z",
    fill: "#eff192",
    fillOpacity: 0.506
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42h-1v-1h1z",
    fill: "#eff193",
    fillOpacity: 0.514
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42v-1h1v1z",
    fill: "#ebf196",
    fillOpacity: 0.518
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M114 42h-1v-1h1z",
    fill: "#edf395",
    fillOpacity: 0.514
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42h-1v-1h1z",
    fill: "#edef97",
    fillOpacity: 0.514
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M116 41v1h-1v-1z",
    fill: "#eef490",
    fillOpacity: 0.478
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M116 42v-1h1v1z",
    fill: "#ecf19a",
    fillOpacity: 0.376
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M118 41v1h-1v-1z",
    fill: "#e9e9aa",
    fillOpacity: 0.047
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#00f",
    fillOpacity: 0.004
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#ffffe2",
    fillOpacity: 0.035
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#f2f2aa",
    fillOpacity: 0.082
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#eef699",
    fillOpacity: 0.118
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#e7ef9f",
    fillOpacity: 0.125
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#efefaa",
    fillOpacity: 0.129
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#ececa3",
    fillOpacity: 0.11
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#f2f593",
    fillOpacity: 0.541
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#f9fc8a",
    fillOpacity: 0.851
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#f6f986",
    fillOpacity: 0.839
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#f6f685",
    fillOpacity: 0.839
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#f6f584",
    fillOpacity: 0.839
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#f7f683",
    fillOpacity: 0.831
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#f5f581",
    fillOpacity: 0.831
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#f6f583",
    fillOpacity: 0.827
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#f6f683",
    fillOpacity: 0.827
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#f4f585",
    fillOpacity: 0.824
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#f4f685",
    fillOpacity: 0.824
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#f3f685",
    fillOpacity: 0.812
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#f2f584",
    fillOpacity: 0.816
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#f2f586",
    fillOpacity: 0.824
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#f2f588",
    fillOpacity: 0.824
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#f2f586",
    fillOpacity: 0.82
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#f3f580",
    fillOpacity: 0.812
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#f5f475",
    fillOpacity: 0.937
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#fcfc7d"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#fdff82"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#f9fa84"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#f8fa7c"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#f0f276"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#fcfe7a"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1z",
    fill: "#f9fc78"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#efef76"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#fafa77"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42h1v1h-1z",
    fill: "#fdff7b"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M117 43h-1v-1h1z",
    fill: "#feff86"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M118 42v1h-1v-1z",
    fill: "#95965f",
    fillOpacity: 0.804
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43h-1v-1h1z",
    fill: "#19181a",
    fillOpacity: 0.706
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M120 42v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.69
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M121 42v1h-1v-1z",
    fill: "#1f1f1d",
    fillOpacity: 0.671
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M122 42v1h-1v-1z",
    fill: "#21211f",
    fillOpacity: 0.537
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#eef691",
    fillOpacity: 0.247
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#f7f988",
    fillOpacity: 0.514
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#f4f58a",
    fillOpacity: 0.659
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#f7f78a",
    fillOpacity: 0.757
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#f6f783",
    fillOpacity: 0.831
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#f8fa7c",
    fillOpacity: 0.898
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#f7f97b",
    fillOpacity: 0.933
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#f6f87e",
    fillOpacity: 0.937
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#f6f87d",
    fillOpacity: 0.941
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#f5f77b",
    fillOpacity: 0.922
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#f9fa83"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#fcfc6b"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#fcfd69"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#fdfd6b"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#fdfe6b"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#fdfd6c"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#fcfe6c"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#fbff6c"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#fbfd6d"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#fbfd6e"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#fcfd6d"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#fdfe6d"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#fcfd6b"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#fcfd68"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#fafc6b"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#ecf271"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#9ea461"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#939b65"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#7b8053"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#868956"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#f8f97d"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#d9d96e"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#bebc6a"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#e0e275"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#e8ea6e"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#d3d46a"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#d5d671"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#d3d56a"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#d9dc6e"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#cacb66"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#f0f07d"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#bfbd66"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#eced72"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#f2f26f"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#dcdd6e"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#e3e56e"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#ddda72"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#d6d469"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#d8d86b"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#d0d06b"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#d8da69"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#e8e972"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1z",
    fill: "#dcda66"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v-1h1v1z",
    fill: "#fafa6d"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43h1v1h-1z",
    fill: "#fdfc6c"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M102 44v-1h1v1z",
    fill: "#fcfc69"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M103 44v-1h1v1z",
    fill: "#fafb69"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43h1v1h-1z",
    fill: "#f9fb6d"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M107 44v-1h1v1z",
    fill: "#f9fb69"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M109 44h-1v-1h1z",
    fill: "#f8fa6c"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M110 44h-1v-1h1z",
    fill: "#d6d86a"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44h-1v-1h1z",
    fill: "#cbce74"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M111 43h1v1h-1z",
    fill: "#cacc67"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v-1h1v1z",
    fill: "#eff273"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44v-1h1v1z",
    fill: "#f9fb6e"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44h-1v-1h1z",
    fill: "#f8fa6d"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44v-1h1v1z",
    fill: "#f8f870"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M117 44v-1h1v1z",
    fill: "#b6b96b"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43v1h-1v-1z",
    fill: "#1a1a14"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43h1v1h-1z",
    fill: "#1b1c1c"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M121 44v-1h1v1z",
    fill: "#1c1d1a"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M122 43h1v1h-1z",
    fill: "#20201e",
    fillOpacity: 0.455
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v1h-1v-1z",
    fill: "#c3d287",
    fillOpacity: 0.067
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h-1v-1h1z",
    fill: "#dbcf53",
    fillOpacity: 0.396
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44v1h-1v-1z",
    fill: "#ecda2b",
    fillOpacity: 0.6
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#f3de27",
    fillOpacity: 0.682
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#eddf2c",
    fillOpacity: 0.741
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#f7f47d",
    fillOpacity: 0.957
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#ffff92"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#ffff90"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#ffff94"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#ffff91"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#ff8"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#fcfd7f"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#fffe78"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#fdfd6a"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#fcfc6f"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#fafa79"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#fcfc7e"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#fbfc81"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#fcfe83"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#fcfd80"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#fdfe80"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#fdfd82"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#fdfd83"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#fdfe83"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#fdfd7f"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#fdfc7f"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#fefd80"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#fefd7f"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#fefc7a"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#f9f969"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#fafc67"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#fbfc67"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#fbfd67"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#fbfd6a"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#fcfd6e"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#fbfc6f"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#fdfd70"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#fbfc6d"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#feff70"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#fafd79"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#9ca061"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#777f5f"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#8c9163"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#949974"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#656e55"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#dfe280"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#e1e281"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#c7c784"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#c6c97d"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#bfbf80"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#b6b87f"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#afb178"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#b5b979"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#cbcf8e"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#9ea175"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#e0e491"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#c5c67c"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#f4f692"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#eaea8b"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#baba7d"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#d0d38e"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#cccc87"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#d0d288"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#dadc92"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#bdbc81"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#d1d18a"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#dcde8d"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#caca7d"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h1z",
    fill: "#f4f889"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M102 45h-1v-1h1z",
    fill: "#ffff8f"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45h-1v-1h1z",
    fill: "#feff8b"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M104 44v1h-1v-1z",
    fill: "#feff8f"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v-1h1v1z",
    fill: "#fcfd8d"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45h-1v-1h1z",
    fill: "#fbfc8e"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v-1h1v1z",
    fill: "#fbfc90"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M107 45v-1h1v1z",
    fill: "#fbfd8d"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M109 45v-1h1v1z",
    fill: "#cacc89"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44v1h-1v-1z",
    fill: "#b0b38b"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v1h-1v-1z",
    fill: "#b4b684"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M112 45v-1h1v1z",
    fill: "#ebec96"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44h1v1h-1z",
    fill: "#fcfe94"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M114 45v-1h1v1z",
    fill: "#fafc94"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M117 45h-1v-1h1z",
    fill: "#fefe9c"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M118 45h-1v-1h1z",
    fill: "#cbcd87"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M119 44v1h-1v-1z",
    fill: "#151614"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M119 45v-1h1v1z",
    fill: "#141517"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M121 44v1h-1v-1z",
    fill: "#171a18"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M122 45v-1h1v1z",
    fill: "#161916",
    fillOpacity: 0.663
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46h-1v-1h1z",
    fill: "#c1c17a",
    fillOpacity: 0.098
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45h1v1h-1z",
    fill: "#d0c33d",
    fillOpacity: 0.49
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h1v1h-1z",
    fill: "#ddc31c",
    fillOpacity: 0.706
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#e1c413",
    fillOpacity: 0.835
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46v-1h1v1z",
    fill: "#dac218",
    fillOpacity: 0.886
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#eadf4e",
    fillOpacity: 0.992
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#f7f45e"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#f7f55c"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#f7f55f"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#f6f461"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#f5f65f"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#f3f558"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#f3f555"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#f3f554"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#f1f551"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#f2f55e"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#f6f666"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#f6f46a"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#f4f569"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#f5f668"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#f6f769"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#f6f66b"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#f7f76b"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#f8f86c"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#f6f86c"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#f7f96d"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#f8fa6e"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#f8f96e"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#f9f86e"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#f8f96f"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#f7f96f"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#f7fa6d"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#f6f968"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#f4f55c"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#f7f75e"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#f7f85f"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#f7f95f"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#f8f860"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#f8f961"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#f7f961"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#f7f960"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#f8fa61"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#f8f962"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#f9fa60"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#f9f963"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#e5e663"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#d6d562"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#d7d564"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#d2d367"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#aaab5c"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#c2c673"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#d6da79"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#bdbf70"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#a6a862"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#c7c872"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#c8c96f"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#c1c471"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#c8c971"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#c2c378"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#b8ba72"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#bec175"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#b9bb6c"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#bfc071"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#bfc16f"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#d0d270"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#d2d178"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#c0bf6e"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#c2c26d"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#cdce7b"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#c1c070"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#c8c778"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#cacb76"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#cecf7b"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#c2c275"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#c6c57a"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#c2c377"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#c1c374"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45v1h-1v-1z",
    fill: "#cdcf76"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#dcde80"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45v1h-1v-1z",
    fill: "#ddde7e"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v1h-1v-1z",
    fill: "#dcdd81"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45h1v1h-1z",
    fill: "#ebed7f"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v1h-1v-1z",
    fill: "#f8fb80"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M106 46v-1h1v1z",
    fill: "#f7f985"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v-1h1v1z",
    fill: "#f7f984"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45v1h-1v-1z",
    fill: "#d7da80"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45h1v1h-1z",
    fill: "#b9bc77"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M111 45h1v1h-1z",
    fill: "#c9cd78"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M112 46v-1h1v1z",
    fill: "#f2f689"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v-1h1v1z",
    fill: "#f8fa8d"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45v1h-1v-1z",
    fill: "#f8f98d"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45h1v1h-1z",
    fill: "#fbfb8f"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M118 46h-1v-1h1z",
    fill: "#c9ce77"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46h-1v-1h1z",
    fill: "#151713"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M122 46v-1h1v1z",
    fill: "#131313",
    fillOpacity: 0.702
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1z",
    fill: "#66c",
    fillOpacity: 0.02
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1z",
    fill: "#947f6a",
    fillOpacity: 0.047
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#bcb536",
    fillOpacity: 0.314
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#bbb225",
    fillOpacity: 0.639
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#bbb225",
    fillOpacity: 0.796
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#c1b726",
    fillOpacity: 0.906
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#c8c028",
    fillOpacity: 0.98
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#d5ce2a"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#dbd328"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#ded22a"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#ded12a"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#dad321"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#e9e547"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#e8ea46"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#e8e947"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#ebe74b"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#ece74b"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#ede84e"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#ece850"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#ebea4f"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#eceb50"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#eceb51"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#ecea51"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#edeb4e"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#eeec50"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#eeed52"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#efed53"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#f0ee54"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#f0ee53"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#f0ef53"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#f0f055"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#f0ef55"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#eff054"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#efef50"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#eeed47"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#f3f04d"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#f3f052"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#f3f151"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#f3f150"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#f2f14f"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#f2f24f"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#f1f04d"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#f3f24f"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#f2f251"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#f2f252"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#f3f352"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#e7e854"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#dcde56"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#dcde55"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#dbde53"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#dddf58"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#dbdd55"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#dadb55"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#dcdc57"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#dedf57"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#dcdc56"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#c2c352"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#abad57"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#b6b659"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#b2b455"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#b3b251"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#c0bf56"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#dadd59"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#dadc5d"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#d4d55f"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1z",
    fill: "#cfce5f"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#d6d65e"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#d4d659"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#d8db5b"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#d8db58"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#d8da5d"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#d7d95b"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1z",
    fill: "#d7da51"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#d7d853"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#d7d855"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#d8d857"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#d8d957"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#d7d957"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M100 47v-1h1v1z",
    fill: "#d6d857"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1z",
    fill: "#d4d856"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47h-1v-1h1z",
    fill: "#d5d656"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46h1v1h-1z",
    fill: "#d6d455"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46v1h-1v-1z",
    fill: "#e5e555"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46h1v1h-1z",
    fill: "#f0f255"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v1h-1v-1z",
    fill: "#eff058"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47v-1h1v1z",
    fill: "#eff059"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M108 46h1v1h-1z",
    fill: "#eff155"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47h-1v-1h1z",
    fill: "#eff25b"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M111 46v1h-1v-1z",
    fill: "#f0f263"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M112 46v1h-1v-1z",
    fill: "#f3f45e"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47h-1v-1h1z",
    fill: "#f0f259"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v1h-1v-1z",
    fill: "#f0f15a"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M115 47h-1v-1h1z",
    fill: "#eff159"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M116 46v1h-1v-1z",
    fill: "#edef54"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v-1h1v1z",
    fill: "#f4f45a"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47h-1v-1h1z",
    fill: "#b9bd59"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46v1h-1v-1z",
    fill: "#14140f"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M123 46v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.663
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#746a1f",
    fillOpacity: 0.094
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#91821e",
    fillOpacity: 0.2
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#9f8c1d",
    fillOpacity: 0.376
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#a6921c",
    fillOpacity: 0.486
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#a68e19",
    fillOpacity: 0.506
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#a58a14",
    fillOpacity: 0.525
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#a69111",
    fillOpacity: 0.51
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#c6b92d",
    fillOpacity: 0.875
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#d4c627"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#d3c424"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#d3c623"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#d3c726"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#d4c727"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#d6c928"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#d7ca28"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#d8cb2a"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#d9cc2a"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#d9cd2b"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#d8cd2b"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#dacf2c"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#dbd02c"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#dbd12d"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#dcd130"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#dcd230"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#ddd331"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#dfd532"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#ded430"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#ded431"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#e0d533"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#e0d632"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#dad22b"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#dfda2a"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#e1de2f"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#e1dc31"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#dfdc32"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#dfdc33"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#e1de34"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#e0dd33"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#e1dd33"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#e1dc34"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#e2dc35"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#e2dc33"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#e2df35"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#e2e138"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#e3e137"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#e3e139"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#e4e13d"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#e5e23a"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#e5e338"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#e4e336"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#e5e33a"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#e8e643"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#afac3b"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#959241"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#a3a23f"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#a7a747"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#b2b045"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#c3c141"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#c5c444"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#9a9543"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#98973f"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#9c9e40"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#9a9b3e"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#b8bc48"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#aeb145"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#a09e44"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#a19e43"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#adab41"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#e6e53d"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#e9e53b"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#e8e53b"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#e9e63c"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#e8e539"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#e7e438"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v1h-1v-1z",
    fill: "#e6e43c"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M103 48v-1h1v1z",
    fill: "#e4e441"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M104 48v-1h1v1z",
    fill: "#e1e13f"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M106 47v1h-1v-1z",
    fill: "#dfde3d"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h-1v-1h1z",
    fill: "#dedf3d"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47h1v1h-1z",
    fill: "#dfe041"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M109 47v1h-1v-1z",
    fill: "#dedf3f"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M109 48v-1h1v1z",
    fill: "#dfdf3c"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48v-1h1v1z",
    fill: "#e0e040"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h-1v-1h1z",
    fill: "#e0e042"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47v1h-1v-1z",
    fill: "#e1e045"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48h-1v-1h1z",
    fill: "#e0e043"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48h-1v-1h1z",
    fill: "#dedf42"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v1h-1v-1z",
    fill: "#dddd45"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47h1v1h-1z",
    fill: "#e3e547"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47v1h-1v-1z",
    fill: "#9a9d49"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v-1h1v1z",
    fill: "#171818"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M122 47v1h-1v-1z",
    fill: "#181717"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M123 47v1h-1v-1z",
    fill: "#181616",
    fillOpacity: 0.525
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#a09127",
    fillOpacity: 0.255
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#ac951a",
    fillOpacity: 0.569
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#b09114",
    fillOpacity: 0.596
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#b29217",
    fillOpacity: 0.6
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#b39319",
    fillOpacity: 0.596
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#b5941a",
    fillOpacity: 0.612
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#b59519",
    fillOpacity: 0.663
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#b29718",
    fillOpacity: 0.706
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#b39718",
    fillOpacity: 0.725
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#b49919",
    fillOpacity: 0.741
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#b59b1a",
    fillOpacity: 0.753
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#b49c1a",
    fillOpacity: 0.769
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#b59c19",
    fillOpacity: 0.792
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#b69f18",
    fillOpacity: 0.816
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#b7a017",
    fillOpacity: 0.835
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#b8a017",
    fillOpacity: 0.851
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#b8a119",
    fillOpacity: 0.871
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#bba419",
    fillOpacity: 0.875
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#bba416",
    fillOpacity: 0.882
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#bca417",
    fillOpacity: 0.886
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#bea619",
    fillOpacity: 0.886
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#c0a719",
    fillOpacity: 0.894
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#c0a615",
    fillOpacity: 0.922
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#bba10f",
    fillOpacity: 0.941
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#c9b417"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#cebc12"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#cbb80e"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#ceba0f"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#cfbb11"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#cebc14"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#ccbb15"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#cdbc15"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#ccbb14"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#cabb12"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#c6b812"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#c6b819"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#c7b81a"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#c5b815"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#c7b917"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#c8bb18"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#c9bc18"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#cabc18"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#b9ac1c"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#bdb527"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#b4aa29"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#aca32b"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#aca530"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#b5ae28"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#afa72b"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#98922c"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#aaa22f"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#a29a33"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1z",
    fill: "#9b942f"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#ada536"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#918b2c"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#a19c2c"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#a89f29"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#b2a529"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#d1c621"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#d3c81e"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#d3c922"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1z",
    fill: "#d4c820"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#d2c821"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1z",
    fill: "#cfc623"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M105 48v1h-1v-1z",
    fill: "#ccc327"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49v-1h1v1z",
    fill: "#cbc329"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48v1h-1v-1z",
    fill: "#cec429"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h1v1h-1z",
    fill: "#cdc32b"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M109 49h-1v-1h1z",
    fill: "#cbc428"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M110 49h-1v-1h1z",
    fill: "#cbc426"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48h1v1h-1z",
    fill: "#cbc32b"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h1v1h-1z",
    fill: "#cac429"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48v1h-1v-1z",
    fill: "#c9c22f"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49h-1v-1h1z",
    fill: "#c8be33"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M117 48v1h-1v-1z",
    fill: "#ccc638"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M117 49v-1h1v1z",
    fill: "#65612a"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v1h-1v-1z",
    fill: "#020305"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49v-1h1v1z",
    fill: "#060707",
    fillOpacity: 0.988
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49h-1v-1h1z",
    fill: "#0a0708",
    fillOpacity: 0.89
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M123 48v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.18
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fillOpacity: 0.027
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fillOpacity: 0.031
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#1c0000",
    fillOpacity: 0.035
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#300",
    fillOpacity: 0.039
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#551500",
    fillOpacity: 0.047
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#713800",
    fillOpacity: 0.071
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#794d00",
    fillOpacity: 0.09
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#b2951a",
    fillOpacity: 0.341
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#b89a11",
    fillOpacity: 0.706
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#bc9812",
    fillOpacity: 0.906
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#c19a12",
    fillOpacity: 0.878
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#c39c11",
    fillOpacity: 0.867
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#c39d12",
    fillOpacity: 0.875
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#c29c12",
    fillOpacity: 0.914
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#c19b15",
    fillOpacity: 0.98
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#c39c17"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#c19b14"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#c09a12"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#bf9a0f"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#bd9911"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#ba9916"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#b79617"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#b09216"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#aa8c18"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#ad901c"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#ac921a"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#ac9019"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#b09218"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#b19418"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1z",
    fill: "#b3971a"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#b29619"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#b99d17"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#bba21a"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#ae9421"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#998122"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#8a7421"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#8c771e"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#917c22"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#927a22"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#9d861c"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#a58f24"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#947e21"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#958021"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#a18920"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#b59c1e"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#c1a61c"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#bea31a"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#bca119"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#bea51a"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#bca419"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#bda51d"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#bda41f"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#bda320"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50v-1h1v1z",
    fill: "#bda31f"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#bda31e"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1z",
    fill: "#bea51b"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h1v1h-1z",
    fill: "#bda61b"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M104 50v-1h1v1z",
    fill: "#baa31b"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M106 49v1h-1v-1z",
    fill: "#bba31d"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50v-1h1v1z",
    fill: "#bba31f"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M108 49v1h-1v-1z",
    fill: "#baa31f"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50h-1v-1h1z",
    fill: "#baa51e"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v-1h1v1z",
    fill: "#bba51d"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M110 50v-1h1v1z",
    fill: "#bba621"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50v-1h1v1z",
    fill: "#bca622"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M113 50h-1v-1h1z",
    fill: "#bca51e"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M113 49h1v1h-1z",
    fill: "#bba51f"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M114 49h1v1h-1z",
    fill: "#b7a221"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49v1h-1v-1z",
    fill: "#b8a124"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M116 50v-1h1v1z",
    fill: "#ad9d2e",
    fillOpacity: 0.906
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M118 50h-1v-1h1z",
    fill: "#332a0e",
    fillOpacity: 0.471
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h-1v-1h1z",
    fillOpacity: 0.329
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M119 49h1v1h-1z",
    fill: "#080804",
    fillOpacity: 0.235
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M121 49v1h-1v-1z",
    fill: "#050505",
    fillOpacity: 0.188
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49v1h-1v-1z",
    fill: "#090909",
    fillOpacity: 0.102
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#b9b9a2",
    fillOpacity: 0.043
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#e6d6a6",
    fillOpacity: 0.522
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#e9d49d",
    fillOpacity: 0.592
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#e8d39b",
    fillOpacity: 0.58
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#e8d39b",
    fillOpacity: 0.573
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#e8d19a",
    fillOpacity: 0.569
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#e6d199",
    fillOpacity: 0.569
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#e7d29b",
    fillOpacity: 0.561
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#e7d199",
    fillOpacity: 0.553
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#e6d099",
    fillOpacity: 0.541
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#e6d097",
    fillOpacity: 0.533
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#e6d199",
    fillOpacity: 0.529
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#e9d297",
    fillOpacity: 0.522
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#e7d296",
    fillOpacity: 0.518
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#e9d39a",
    fillOpacity: 0.506
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#e7cf98",
    fillOpacity: 0.506
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#e5cd97",
    fillOpacity: 0.502
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#e6d097",
    fillOpacity: 0.494
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#e6d09b",
    fillOpacity: 0.49
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#e0cc96",
    fillOpacity: 0.49
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#d6be88",
    fillOpacity: 0.588
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#edd18f",
    fillOpacity: 0.929
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#efd58e",
    fillOpacity: 0.914
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#eed58f",
    fillOpacity: 0.91
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#edd48f",
    fillOpacity: 0.914
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#ebd18c",
    fillOpacity: 0.941
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#e7cc86",
    fillOpacity: 0.988
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#e7cc84"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#e6cc82"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#e6cb80"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#e6c97d"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#e7cc7e"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#d9c479"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#d9c481"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#cdb579"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#c8b079"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#d4bd82"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#d8c285"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#bea771"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#c7b073"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#d9c27e"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#dac182"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#d9c081"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#ddc481"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#dfc57d"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#d9bf7d"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#d8c080"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#d6c17d"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#cbb779"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#bca56b"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#c4ab6c"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#dbc17d"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1z",
    fill: "#d9c078"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#d3bb7f"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#d1bc78"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#d8c37c"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#d7c077"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#d7bf78"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#d4bc79"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#d2bb77"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#d5be79"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#d1ba74"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#d0ba75"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#cfb976"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51h-1v-1h1z",
    fill: "#cfb877"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50v1h-1v-1z",
    fill: "#ceb876"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h-1v-1h1z",
    fill: "#cdb674"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1z",
    fill: "#d1ba73"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#d4bc73"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h-1v-1h1z",
    fill: "#d1ba72"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51v-1h1v1z",
    fill: "#d0b873"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51h-1v-1h1z",
    fill: "#d0b972"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M108 51h-1v-1h1z",
    fill: "#d0b970"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v1h-1v-1z",
    fill: "#d1ba70"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M110 51h-1v-1h1z",
    fill: "#d2bb70"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M111 51h-1v-1h1z",
    fill: "#d2bb6e"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50h1v1h-1z",
    fill: "#d4ba6d"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v-1h1v1z",
    fill: "#d6bb6f"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50v1h-1v-1z",
    fill: "#d4ba71"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50h1v1h-1z",
    fill: "#d0b870"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51v-1h1v1z",
    fill: "#d0b96f"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h-1v-1h1z",
    fill: "#cbb977",
    fillOpacity: 0.878
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51v-1h1v1z",
    fill: "#ded4a2",
    fillOpacity: 0.518
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50v1h-1v-1z",
    fill: "#ffffc2",
    fillOpacity: 0.082
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#f1deb0",
    fillOpacity: 0.153
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#ecddac",
    fillOpacity: 0.267
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#efdfac",
    fillOpacity: 0.376
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#eedeae",
    fillOpacity: 0.498
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#f0e2ad",
    fillOpacity: 0.627
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1z",
    fill: "#f0e2aa",
    fillOpacity: 0.639
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#ede1a8",
    fillOpacity: 0.639
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#ecdea5",
    fillOpacity: 0.647
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#eadba6",
    fillOpacity: 0.733
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#fff1b3"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#fff0b0"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#fff0ae"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#ffefb1"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#fff0b3"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#ffefb2"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#fff0b2"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#fff0b1"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#ffeeae"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#ffeeaf"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#ffefaf"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#ffecad"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#ffeeac"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#fae7a6"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#fceaac"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#fdecae"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#fdebaf"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#fde9ae"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#fde9ad"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#fde9ac"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#fcebab"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1z",
    fill: "#dcd09f"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#867d6b"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#78705f"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#9b947c"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#5f5e51"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#b3af8b"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#fbeeb8"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#ada07c"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#cfc499"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#c3b691"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#e1d5a9"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#b3a884"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#c6be96"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#bcb18c"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#cec39a"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#afa482"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#e6daac"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#bbaf89"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#e1d4aa"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#f3e6ad"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#cfc197"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M88 52h-1v-1h1z",
    fill: "#dbcda3"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#c8bb93"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#d6c99c"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#c2b590"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#cdbf97"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1z",
    fill: "#c9bc93"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#cfc595"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#ecdea9"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#d5c494"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#fdedb3"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#ffedb0"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#feedb1"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51v1h-1v-1z",
    fill: "#feeeaf"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52h-1v-1h1z",
    fill: "#feedae"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v-1h1v1z",
    fill: "#feedaf"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1z",
    fill: "#fcedaf"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M103 52v-1h1v1z",
    fill: "#fcedb0"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h1v1h-1z",
    fill: "#fbecb1"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M107 52v-1h1v1z",
    fill: "#fbecae"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M111 52h-1v-1h1z",
    fill: "#fbedaf"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v1h-1v-1z",
    fill: "#fbeeb1"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h-1v-1h1z",
    fill: "#fcefb3"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M113 51h1v1h-1z",
    fill: "#faecb1"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M114 51h1v1h-1z",
    fill: "#faecb0"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51h1v1h-1z",
    fill: "#f9eaaf"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52v-1h1v1z",
    fill: "#f6e8ac"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h1v1h-1z",
    fill: "#f9eeac"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51v1h-1v-1z",
    fill: "#a9a07e",
    fillOpacity: 0.867
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51h1v1h-1z",
    fill: "#1c1e1a",
    fillOpacity: 0.8
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52h-1v-1h1z",
    fill: "#1f2220",
    fillOpacity: 0.792
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v-1h1v1z",
    fill: "#1e2220",
    fillOpacity: 0.765
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M123 51v1h-1v-1z",
    fill: "#242624",
    fillOpacity: 0.678
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#aa7f55",
    fillOpacity: 0.024
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#dd9044",
    fillOpacity: 0.118
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1z",
    fill: "#f19c35",
    fillOpacity: 0.224
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#f29f26",
    fillOpacity: 0.314
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#e8a84f",
    fillOpacity: 0.392
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#f4e9b4",
    fillOpacity: 0.78
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#f9ebbf",
    fillOpacity: 0.961
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#f8eebd"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#fcf3be"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#fff4c0"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#fff3bf"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#fef2c5"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#fff5c8"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#fff1bc"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#f9ebbb"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#fbf0c1"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#f9eebc"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#faedbc"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#faeeba"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#f9edba"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#f9ebb9"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#f9ecb8"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#f9ebb8"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#faecb7"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#f4e3ac"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#f7e4a9"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#f7e5aa"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#f7e6ac"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#f8e7ac"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#f7e6ab"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#f8e5a9"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#f7e4a7"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#f7e4a6"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#f8e4a7"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#f9e7a8"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#cec093"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#857b67"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#bbb191"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#d9ce9e"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#938d7a"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#8c836d"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#eadbaa"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#b0a583"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#cabd9c"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#a69a82"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#aea688"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#958e7a"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1z",
    fill: "#a49d85"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#9e967a"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#b7b190"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#867e6f"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#c9bc97"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#bdb08f"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#d1c59e"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#dfd1a3"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#a69b82"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#a89d89"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#b4ab8c"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#bdb397"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#b1a887"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#c3b89a"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#a49882"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#b0a98b"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#cec3a1"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#ae9f83"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#e6d8a7"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#f6e7a8"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M100 53h-1v-1h1z",
    fill: "#f6e6ac"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v1h-1v-1z",
    fill: "#f5e5aa"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#f5e5ad"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M106 53v-1h1v1z",
    fill: "#f4e5ab"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53h-1v-1h1z",
    fill: "#f3e4a9"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M110 53v-1h1v1z",
    fill: "#eddca8"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h-1v-1h1z",
    fill: "#e6d7a7"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M112 52h1v1h-1z",
    fill: "#e7daa7"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h1v1h-1z",
    fill: "#efe3aa"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M114 52h1v1h-1z",
    fill: "#f2e4a7"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52v1h-1v-1z",
    fill: "#f0e3ad"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53h-1v-1h1z",
    fill: "#ede3a6"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M118 52v1h-1v-1z",
    fill: "#f2e8af"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53h-1v-1h1z",
    fill: "#c4bb95"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M120 53h-1v-1h1z",
    fill: "#1c1b17"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M122 52v1h-1v-1z",
    fill: "#16191a"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M123 52h1v1h-1z",
    fill: "#1f1d1a",
    fillOpacity: 0.573
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1z",
    fill: "#bf844d",
    fillOpacity: 0.22
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#d57823",
    fillOpacity: 0.678
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#e57c15",
    fillOpacity: 0.898
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#e87c09",
    fillOpacity: 0.992
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#ea8925"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#f8e0a0"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#f8e4b2"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#f1e3b1"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#f3e1b3"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#f4e3b2"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#f1e0aa"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#eedba5"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#f1dca6"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#efda9d"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#e9d6a0"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#f2e2ad"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#f3e2a9"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#f4e2a9"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#f5e3aa"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#f4e1a9"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#f5e1ab"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#f6e2ac"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#f4e3aa"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#f5e3ab"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#f6e3ad"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#f6e4ae"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#f6e4b0"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#f5e4af"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#efdca2"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#f1dda1"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#f3dea0"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#f3dea1"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#f4dda1"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#f3dc9f"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#f4dca1"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#f2dda6"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#eedaa5"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#f6e2aa"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#f8e2a4"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#edd9a4"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#f0ddaa"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#f2dea4"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#e5d3a4"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#ead7a9"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#f1e1b1"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#e3d5a4"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#e0d2a5"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#e8dab1"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#e3d3a3"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#e6d5a9"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#e6d5ad"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#edddb1"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#f5e8bd"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#e1d6ab"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#e3d6ab"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#eee0b8"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#e5d7af"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#e2d2ac"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#efe2bb"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#e6dab3"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#eadeb8"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#dfd4af"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#e0d6b1"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#e3d7b5"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#ded2b1"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#e7dcb7"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#f8edc0"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#f9edc1"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53h1v1h-1z",
    fill: "#f9edc3"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v-1h1v1z",
    fill: "#f7ecc1"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53v1h-1v-1z",
    fill: "#f8ecc3"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54v-1h1v1z",
    fill: "#f9edc6"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h-1v-1h1z",
    fill: "#f9eec6"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53v1h-1v-1z",
    fill: "#f8edc6"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54v-1h1v1z",
    fill: "#f8eec6"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54h-1v-1h1z",
    fill: "#f8eec7"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53v1h-1v-1z",
    fill: "#f8edc8"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M109 54h-1v-1h1z",
    fill: "#f8edc5"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54h-1v-1h1z",
    fill: "#f8efc7"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54v-1h1v1z",
    fill: "#cbc3a7"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53v1h-1v-1z",
    fill: "#b8b4a2"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h1v1h-1z",
    fill: "#b4b09f"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53v1h-1v-1z",
    fill: "#dad3b9"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53h1v1h-1z",
    fill: "#f9f2cd"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54h-1v-1h1z",
    fill: "#f7f1cd"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53v1h-1v-1z",
    fill: "#f7f1c9"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53h1v1h-1z",
    fill: "#f8f3ce"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53v1h-1v-1z",
    fill: "#d5d0b4"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v-1h1v1z",
    fill: "#1c1a15"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M121 54h-1v-1h1z",
    fill: "#0e0d0f"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M121 53h1v1h-1z",
    fill: "#111112"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M123 54h-1v-1h1z",
    fill: "#171617"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M124 53v1h-1v-1z",
    fill: "#1e1d1b",
    fillOpacity: 0.753
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v1h-1v-1z",
    fill: "#963",
    fillOpacity: 0.02
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h-1v-1h1z",
    fill: "#bc5e25",
    fillOpacity: 0.106
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#c35115",
    fillOpacity: 0.184
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#ba5923",
    fillOpacity: 0.278
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#c19f68",
    fillOpacity: 0.584
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#b89964",
    fillOpacity: 0.839
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#b69d68",
    fillOpacity: 0.976
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1z",
    fill: "#c3a775"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#ceb07b"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#d5b67e"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#d5b87c"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#d3b77a"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#d1b379"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#d2b47d"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#e3c98c"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#e0c78c"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#e1c88c"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#e2c98e"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#e3c98e"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#e4c98d"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#e5ca8e"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#e5cb90"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#e6cb90"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#e4cc8e"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#e5cd8f"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#e5cd91"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#e6cd91"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#e5cd92"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#e5cc92"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#e6ce93"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#e7ce94"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#e7ce95"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#e7cf95"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#e9cf96"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#e9ce93"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#e3c98a"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#eacf91"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#e8cf90"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#e7cf8f"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#e8d090"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#e9d190"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#ebd291"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#ebd292"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#ebd393"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#ecd396"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#ebd695"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#edd892"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M73 54v1h-1v-1z",
    fill: "#dfc993"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#99876a"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#a89d79"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#b3a581"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#c8b587"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#d8c491"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#b4a67d"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#cfbe93"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#bcaa83"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#c6b68b"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#c9b98c"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#cfbd8e"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#c2af88"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#ab9c7b"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#d3c196"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#d7c194"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#e4cf9a"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#ccb88b"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#ddc99b"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#deca98"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1z",
    fill: "#e3d09f"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#dac99a"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#cbba90"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#ead49c"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#f1d799"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#edd59c"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1z",
    fill: "#edd69d"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v1h-1v-1z",
    fill: "#eed59e"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h-1v-1h1z",
    fill: "#efd7a0"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54v1h-1v-1z",
    fill: "#efd9a1"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h1v1h-1z",
    fill: "#eed8a0"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54h1v1h-1z",
    fill: "#edd9a1"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54v1h-1v-1z",
    fill: "#ecdaa2"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54v1h-1v-1z",
    fill: "#ebd9a4"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54h1v1h-1z",
    fill: "#ebdaa3"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55v-1h1v1z",
    fill: "#ecdda6"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55v-1h1v1z",
    fill: "#b3a885"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M111 55v-1h1v1z",
    fill: "#9c9786"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M113 54v1h-1v-1z",
    fill: "#97917b"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55h-1v-1h1z",
    fill: "#c8be96"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M114 54h1v1h-1z",
    fill: "#efe1ae"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54v1h-1v-1z",
    fill: "#efdfae"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M117 55h-1v-1h1z",
    fill: "#f0dfae"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M118 54v1h-1v-1z",
    fill: "#f2e2af"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v1h-1v-1z",
    fill: "#cfc5a0"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M120 55h-1v-1h1z",
    fill: "#1c1b15"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M121 54v1h-1v-1z",
    fill: "#0c0d0e"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M123 55v-1h1v1z",
    fill: "#191917",
    fillOpacity: 0.78
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1z",
    fill: "#333319",
    fillOpacity: 0.039
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1z",
    fill: "#776243",
    fillOpacity: 0.192
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#7e6a4b",
    fillOpacity: 0.412
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56v-1h1v1z",
    fill: "#867152",
    fillOpacity: 0.58
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#8e7759",
    fillOpacity: 0.718
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#8d7858",
    fillOpacity: 0.749
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#8c7859",
    fillOpacity: 0.769
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#8b7357",
    fillOpacity: 0.753
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#a18861",
    fillOpacity: 0.757
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#c1a874"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#c1a26f"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#c2a371"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#c4a672"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#c5a773"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#c6a873"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#c7a973"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#c6ab73"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#c7ab74"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#c9ac75"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#c9ac74"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#ccae77"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#ccaf78"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#cdaf79"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#ceaf78"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#ccad74"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#cbab70"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#d7b679"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#d2b374"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#d4b476"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#d4b577"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#d5b577"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#d5b678"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#d5b778"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#d6b879"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#d7b97a"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#d9bb7c"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#d9bc80"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#dabd82"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#c9ae7b"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#95825f"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#978665"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#89775d"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#a38f6f"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#aa9770"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#7d7053"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#97876a"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#8f7e5e"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#847657"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#7b6d53"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#aa9672"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#a08c69"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#8a7d60"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#756650"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1z",
    fill: "#84735a"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#b3a376"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#88775a"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#86765d"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#918367"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#86795d"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#7a6d53"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#7c6f58"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#c1ac7c"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#e5c787"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#e0c686"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56v-1h1v1z",
    fill: "#e0c788"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h1v1h-1z",
    fill: "#e1c888"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56h-1v-1h1z",
    fill: "#e0c888"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56v-1h1v1z",
    fill: "#dfc888"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M107 56h-1v-1h1z",
    fill: "#e1c887"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M108 55v1h-1v-1z",
    fill: "#e3c68a"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56v-1h1v1z",
    fill: "#e3c78a"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55h1v1h-1z",
    fill: "#e3ca8d"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M111 56h-1v-1h1z",
    fill: "#d0bc88"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55v1h-1v-1z",
    fill: "#b6a578"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55h1v1h-1z",
    fill: "#c2af7f"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55v1h-1v-1z",
    fill: "#dfc88f"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v-1h1v1z",
    fill: "#e3cb8c"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M115 56v-1h1v1z",
    fill: "#e0cb8c"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M117 55v1h-1v-1z",
    fill: "#e0cb8a"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56v-1h1v1z",
    fill: "#e3ce8d"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M119 55v1h-1v-1z",
    fill: "#bcad81"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v-1h1v1z",
    fill: "#191814"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M124 55v1h-1v-1z",
    fill: "#141413",
    fillOpacity: 0.729
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#7f7f66",
    fillOpacity: 0.078
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#8e8167",
    fillOpacity: 0.678
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#8e7a62",
    fillOpacity: 0.773
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#907c64",
    fillOpacity: 0.784
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#8e7b64",
    fillOpacity: 0.843
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#8e7c65",
    fillOpacity: 0.886
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#8d7d65",
    fillOpacity: 0.898
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#8f7f67",
    fillOpacity: 0.902
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#8f8066",
    fillOpacity: 0.914
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#908167",
    fillOpacity: 0.922
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#918168",
    fillOpacity: 0.929
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#938269",
    fillOpacity: 0.937
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#938368",
    fillOpacity: 0.949
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#948469",
    fillOpacity: 0.961
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#96846a",
    fillOpacity: 0.969
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#968469",
    fillOpacity: 0.976
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#958468",
    fillOpacity: 0.98
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#978669",
    fillOpacity: 0.984
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#988569",
    fillOpacity: 0.988
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#9b8769",
    fillOpacity: 0.992
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#9b886a"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#9d8b6b"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#9e8d6d"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#9d8a6b"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#a68f6b"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#b69c70"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#b2986a"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#b4996b"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#b3986a"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#b29769"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#b19768"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#b39969"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#b59b6a"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#b69d68"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57h-1v-1h1z",
    fill: "#b69c6a"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#b89c6a"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#b59d69"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#a8986b"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#b39d6e"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#b09b6f"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#b29b6c"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#b19c6e"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#af986c"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#ad966e"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#ab966f"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#b0996c"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#b59e72"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#aa956d"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1z",
    fill: "#b49e6f"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#b8a06c"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#b19869"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#b59c6c"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#b59c6f"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#ae966a"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#ae9769"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#bda16b"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#c5a470"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#c5a371"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M99 57h-1v-1h1z",
    fill: "#c4a56d"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56v1h-1v-1z",
    fill: "#c4a56c"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-1h1z",
    fill: "#c6a76f"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M103 56h1v1h-1z",
    fill: "#c6a66f"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M104 57v-1h1v1z",
    fill: "#c5a66e"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57h-1v-1h1z",
    fill: "#c5a76f"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v-1h1v1z",
    fill: "#c4a96f"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M107 57v-1h1v1z",
    fill: "#c4a971"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56h1v1h-1z",
    fill: "#c5aa70"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M109 56h1v1h-1z",
    fill: "#c3ad6f"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M110 56h1v1h-1z",
    fill: "#c4af73"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M112 56v1h-1v-1z",
    fill: "#c9b173"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M112 57v-1h1v1z",
    fill: "#cab273"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v1h-1v-1z",
    fill: "#c9b172"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M114 57v-1h1v1z",
    fill: "#c7b072"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M116 57h-1v-1h1z",
    fill: "#c5ae75"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M116 56h1v1h-1z",
    fill: "#c5af73"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56h1v1h-1z",
    fill: "#c9b379"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v1h-1v-1z",
    fill: "#998863"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v-1h1v1z",
    fill: "#1f1d1b"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M121 57v-1h1v1z",
    fill: "#1d1e1a"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M122 57v-1h1v1z",
    fill: "#1f1f1f"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M124 57h-1v-1h1z",
    fill: "#1e1e1c",
    fillOpacity: 0.533
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#170000",
    fillOpacity: 0.043
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#271313",
    fillOpacity: 0.051
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#3c2d2d",
    fillOpacity: 0.067
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#3f3333",
    fillOpacity: 0.078
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#423737",
    fillOpacity: 0.09
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#553f3f",
    fillOpacity: 0.094
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#51483f",
    fillOpacity: 0.11
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#5a4b43",
    fillOpacity: 0.133
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#575049",
    fillOpacity: 0.149
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#5b4e48",
    fillOpacity: 0.165
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#605549",
    fillOpacity: 0.176
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#63584d",
    fillOpacity: 0.18
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#645a4a",
    fillOpacity: 0.188
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#665d4e",
    fillOpacity: 0.204
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#6b5d50",
    fillOpacity: 0.224
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#6c6152",
    fillOpacity: 0.267
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#686255",
    fillOpacity: 0.306
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#665c4c",
    fillOpacity: 0.314
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#786b5a",
    fillOpacity: 0.455
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#938670",
    fillOpacity: 0.773
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#8d8168",
    fillOpacity: 0.812
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#8f8169",
    fillOpacity: 0.824
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#8e816a",
    fillOpacity: 0.843
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#8e8169",
    fillOpacity: 0.851
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#8e8069",
    fillOpacity: 0.863
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#8b7e67",
    fillOpacity: 0.922
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#857963"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#847862"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#7b6d58"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#796953"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#7a6b52"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#7d6e54"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#7e6f56"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#83735c"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#86755e"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#7e6e5b"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#5d5246"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#5b5548"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#605a4b"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#61594b"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#645b4c"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#665e4d"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#615746"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#786d58"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#6c604e"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#695f4f"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#5f5446"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#706556"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#726552"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#796950"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h-1v-1h1z",
    fill: "#928062"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#9b886b"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#9f8c6d"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#9f8b68"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#988461"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#998460"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#9a8562"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#9b8564"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#9c8461"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M99 58h-1v-1h1z",
    fill: "#9b8560"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58h-1v-1h1z",
    fill: "#9b8661"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M101 57v1h-1v-1z",
    fill: "#9c8763"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58v-1h1v1z",
    fill: "#9e8965"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57v1h-1v-1z",
    fill: "#a18e6a"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h1v1h-1z",
    fill: "#a18f6b"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M105 58h-1v-1h1z",
    fill: "#a3906c"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v1h-1v-1z",
    fill: "#a4906d"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58h-1v-1h1z",
    fill: "#a3926c"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58h-1v-1h1z",
    fill: "#a2936c"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58v-1h1v1z",
    fill: "#a3936c"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M110 57v1h-1v-1z",
    fill: "#a3946b"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M110 58v-1h1v1z",
    fill: "#a2946a"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M112 58h-1v-1h1z",
    fill: "#a5956a"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h-1v-1h1z",
    fill: "#a5956b"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58v-1h1v1z",
    fill: "#a6956d"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M115 57v1h-1v-1z",
    fill: "#a5946b"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M116 58h-1v-1h1z",
    fill: "#a39166"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h-1v-1h1z",
    fill: "#9f895c"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M118 57v1h-1v-1z",
    fill: "#9c8758"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v1h-1v-1z",
    fill: "#584c35",
    fillOpacity: 0.984
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58h-1v-1h1z",
    fill: "#070606",
    fillOpacity: 0.918
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58v-1h1v1z",
    fill: "#0c0b0b",
    fillOpacity: 0.902
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58v-1h1v1z",
    fill: "#0c0b09",
    fillOpacity: 0.902
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M123 57v1h-1v-1z",
    fill: "#0e0e0e",
    fillOpacity: 0.784
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M123 58v-1h1v1z",
    fill: "#161616",
    fillOpacity: 0.133
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#bcd2dd",
    fillOpacity: 0.09
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#b3cede",
    fillOpacity: 0.184
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#b5d1d7",
    fillOpacity: 0.176
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#b7cfdb",
    fillOpacity: 0.169
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#b9d6dc",
    fillOpacity: 0.173
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#b1d2d8",
    fillOpacity: 0.18
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#adc8d9",
    fillOpacity: 0.184
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#abc7d8",
    fillOpacity: 0.18
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#afccd7",
    fillOpacity: 0.176
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#adcadc",
    fillOpacity: 0.173
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#b0ced4",
    fillOpacity: 0.165
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#b2ccd8",
    fillOpacity: 0.157
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#a5c5d2",
    fillOpacity: 0.157
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#a3c4d7",
    fillOpacity: 0.153
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#a2c6d4",
    fillOpacity: 0.141
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#aac8d8",
    fillOpacity: 0.129
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#a7c1d3",
    fillOpacity: 0.114
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#aac3d4",
    fillOpacity: 0.235
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#bcd7e5",
    fillOpacity: 0.588
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#adccd7",
    fillOpacity: 0.612
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#aac5cf",
    fillOpacity: 0.612
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#a8c1cc",
    fillOpacity: 0.616
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#a5beca",
    fillOpacity: 0.624
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#a4bdc8",
    fillOpacity: 0.627
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#a3bac5",
    fillOpacity: 0.643
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#91a6ae",
    fillOpacity: 0.769
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#798c92",
    fillOpacity: 0.996
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#798b92"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#546369"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#4f585c"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#444e51"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#4c5658"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#3b4646"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#545e5e"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#505c5d"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#445153"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#424d50"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#333b3f"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#3e464b"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#3c4448"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#40494e"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#525d64"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#4e585d"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#3e4649"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#363e3e"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#363c3c"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#3f4445"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#4f5452"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#464a46"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1z",
    fill: "#383d3c"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#444a4a"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#68706d"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#6b7470"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#616966"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#505553"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#4c524e"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#515551"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#4e534e"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#525752"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#555954"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M97 59v-1h1v1z",
    fill: "#575a55"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M98 58h1v1h-1z",
    fill: "#54564f"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58v1h-1v-1z",
    fill: "#52534b"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M100 59v-1h1v1z",
    fill: "#54554e"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1z",
    fill: "#565850"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58h1v1h-1z",
    fill: "#55584f"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M103 58h1v1h-1z",
    fill: "#595d53"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M105 59h-1v-1h1z",
    fill: "#696c62"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59h-1v-1h1z",
    fill: "#6f7369"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58v1h-1v-1z",
    fill: "#6f7469"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59v-1h1v1z",
    fill: "#707569"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M108 59v-1h1v1z",
    fill: "#66685e"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M110 59h-1v-1h1z",
    fill: "#5d5c53"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M111 58v1h-1v-1z",
    fill: "#5a594f"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h-1v-1h1z",
    fill: "#656559"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59v-1h1v1z",
    fill: "#77786b"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h1v1h-1z",
    fill: "#797a6e"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M114 58h1v1h-1z",
    fill: "#7a7c6f"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M116 59h-1v-1h1z",
    fill: "#76786d",
    fillOpacity: 0.996
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58v1h-1v-1z",
    fill: "#6f6a59",
    fillOpacity: 0.851
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h1v1h-1z",
    fill: "#60533b",
    fillOpacity: 0.671
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M119 58v1h-1v-1z",
    fill: "#3d3125",
    fillOpacity: 0.243
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M121 59h-1v-1h1z",
    fill: "#0c0c0c",
    fillOpacity: 0.078
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58h1v1h-1z",
    fill: "#190c0c",
    fillOpacity: 0.078
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M122 59v-1h1v1z",
    fill: "#1f1f1f",
    fillOpacity: 0.031
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60v-1h1v1z",
    fill: "#ccd8e5",
    fillOpacity: 0.078
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#c3e1e7",
    fillOpacity: 0.169
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60v-1h1v1z",
    fill: "#b9d9e4",
    fillOpacity: 0.188
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#bcdbe5",
    fillOpacity: 0.196
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#b6d3dd",
    fillOpacity: 0.208
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#b9d9e2",
    fillOpacity: 0.318
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#c9e9f4",
    fillOpacity: 0.875
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#c7eaf7",
    fillOpacity: 0.984
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#c4e7f4",
    fillOpacity: 0.984
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#c3e7f4",
    fillOpacity: 0.98
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#c3e7f3",
    fillOpacity: 0.984
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#c3e7f3",
    fillOpacity: 0.988
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#c4e6f4",
    fillOpacity: 0.984
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#c4e6f3",
    fillOpacity: 0.984
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#c3e5f1",
    fillOpacity: 0.984
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#c3e6f2",
    fillOpacity: 0.98
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#c3e6f1",
    fillOpacity: 0.984
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#c2e6f1",
    fillOpacity: 0.98
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#c1e5f1",
    fillOpacity: 0.98
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#c0e5f1",
    fillOpacity: 0.98
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#c0e5f0",
    fillOpacity: 0.98
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#c0e4f0",
    fillOpacity: 0.98
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#c0e3ef",
    fillOpacity: 0.976
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#c1e3f0",
    fillOpacity: 0.969
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#bfe1ee",
    fillOpacity: 0.965
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#bbdfec",
    fillOpacity: 0.984
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#cff6ff"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#d1f7ff"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#cef4ff"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#b0d3e0"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#a7c7d4"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#c1e2ef"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#c8e9f7"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#c2e3f1"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#c6e9f7"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#c5e8f5"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#c0e4f1"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#bee2ed"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#b8dde8"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#bce1ec"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#a8ccd7"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#9abec9"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#93b3c1"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#91b1bf"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#8dacba"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#88a7b5"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#a3c5d3"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#94b6c5"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#8fb1c0"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#8aa9ba"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#7997a5"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1z",
    fill: "#8aa8b6"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#c2e2ef"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#c5e6f2"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#b9d8e6"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#8aa7b5"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#85a2ae"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#87a4b0"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#8facb6"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#8aa7b1"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#95b3bc"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#87a4ad"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M99 59v1h-1v-1z",
    fill: "#84a1ac"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M100 60h-1v-1h1z",
    fill: "#819da9"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M101 59v1h-1v-1z",
    fill: "#829eaa"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M102 60h-1v-1h1z",
    fill: "#7f9ba7"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60h-1v-1h1z",
    fill: "#97b2bd"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60v-1h1v1z",
    fill: "#a6c2cc"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60v-1h1v1z",
    fill: "#b1d0d9"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59v1h-1v-1z",
    fill: "#b5d4dd"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M107 60h-1v-1h1z",
    fill: "#b3d3dc"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59h1v1h-1z",
    fill: "#b3d2db"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M109 59v1h-1v-1z",
    fill: "#aac6d0"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v-1h1v1z",
    fill: "#8ea8b3"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v-1h1v1z",
    fill: "#8ba3ae"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M111 60v-1h1v1z",
    fill: "#9cb4be"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h1v1h-1z",
    fill: "#b2ccd5"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M113 59h1v1h-1z",
    fill: "#afcbd3"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M114 59h1v1h-1z",
    fill: "#adc9d2"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M115 59h1v1h-1z",
    fill: "#adc8d2",
    fillOpacity: 0.996
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M117 60h-1v-1h1z",
    fill: "#b3cad2",
    fillOpacity: 0.769
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M118 59v1h-1v-1z",
    fill: "#475562",
    fillOpacity: 0.153
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M119 60h-1v-1h1z",
    fillOpacity: 0.078
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M120 59v1h-1v-1z",
    fill: "#282828",
    fillOpacity: 0.075
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M121 59v1h-1v-1z",
    fill: "#243624",
    fillOpacity: 0.055
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61h-1v-1h1z",
    fill: "#fcc",
    fillOpacity: 0.02
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61h-1v-1h1z",
    fill: "#ccc",
    fillOpacity: 0.039
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61v-1h1v1z",
    fill: "#c9e9f7",
    fillOpacity: 0.282
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61h-1v-1h1z",
    fill: "#cceaf2",
    fillOpacity: 0.498
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61v-1h1v1z",
    fill: "#c8eaf3",
    fillOpacity: 0.675
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-1z",
    fill: "#c9ebf7",
    fillOpacity: 0.804
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1z",
    fill: "#caebf8",
    fillOpacity: 0.894
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61v-1h1v1z",
    fill: "#c9edf6",
    fillOpacity: 0.965
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1z",
    fill: "#caecf5",
    fillOpacity: 0.976
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v1h-1v-1z",
    fill: "#ceecf6",
    fillOpacity: 0.98
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#cbebf6",
    fillOpacity: 0.984
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#c7e8f0"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#d8f7ff"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#d8f5fd"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#d6f5fd"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#d7f5fd"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#d5f4fc"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#d5f5fd"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#d4f3fc"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#d4f4fb"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#d4f3fb"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#d4f2fc"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#d3f3fd"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#cdf2fa"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#cef5ff"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#c6eef8"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#caf1fa"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#cdf0fa"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#caeff9"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#ccf2fc"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#ccf3fd"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#cbf1fc"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#cbf1fe"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#cbf0fd"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#ccf0fd"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#cef1fd"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#cef1fe"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#cef0fd"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#cceffc"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#cbeefb"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#c8edf8"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#c8effc"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#c8eefc"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#ccf1fd"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#caeef8"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#c9ecf6"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#c9ebf8"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#c4ebf5"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61h-1v-1h1z",
    fill: "#c6edf8"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#c9effc"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#caeffd"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h-1v-1h1z",
    fill: "#c7ecf9"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#c3e8f3"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60h1v1h-1z",
    fill: "#c2e6f0"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#c3e6f0"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#c5e9f2"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#c1e6ef"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#bfe6ef"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M98 60h1v1h-1z",
    fill: "#bee5ee"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M99 60h1v1h-1z",
    fill: "#bfe5ef"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M101 61h-1v-1h1z",
    fill: "#bee5ef"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61h-1v-1h1z",
    fill: "#bde4ee"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v-1h1v1z",
    fill: "#c9eefa"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M105 60h1v1h-1z",
    fill: "#cef3ff"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61h-1v-1h1z",
    fill: "#cff3ff"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M112 60v1h-1v-1z",
    fill: "#d1f4fe"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M114 61h-1v-1h1z",
    fill: "#cff3fd"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M116 61h-1v-1h1z",
    fill: "#cdf2fb"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61h-1v-1h1z",
    fill: "#d5f6ff"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v-1h1v1z",
    fill: "#5d6a6f",
    fillOpacity: 0.941
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M119 61h-1v-1h1z",
    fill: "#1c1d1b",
    fillOpacity: 0.922
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M119 61v-1h1v1z",
    fill: "#222323",
    fillOpacity: 0.91
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M120 61v-1h1v1z",
    fill: "#1f2220",
    fillOpacity: 0.89
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M122 61h-1v-1h1z",
    fill: "#232320",
    fillOpacity: 0.698
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M16 61h1v1h-1z",
    fill: "#3374a3",
    fillOpacity: 0.275
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M18 61v1h-1v-1z",
    fill: "#1e77c0",
    fillOpacity: 0.651
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M18 62v-1h1v1z",
    fill: "#1988d4",
    fillOpacity: 0.792
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61v1h-1v-1z",
    fill: "#118ad4",
    fillOpacity: 0.843
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62v-1h1v1z",
    fill: "#3994d0",
    fillOpacity: 0.867
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M22 61v1h-1v-1z",
    fill: "#ccf0f8"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62v-1h1v1z",
    fill: "#dff"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h-1v-1h1z",
    fill: "#dffcff"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62h-1v-1h1z",
    fill: "#def9ff"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62v-1h1v1z",
    fill: "#dbfafc"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61v1h-1v-1z",
    fill: "#d4f5f9"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61h1v1h-1z",
    fill: "#d4f2f9"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#daf4fc"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#d5f3f9"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#c9edf4"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1z",
    fill: "#d1f1fc"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#cff2fc"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#d1f4fd"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#d1f2fd"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#d1f3fd"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#cdf1fc"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#c9eef9"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#c7eef8"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#c7eefa"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#c6eefa"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#c6edfb"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#c5eefb"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#c6effb"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#c7edfc"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#c5edfd"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#c9effd"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#c6edf9"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#c4e7f4"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#c2e7f4"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#c9eff9"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#c9f0fa"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#cbf1fa"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#ccf0f9"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#cef1fb"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#d1f1fb"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#cff2fe"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#cceef8"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#cff3fb"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#d2f3fb"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61v1h-1v-1z",
    fill: "#d2f3fa"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1z",
    fill: "#d2f1fa"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#d3f2fa"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#d1f2fa"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#d1f2f9"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h1v1h-1z",
    fill: "#d5f4fa"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#d6f5fb"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#d3f3fa"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#cef3f9"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#cef2f7"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#cef2f8"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h1v1h-1z",
    fill: "#cdf2f9"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61h1v1h-1z",
    fill: "#cff2fa"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v1h-1v-1z",
    fill: "#cff3fa"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62h-1v-1h1z",
    fill: "#cfeffb"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v-1h1v1z",
    fill: "#d0f0fb"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62h-1v-1h1z",
    fill: "#cfeef9"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62h-1v-1h1z",
    fill: "#cfeff9"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62v-1h1v1z",
    fill: "#cfeef7"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M108 61h1v1h-1z",
    fill: "#ceedf6"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M109 62v-1h1v1z",
    fill: "#cceef5"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62v-1h1v1z",
    fill: "#cdeef7"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M115 62h-1v-1h1z",
    fill: "#cdecf6"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M115 61h1v1h-1z",
    fill: "#c9eef5"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v1h-1v-1z",
    fill: "#d3f5fc"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h-1v-1h1z",
    fill: "#78878e"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62v-1h1v1z",
    fill: "#0f1011"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M121 61v1h-1v-1z",
    fill: "#161919"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M121 62v-1h1v1z",
    fill: "#181817"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M123 62h-1v-1h1z",
    fill: "#211e1b",
    fillOpacity: 0.333
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M16 62h1v1h-1z",
    fill: "#346f9c",
    fillOpacity: 0.153
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63h-1v-1h1z",
    fill: "#1a68ae",
    fillOpacity: 0.412
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M19 62v1h-1v-1z",
    fill: "#0c6ab4",
    fillOpacity: 0.565
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63h-1v-1h1z",
    fill: "#0464ae",
    fillOpacity: 0.667
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62h1v1h-1z",
    fill: "#2674af",
    fillOpacity: 0.745
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M22 63h-1v-1h1z",
    fill: "#a1cad4",
    fillOpacity: 0.988
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#acd6e3"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62v1h-1v-1z",
    fill: "#acdae6"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#aedced"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-1z",
    fill: "#b1deed"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v-1h1v1z",
    fill: "#b1e0f2"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63h-1v-1h1z",
    fill: "#aedcef"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62v1h-1v-1z",
    fill: "#afdcef"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#aadcec"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#a8dae8"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#b9e0f1"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1z",
    fill: "#b9e0ee"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#bbe4f1"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#bde5f2"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#bee6f2"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#bee6f3"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#bee5f4"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#bce5f4"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#b6dfef"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#bbe5f5"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#bbe5f7"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#bbe5f6"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#bbe6f5"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#bce7f6"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1z",
    fill: "#bce8f7"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#95b7c4"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#95b4c6"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#8eb0c1"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#82a2af"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#afd5e3"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#bfe9f8"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#89adbf"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#a2c7d7"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#b9e1f0"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#bee4f4"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#b7dcea"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#bde2ef"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#badfed"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#bde0ed"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#c7ecfb"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#b1d4e2"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#9dc2cf"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#a7cdd8"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#c8eaf6"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#c9edf9"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#c7eaf5"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#c6e8f3"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#c9eaf4"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#caecf5"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#cbebf5"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1z",
    fill: "#ceeef7"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#d3eff8"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#d0f0f8"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M99 62v1h-1v-1z",
    fill: "#d4f1f8"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M100 63h-1v-1h1z",
    fill: "#d6f1f8"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M101 62v1h-1v-1z",
    fill: "#d7f2f9"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M102 63h-1v-1h1z",
    fill: "#d8f3f9"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M102 62h1v1h-1z",
    fill: "#d9f4f9"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v1h-1v-1z",
    fill: "#dbf5fa"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62v1h-1v-1z",
    fill: "#dcf7f9"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h-1v-1h1z",
    fill: "#ddf5f9"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62h1v1h-1z",
    fill: "#def5f9"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62v1h-1v-1z",
    fill: "#ddf7fa"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h1v1h-1z",
    fill: "#dcf8fa"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h-1v-1h1z",
    fill: "#dbf7fa"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M113 63h-1v-1h1z",
    fill: "#ddf6fa"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62v1h-1v-1z",
    fill: "#e0f7fa"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62h1v1h-1z",
    fill: "#e2f7fb"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M116 62v1h-1v-1z",
    fill: "#e1f7fc"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h-1v-1h1z",
    fill: "#e6fcfe"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M117 62h1v1h-1z",
    fill: "#8d9b9e"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M122 63v-1h1v1z",
    fill: "#171715",
    fillOpacity: 0.475
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64h-1v-1h1z",
    fill: "#688e9a",
    fillOpacity: 0.239
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h-1v-1h1z",
    fill: "#69889a",
    fillOpacity: 0.447
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64v-1h1v1z",
    fill: "#63889b",
    fillOpacity: 0.651
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M25 63v1h-1v-1z",
    fill: "#698ea6",
    fillOpacity: 0.788
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v1h-1v-1z",
    fill: "#6c94ac",
    fillOpacity: 0.918
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M27 63v1h-1v-1z",
    fill: "#729bb6",
    fillOpacity: 0.98
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63v1h-1v-1z",
    fill: "#719bb8",
    fillOpacity: 0.996
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#719bba"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#6b96b4"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#7caac4"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#99cae2"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#96c8e0"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#98c8e0"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#99c9e0"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#99c8e0"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1z",
    fill: "#9ac9e1"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#9ccae1"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#9ccce2"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#9dcce1"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#9dcde2"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#9fcde1"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#9fcce0"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#a0cee0"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#a0cee1"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#a0cfe2"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#a1cfe3"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#a2d1e4"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#a2d1e5"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#9fcfe4"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#9ecee1"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#a9d6eb"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#a9d6ea"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#a9d8e9"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#abdbeb"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#abdaeb"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#addced"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#8db3c3"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#45606c"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#445f6d"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#718f9e"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#324b55"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#73939f"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#b1daec"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#7899ad"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#9bbaca"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#7698aa"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#9bbccf"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#6b8c9c"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#86a4b4"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#7a98a9"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#8caebf"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#688997"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#a1c6d6"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#7ea0b3"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#add7e7"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#87aaba"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#97bbca"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#81a5b4"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#95b7c7"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#7c9dad"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#88a9b8"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#84a4b4"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#89aabc"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#a9ccdf"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#88acbc"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#b4dfee"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#b5e1f1"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v1z",
    fill: "#b6e0f0"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M100 64v-1h1v1z",
    fill: "#b8e2f2"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M101 63h1v1h-1z",
    fill: "#b9e2f3"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63v1h-1v-1z",
    fill: "#b9e3f1"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h1v1h-1z",
    fill: "#bbe5f1"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M107 63v1h-1v-1z",
    fill: "#bce5f1"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64v-1h1v1z",
    fill: "#bde4f1"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h1v1h-1z",
    fill: "#bee4f2"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63h1v1h-1z",
    fill: "#bde6f3"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63v1h-1v-1z",
    fill: "#bde7f0"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h1v1h-1z",
    fill: "#c0e7ef"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h-1v-1h1z",
    fill: "#c3e7ef"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63v1h-1v-1z",
    fill: "#c7e6ef"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64h-1v-1h1z",
    fill: "#c8e7f1"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64v-1h1v1z",
    fill: "#ceeff8"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h1v1h-1z",
    fill: "#84959a"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M119 63v1h-1v-1z",
    fill: "#08090b"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63h1v1h-1z",
    fill: "#101212"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M122 63h1v1h-1z",
    fill: "#161612",
    fillOpacity: 0.494
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65v-1h1v1z",
    fill: "#3d475b",
    fillOpacity: 0.098
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M26 65v-1h1v1z",
    fill: "#465a73",
    fillOpacity: 0.2
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65h-1v-1h1z",
    fill: "#426079",
    fillOpacity: 0.239
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64h1v1h-1z",
    fill: "#415b78",
    fillOpacity: 0.275
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65v-1h1v1z",
    fill: "#364e6c",
    fillOpacity: 0.294
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#5d7c96",
    fillOpacity: 0.451
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#638ca8",
    fillOpacity: 0.988
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#5f8bae"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#618eb0"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1z",
    fill: "#638fb3"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#6490b4"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#6691b6"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#6892b7"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#6993b9"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#6995ba"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#6996bb"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#6b98bd"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#6d99be"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#6d9bbf"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#6f9dc0"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#709ec2"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#72a0c3"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#75a4c7"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#75a4c6"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#70a0c3"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#78a8c7"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#89b9d1"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#87b6d0"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#89b7d1"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#8ab8d2"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#8bbad3"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#8cbad4"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#8bbbd5"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#8bbcd5"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#8ebcd6"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#91bdd8"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#7aa3bb"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#597d91"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#83abc0"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#8eb8ce"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#608496"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#5b8194"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#8fb8cd"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#6c90a7"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#7da1b7"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#6a8da2"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#6a8da1"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#5e7f93"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#6c8c9f"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#658397"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#7394a8"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#547384"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#84a8bb"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#779bb1"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#83a9be"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#86acc0"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#628699"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#69889a"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#718fa2"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#7e9eb2"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#7596aa"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1z",
    fill: "#7fa0b3"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#69899c"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#7190a4"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#8dadc1"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#6c8b9e"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#9dc6db"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#a6d0e8"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64h1v1h-1z",
    fill: "#a8cfe7"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M99 64v1h-1v-1z",
    fill: "#a8d2e5"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65h-1v-1h1z",
    fill: "#a9d2e4"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65h-1v-1h1z",
    fill: "#aad3e5"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65v-1h1v1z",
    fill: "#a9d3e5"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64h1v1h-1z",
    fill: "#aad4e7"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64v1h-1v-1z",
    fill: "#abd4e8"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h1v1h-1z",
    fill: "#aad4e6"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M106 64v1h-1v-1z",
    fill: "#aad5e6"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M108 64h1v1h-1z",
    fill: "#aed7e7"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65v-1h1v1z",
    fill: "#add2e1"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M111 64v1h-1v-1z",
    fill: "#add0e1"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65v-1h1v1z",
    fill: "#aed3e6"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M112 64h1v1h-1z",
    fill: "#b2d8eb"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M114 65h-1v-1h1z",
    fill: "#b1d9ed"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h1v1h-1z",
    fill: "#b0d9eb"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64v1h-1v-1z",
    fill: "#aedcec"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M117 65h-1v-1h1z",
    fill: "#b7e3f2"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65h-1v-1h1z",
    fill: "#6e838c"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65v-1h1v1z",
    fill: "#0f0f10"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M122 64v1h-1v-1z",
    fill: "#161615"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M123 64v1h-1v-1z",
    fill: "#1a1a18",
    fillOpacity: 0.447
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#3d5776",
    fillOpacity: 0.227
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#3b577c",
    fillOpacity: 0.322
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#38567b",
    fillOpacity: 0.357
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#36557b",
    fillOpacity: 0.365
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#38557e",
    fillOpacity: 0.373
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#365780",
    fillOpacity: 0.388
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#38587f",
    fillOpacity: 0.408
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#35577f",
    fillOpacity: 0.447
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#365980",
    fillOpacity: 0.459
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#375b81",
    fillOpacity: 0.471
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#385b83",
    fillOpacity: 0.478
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M42 65h1v1h-1z",
    fill: "#395a84",
    fillOpacity: 0.506
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#3a5b83",
    fillOpacity: 0.533
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#395c84",
    fillOpacity: 0.553
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#3a5d87",
    fillOpacity: 0.569
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#3a5e88",
    fillOpacity: 0.58
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v-1h1v1z",
    fill: "#3b608a",
    fillOpacity: 0.592
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#3c628a",
    fillOpacity: 0.612
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#3e618e",
    fillOpacity: 0.624
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#3d6390",
    fillOpacity: 0.635
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#406590",
    fillOpacity: 0.651
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#40658f",
    fillOpacity: 0.682
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#385e89",
    fillOpacity: 0.722
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#4b749b",
    fillOpacity: 0.878
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#5987b4"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#5384b2"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#5786b8"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#5787b9"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#5989ba"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#5b8abc"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#5b8cbd"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#5c8dbe"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#5e8dbf"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#5f8ec0"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#6190bf"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#6493be"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#6293bf"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#6294c0"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#6596c1"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#6899c3"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#6492b7"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#5982a6"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#5e88ab"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#6690b0"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#658fb0"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#6891b3"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#6990b0"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#6990b2"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#658faf"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#6b94b5"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#6d97b9"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#739ec0"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1z",
    fill: "#729dbc"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#6b93b1"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65h1v1h-1z",
    fill: "#6b94b3"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#7299b5"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#6d98b3"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#7098b7"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#6e93b1"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#6b90ad"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#6a90ad"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#688faa"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65v1h-1v-1z",
    fill: "#739eba"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#7eabc8"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M97 65h1v1h-1z",
    fill: "#7facc7"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M98 65h1v1h-1z",
    fill: "#80acc8"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65v1h-1v-1z",
    fill: "#82acca"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v-1h1v1z",
    fill: "#83afca"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M104 66h-1v-1h1z",
    fill: "#84b1ca"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65h1v1h-1z",
    fill: "#85b1ca"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M105 65h1v1h-1z",
    fill: "#86b1ca"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65v1h-1v-1z",
    fill: "#88b2cc"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M107 66v-1h1v1z",
    fill: "#8ab4cf"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M109 66h-1v-1h1z",
    fill: "#87afc6"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65h1v1h-1z",
    fill: "#5e7d90"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M110 66v-1h1v1z",
    fill: "#567181"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65h1v1h-1z",
    fill: "#587887"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M112 65h1v1h-1z",
    fill: "#89b1c2"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66v-1h1v1z",
    fill: "#90becf"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M115 65v1h-1v-1z",
    fill: "#91bcd0"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M116 66h-1v-1h1z",
    fill: "#95bbcf"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M117 65v1h-1v-1z",
    fill: "#99c3d8"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M117 66v-1h1v1z",
    fill: "#4f6067"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65h1v1h-1z",
    fill: "#191614"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M121 65h1v1h-1z",
    fill: "#1d1c1c"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M123 66h-1v-1h1z",
    fill: "#262222",
    fillOpacity: 0.259
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#2f4267",
    fillOpacity: 0.106
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#32507b",
    fillOpacity: 0.396
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#284978",
    fillOpacity: 0.447
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#26487b",
    fillOpacity: 0.471
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#28497c",
    fillOpacity: 0.475
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#2a4c7f",
    fillOpacity: 0.471
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#2a4d80",
    fillOpacity: 0.49
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#2d5085",
    fillOpacity: 0.51
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#2b4e86",
    fillOpacity: 0.573
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#2a4b7e",
    fillOpacity: 0.639
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#274676",
    fillOpacity: 0.733
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#23416c",
    fillOpacity: 0.902
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#21416c"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#22416c"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#24436e"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#254571"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#264673"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#25426b"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#1c365b"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#203a5d"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#1f3a5b"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#264265"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#26466a"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#213d60"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#28466c"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#234367"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#23446a"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#26436c"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#315279"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-1h1z",
    fill: "#2b4871"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M85 66v1h-1v-1z",
    fill: "#2b4870"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M86 67h-1v-1h1z",
    fill: "#2c4d73"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1z",
    fill: "#30517e"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1z",
    fill: "#3a5e8e"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1z",
    fill: "#2f4e78"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#365882"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#365a86"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#395c86"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#365982"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#345782"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#4671a1"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M96 67h-1v-1h1z",
    fill: "#4a77aa"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66v1h-1v-1z",
    fill: "#4a76a9"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67h-1v-1h1z",
    fill: "#4c78aa"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M99 67h-1v-1h1z",
    fill: "#4d7aac"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v1h-1v-1z",
    fill: "#4e7bad"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67h-1v-1h1z",
    fill: "#507db0"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v1h-1v-1z",
    fill: "#527fb1"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67h-1v-1h1z",
    fill: "#537fb1"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67h-1v-1h1z",
    fill: "#5481b1"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M105 67h-1v-1h1z",
    fill: "#5583b3"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M105 66h1v1h-1z",
    fill: "#5683b4"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h-1v-1h1z",
    fill: "#5984b3"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66v1h-1v-1z",
    fill: "#5a86b4"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66h1v1h-1z",
    fill: "#5580aa"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v-1h1v1z",
    fill: "#41648a"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67v-1h1v1z",
    fill: "#436186"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67v-1h1v1z",
    fill: "#466a91"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M112 66h1v1h-1z",
    fill: "#5e89b1"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66h1v1h-1z",
    fill: "#618eb6"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M115 66v1h-1v-1z",
    fill: "#618fb9"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M116 66v1h-1v-1z",
    fill: "#628fb6"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M117 67h-1v-1h1z",
    fill: "#698fab",
    fillOpacity: 0.996
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M118 66v1h-1v-1z",
    fill: "#21292d",
    fillOpacity: 0.937
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M118 67v-1h1v1z",
    fill: "#050705",
    fillOpacity: 0.851
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66v1h-1v-1z",
    fill: "#080b08",
    fillOpacity: 0.792
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66h1v1h-1z",
    fill: "#0b0a09",
    fillOpacity: 0.761
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M121 67v-1h1v1z",
    fill: "#110d0d",
    fillOpacity: 0.525
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#73738b",
    fillOpacity: 0.043
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#5a87a5",
    fillOpacity: 0.067
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#4f7f9f",
    fillOpacity: 0.063
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#4b7896",
    fillOpacity: 0.067
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1z",
    fill: "#55719b",
    fillOpacity: 0.071
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#5571aa",
    fillOpacity: 0.071
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#557faa",
    fillOpacity: 0.071
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#597fa5",
    fillOpacity: 0.078
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#5579aa",
    fillOpacity: 0.082
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#4879aa",
    fillOpacity: 0.082
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#4568a2",
    fillOpacity: 0.086
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#3f6a9f",
    fillOpacity: 0.094
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#477099",
    fillOpacity: 0.098
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#3c6d9d",
    fillOpacity: 0.082
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#4b85bf",
    fillOpacity: 0.173
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#4b90d7",
    fillOpacity: 0.506
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#418cd2",
    fillOpacity: 0.533
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#4289cf",
    fillOpacity: 0.529
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#418ad0",
    fillOpacity: 0.522
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#428ad0",
    fillOpacity: 0.514
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#4088cf",
    fillOpacity: 0.529
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#3e83c9",
    fillOpacity: 0.561
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#3c7ec3",
    fillOpacity: 0.6
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#3675b6",
    fillOpacity: 0.663
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#2d6299",
    fillOpacity: 0.855
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#2a598c"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#28588b"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#27578a"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#275589"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#265387"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#245285"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#255385"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#235183"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#254e80"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#244d7e"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#214d81"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#224b7c"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#214a7b"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#204c7c"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#214876"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#1f487a"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#1e4779"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67h1v1h-1z",
    fill: "#204678"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68v-1h1v1z",
    fill: "#204576"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68h-1v-1h1z",
    fill: "#1d4475"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67v1h-1v-1z",
    fill: "#1c4376"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68h-1v-1h1z",
    fill: "#1a4477"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1z",
    fill: "#194376"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M90 67v1h-1v-1z",
    fill: "#1a4373"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#1a4274"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#184075"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#194076"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#1a4179"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#1b447a"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67h1v1h-1z",
    fill: "#1e467c"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68h-1v-1h1z",
    fill: "#1e467d"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67v1h-1v-1z",
    fill: "#1f467f"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68v-1h1v1z",
    fill: "#1e4681"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68h-1v-1h1z",
    fill: "#1f4682"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67v1h-1v-1z",
    fill: "#204784"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68h-1v-1h1z",
    fill: "#214985"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M105 68h-1v-1h1z",
    fill: "#204b86"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M106 68h-1v-1h1z",
    fill: "#1f4d88"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M106 67h1v1h-1z",
    fill: "#1f4e8b"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h1v1h-1z",
    fill: "#20508f"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v1h-1v-1z",
    fill: "#225390"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68v-1h1v1z",
    fill: "#24538e"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67h1v1h-1z",
    fill: "#275593"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67h1v1h-1z",
    fill: "#27589b"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v-1h1v1z",
    fill: "#285c9f"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M114 68h-1v-1h1z",
    fill: "#285c9d"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M115 68h-1v-1h1z",
    fill: "#2a5c9b"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M116 68h-1v-1h1z",
    fill: "#2b619f"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M117 68h-1v-1h1z",
    fill: "#335f8f",
    fillOpacity: 0.804
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M117 68v-1h1v1z",
    fill: "#1e2b33",
    fillOpacity: 0.231
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M119 67v1h-1v-1z",
    fillOpacity: 0.02
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1z",
    fill: "#5f7f9f",
    fillOpacity: 0.031
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#6d91b6",
    fillOpacity: 0.055
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v1h-1v-1z",
    fill: "#68b",
    fillOpacity: 0.059
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#6f8faf",
    fillOpacity: 0.063
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#70a1cd",
    fillOpacity: 0.204
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#5c9cdb",
    fillOpacity: 0.824
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#529ce1",
    fillOpacity: 0.882
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#529ce1",
    fillOpacity: 0.875
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#509be2",
    fillOpacity: 0.878
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#509ae1",
    fillOpacity: 0.882
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#509be1",
    fillOpacity: 0.882
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#4e99e0",
    fillOpacity: 0.886
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#5099e1",
    fillOpacity: 0.886
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#4f9be1",
    fillOpacity: 0.89
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#509ce3",
    fillOpacity: 0.894
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#4f9ae1",
    fillOpacity: 0.902
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#509ae2",
    fillOpacity: 0.902
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#4f99e1",
    fillOpacity: 0.902
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#4e97e2",
    fillOpacity: 0.906
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#4e96e2",
    fillOpacity: 0.902
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#4f97e0",
    fillOpacity: 0.898
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#4d96dd",
    fillOpacity: 0.906
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#4e96de",
    fillOpacity: 0.91
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#4f97de",
    fillOpacity: 0.91
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#4f98e0",
    fillOpacity: 0.906
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#4e98df",
    fillOpacity: 0.918
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#4d97e0",
    fillOpacity: 0.922
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#4c97df",
    fillOpacity: 0.918
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#4794dc",
    fillOpacity: 0.961
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#56aeff"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#51adff"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#53aeff"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#52acfe"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#51abfd"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#50aafc"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#52aafb"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#54a9f8"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#52a9f9"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#50a8f8"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#4ea8f9"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#52a6f8"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#54a4f3"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#53a5f5"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#54a3f0"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#52a5f4"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#52a6f6"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#59a7f0"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#50a6f7"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#4ea5f7"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#4fa6f7"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h-1v-1h1z",
    fill: "#4ea6f8"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68v1h-1v-1z",
    fill: "#4ea5f9"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M87 69h-1v-1h1z",
    fill: "#50a5f8"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68v1h-1v-1z",
    fill: "#4fa4f7"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69v-1h1v1z",
    fill: "#4da4f9"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69h-1v-1h1z",
    fill: "#52a3f2"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M91 69h-1v-1h1z",
    fill: "#57a5ed"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#51a4ef"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#4ba4f4"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#4ca3f3"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68h1v1h-1z",
    fill: "#4ba2f2"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68v1h-1v-1z",
    fill: "#4ba2f1"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68v1h-1v-1z",
    fill: "#4ca2ef"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68h1v1h-1z",
    fill: "#4aa1ec"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68h1v1h-1z",
    fill: "#49a0eb"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69v-1h1v1z",
    fill: "#499feb"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M107 68v1h-1v-1z",
    fill: "#4b9eeb"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M107 69v-1h1v1z",
    fill: "#4b9ce8"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M109 69h-1v-1h1z",
    fill: "#4a9ce7"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68h1v1h-1z",
    fill: "#499ce9"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M110 68h1v1h-1z",
    fill: "#489bea"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v1h-1v-1z",
    fill: "#489beb"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68h1v1h-1z",
    fill: "#499ced"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M113 69v-1h1v1z",
    fill: "#499ceb"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M115 69h-1v-1h1z",
    fill: "#499ae6"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M115 68h1v1h-1z",
    fill: "#4898e6"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M116 68h1v1h-1z",
    fill: "#4496e3",
    fillOpacity: 0.98
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M117 68h1v1h-1z",
    fill: "#4d94d1",
    fillOpacity: 0.776
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M118 68h1v1h-1z",
    fill: "#22333d",
    fillOpacity: 0.294
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M120 68v1h-1v-1z",
    fill: "#181613",
    fillOpacity: 0.408
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M120 69v-1h1v1z",
    fill: "#1f1f1c",
    fillOpacity: 0.416
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M121 69v-1h1v1z",
    fill: "#1f1f1d",
    fillOpacity: 0.376
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M123 68v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.118
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M22 69h1v1h-1z",
    fill: "#689fda",
    fillOpacity: 0.22
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#62a4de",
    fillOpacity: 0.365
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1z",
    fill: "#5ca6e2",
    fillOpacity: 0.486
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#5ca4e0",
    fillOpacity: 0.627
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#5ca1e8",
    fillOpacity: 0.757
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70v-1h1v1z",
    fill: "#56a2ed",
    fillOpacity: 0.843
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70h-1v-1h1z",
    fill: "#56a2e9",
    fillOpacity: 0.882
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h1v1z",
    fill: "#55a3eb",
    fillOpacity: 0.886
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#53a0ea",
    fillOpacity: 0.886
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#5da3e1",
    fillOpacity: 0.937
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#6dbcfd"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#69b9fb"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#69b9fc"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#68b8fa"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#66b8fa"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#66b7f9"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#67b7f9"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#66b7fa"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#66b7fb"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#65b6f9"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#63b4f7"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#65b5f9"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#65b6fb"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#63b4fa"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#61b3f9"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#54a8f4"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#55acf5"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#53abf6"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#55abf5"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#55abfa"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#56abf8"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#56acf5"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#55adf8"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#54acf5"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#5aa8ec"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#79b5e9"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#8bbee8"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#8ebfe9"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#93c6ed"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#5ca7e9"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v1h-1v-1z",
    fill: "#5baaf0"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#75b5ec"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#5fa9eb"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#5da9ef"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#63aeef"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#64aef1"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h1v1h-1z",
    fill: "#66aff0"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70h-1v-1h1z",
    fill: "#61acef"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70v-1h1v1z",
    fill: "#69b1ee"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69h1v1h-1z",
    fill: "#58a6ee"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69v1h-1v-1z",
    fill: "#6db4f0"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v-1h1v1z",
    fill: "#5eabf0"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#5caaf2"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M92 70v-1h1v1z",
    fill: "#5facf2"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#5caaf0"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1z",
    fill: "#5faff3"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M95 69h1v1h-1z",
    fill: "#62b1f4"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70v-1h1v1z",
    fill: "#60b1f4"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69v1h-1v-1z",
    fill: "#61b0f1"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v-1h1v1z",
    fill: "#5fb0f4"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M100 70h-1v-1h1z",
    fill: "#5cadf2"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M100 69h1v1h-1z",
    fill: "#5fb0f5"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M102 70h-1v-1h1z",
    fill: "#57adf9"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M102 69h1v1h-1z",
    fill: "#56aefa"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M103 70v-1h1v1z",
    fill: "#55aefa"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M104 70v-1h1v1z",
    fill: "#55adfb"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69h1v1h-1z",
    fill: "#55adfa"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M106 70v-1h1v1z",
    fill: "#54adfa"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h-1v-1h1z",
    fill: "#54adf8"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70v-1h1v1z",
    fill: "#53adf8"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M110 69h1v1h-1z",
    fill: "#56aaf3"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h-1v-1h1z",
    fill: "#59aaf2"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M113 70h-1v-1h1z",
    fill: "#5aacf7"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M113 69h1v1h-1z",
    fill: "#56adf9"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M115 69v1h-1v-1z",
    fill: "#54affb"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M116 69v1h-1v-1z",
    fill: "#53adf6"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M117 70h-1v-1h1z",
    fill: "#51a9f3"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M117 69h1v1h-1z",
    fill: "#58aaf3"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M119 70h-1v-1h1z",
    fill: "#2e4659"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M119 69h1v1h-1z",
    fill: "#1b1c1a"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M122 69h1v1h-1z",
    fill: "#1f221f",
    fillOpacity: 0.788
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70h1v1h-1z",
    fill: "#2f3f4f",
    fillOpacity: 0.063
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M18 70h1v1h-1z",
    fill: "#333c61",
    fillOpacity: 0.216
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M19 70h1v1h-1z",
    fill: "#324078",
    fillOpacity: 0.357
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71v-1h1v1z",
    fill: "#23356c",
    fillOpacity: 0.451
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71v-1h1v1z",
    fill: "#456592",
    fillOpacity: 0.573
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70h1v1h-1z",
    fill: "#7ec0ea",
    fillOpacity: 0.973
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#7cc5f8"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#7ec8ff"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#86cafe"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70h1v1h-1z",
    fill: "#8dcfff"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#79c2f9"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#63b4f4"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#5db2f8"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#5db0f8"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#6fb9f1"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#80c8f9"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#7bc5fd"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#77c1fb"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#76c0fa"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#76bff9"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#76bffb"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#74bef9"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#74befa"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#73bffa"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#72bef8"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#6ebcf8"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#6bb9fa"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M56 71h-1v-1h1z",
    fill: "#5baaf1"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#55a8f3"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#52a6f3"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#53a6f3"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#55a8f5"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#57aaf6"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#56a9f6"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#57a8f7"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#59aaf7"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#5ca8f0"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#84bbef"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#a4cce9"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#9dcceb"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#95bfe3"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#b2d6ec"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#7fbaee"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#70b1e8"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#8dc0e9"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#84bae9"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#8ac2ee"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1z",
    fill: "#90c1ec"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#95c7ed"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70v1h-1v-1z",
    fill: "#98c7ec"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71h-1v-1h1z",
    fill: "#8bbde9"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M88 70v1h-1v-1z",
    fill: "#a0cced"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71h-1v-1h1z",
    fill: "#87beee"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M89 70h1v1h-1z",
    fill: "#91c8ef"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v1h-1v-1z",
    fill: "#7bbff3"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M91 71v-1h1v1z",
    fill: "#7fbff1"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v1h-1v-1z",
    fill: "#95cdf4"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#8fc4ec"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70h1v1h-1z",
    fill: "#8cc2ed"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70h1v1h-1z",
    fill: "#87bdea"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M97 71h-1v-1h1z",
    fill: "#82bbea"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v1h-1v-1z",
    fill: "#91c3ee"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M99 71h-1v-1h1z",
    fill: "#84beed"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M99 70h1v1h-1z",
    fill: "#7ab8e9"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M101 70v1h-1v-1z",
    fill: "#83c0ee"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71h-1v-1h1z",
    fill: "#6ab2f0"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M103 71h-1v-1h1z",
    fill: "#68b4f4"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71h-1v-1h1z",
    fill: "#67b4f2"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M105 70v1h-1v-1z",
    fill: "#68b4f1"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71v-1h1v1z",
    fill: "#68b3ee"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M107 70v1h-1v-1z",
    fill: "#67b2ef"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M107 70h1v1h-1z",
    fill: "#67b3f2"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h1v1h-1z",
    fill: "#64b2f3"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M110 71h-1v-1h1z",
    fill: "#67afed"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M110 70h1v1h-1z",
    fill: "#85bfee"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70v1h-1v-1z",
    fill: "#90c1ea"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h1v1h-1z",
    fill: "#88c0ee"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M114 70v1h-1v-1z",
    fill: "#68afec"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M115 70v1h-1v-1z",
    fill: "#63aff0"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M115 71v-1h1v1z",
    fill: "#65aff1"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M116 70h1v1h-1z",
    fill: "#62b0f0"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M117 70h1v1h-1z",
    fill: "#6ab5f3"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M118 70h1v1h-1z",
    fill: "#3c5f7b"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M120 71h-1v-1h1z",
    fill: "#10110f"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M122 70h1v1h-1z",
    fill: "#161816"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M123 70h1v1h-1z",
    fill: "#1d1d19",
    fillOpacity: 0.239
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h1v1h-1z",
    fill: "#2d3141",
    fillOpacity: 0.243
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M18 72v-1h1v1z",
    fill: "#1d264a",
    fillOpacity: 0.643
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M19 71h1v1h-1z",
    fill: "#1f2c60",
    fillOpacity: 0.835
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71h1v1h-1z",
    fill: "#13235c",
    fillOpacity: 0.945
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1z",
    fill: "#2c497d",
    fillOpacity: 0.988
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#72b0e3"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#6face1"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#6eace7"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#6daee7"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#70b3e7"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#5fa7ea"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#4d99eb"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#4c9bee"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#4b96e5"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#5297dd"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#62abed"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#60a8ee"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#5fa6ec"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#5fa5ed"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#5ea5ed"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#5ca6ed"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#5ba6ec"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#5da7ed"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#5ba8ec"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#5aa7eb"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#59a7ea"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#59a6ea"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#58a6ec"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#57a4ea"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#4c99e3"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#4e9eee"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#4f9fed"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#4fa0ed"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#4fa0ec"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#50a0ed"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#51a1ed"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#52a2ed"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#50a0ec"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#53a1ea"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#5ea6e8"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#61a6e8"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#62a5e4"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#73a9e1"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1z",
    fill: "#72a5db"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#609fdd"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#68a5e2"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#7bb0dd"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#70abe2"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#6da7e1"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#6fade5"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#72abe0"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#71adde"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h-1v-1h1z",
    fill: "#7ab1e4"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72v-1h1v1z",
    fill: "#79aedf"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M85 71h1v1h-1z",
    fill: "#7bb3e5"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71v1h-1v-1z",
    fill: "#79b3e9"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M88 71v1h-1v-1z",
    fill: "#7bb2e4"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72h-1v-1h1z",
    fill: "#76b2e8"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72v-1h1v1z",
    fill: "#74b1e6"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72h-1v-1h1z",
    fill: "#84baec"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-1z",
    fill: "#85b8ea"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h-1v-1h1z",
    fill: "#81b4e4"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h-1v-1h1z",
    fill: "#85bbe9"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M95 71h1v1h-1z",
    fill: "#7fb7ea"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72h-1v-1h1z",
    fill: "#8cbfec"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h-1v-1h1z",
    fill: "#8cc0ea"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72v-1h1v1z",
    fill: "#8ec3ea"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M100 71h1v1h-1z",
    fill: "#8fc0e6"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71v1h-1v-1z",
    fill: "#8bc0eb"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h-1v-1h1z",
    fill: "#88c2ed"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71v1h-1v-1z",
    fill: "#88c2ec"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M105 72h-1v-1h1z",
    fill: "#8bc5ee"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71h1v1h-1z",
    fill: "#8bc6f1"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M107 71v1h-1v-1z",
    fill: "#8cc7f2"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M108 72h-1v-1h1z",
    fill: "#8dc8f2"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M108 71h1v1h-1z",
    fill: "#8cc9f4"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v-1h1v1z",
    fill: "#8ec9f2"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v-1h1v1z",
    fill: "#a5d3f3"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h-1v-1h1z",
    fill: "#b4d8f1"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M112 71h1v1h-1z",
    fill: "#a8d2f1"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M114 72h-1v-1h1z",
    fill: "#95c9f1"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M114 71h1v1h-1z",
    fill: "#9dd4f7"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M116 71v1h-1v-1z",
    fill: "#9fd4f7"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M117 72h-1v-1h1z",
    fill: "#a1d6f9"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M117 71h1v1h-1z",
    fill: "#a3defa"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M118 72v-1h1v1z",
    fill: "#5b798b"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M119 71h1v1h-1z",
    fill: "#0d0e0c"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M123 71v1h-1v-1z",
    fill: "#141614"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M123 72v-1h1v1z",
    fill: "#181816",
    fillOpacity: 0.361
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M21 73h-1v-1h1z",
    fill: "#2a2a35",
    fillOpacity: 0.094
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h-1v-1h1z",
    fill: "#3b516c",
    fillOpacity: 0.184
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#306099",
    fillOpacity: 0.639
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#2a5e94",
    fillOpacity: 0.796
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M24 73v-1h1v1z",
    fill: "#2a619d",
    fillOpacity: 0.878
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#2c63a1",
    fillOpacity: 0.937
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#3269ae",
    fillOpacity: 0.984
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#386fb7"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#376eb6"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#366db6"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#3168ad"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#3873ba"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#4385d3"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#4384ce"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#4382cf"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#4383cf"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#4384d0"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#4183cf"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#4284d0"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#4284cf"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#4486d1"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#4386d1"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#4286d1"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#4286d0"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#3f83cb"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#3c82cb"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#448cdc"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#438ada"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#458ada"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#458cdb"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#468cdc"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#478cdc"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#488ddd"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#478bdc"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#4a8cd8"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#548fd2"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#5590d5"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#5291da"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#5090da"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#5092db"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#5591d5"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#5590d7"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#5c93d8"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#6199d2"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#6397d4"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#6198d5"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#6298d4"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1z",
    fill: "#6198d8"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72v1h-1v-1z",
    fill: "#5896da"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72h1v1h-1z",
    fill: "#5a94d9"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M87 73v-1h1v1z",
    fill: "#5b95d9"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M88 73v-1h1v1z",
    fill: "#5d97da"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73v-1h1v1z",
    fill: "#5b97dc"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72v1h-1v-1z",
    fill: "#5a97d9"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M92 72v1h-1v-1z",
    fill: "#5a98d9"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72v1h-1v-1z",
    fill: "#5898dd"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h1v1h-1z",
    fill: "#5799da"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h1v1h-1z",
    fill: "#5b98db"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v1h-1v-1z",
    fill: "#5c9add"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73v-1h1v1z",
    fill: "#5c9bde"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72v1h-1v-1z",
    fill: "#5d9adb"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M98 73v-1h1v1z",
    fill: "#5e9cdb"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h1v1h-1z",
    fill: "#5d9cdd"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M100 72h1v1h-1z",
    fill: "#5e9bd7"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M101 72h1v1h-1z",
    fill: "#5e9ad8"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72v1h-1v-1z",
    fill: "#5f9bdc"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h1v1h-1z",
    fill: "#609bda"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M104 72h1v1h-1z",
    fill: "#5f9dde"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M106 73h-1v-1h1z",
    fill: "#5298df"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M107 73h-1v-1h1z",
    fill: "#4996e1"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M108 72v1h-1v-1z",
    fill: "#4a97e2"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v1h-1v-1z",
    fill: "#4796e3"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v1h-1v-1z",
    fill: "#4796e2"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73v-1h1v1z",
    fill: "#529bdf"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M111 73v-1h1v1z",
    fill: "#599cdc"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h1v1h-1z",
    fill: "#5499de"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M114 73h-1v-1h1z",
    fill: "#4e98e1"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M115 73h-1v-1h1z",
    fill: "#519de1"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M115 73v-1h1v1z",
    fill: "#52a0e2"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M117 72v1h-1v-1z",
    fill: "#559ee4"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M117 73v-1h1v1z",
    fill: "#5aa3e8"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M119 72v1h-1v-1z",
    fill: "#3f6489"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M123 72h1v1h-1z",
    fill: "#171715",
    fillOpacity: 0.376
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#223",
    fillOpacity: 0.059
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#223b55",
    fillOpacity: 0.118
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1z",
    fill: "#254271",
    fillOpacity: 0.212
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#294878",
    fillOpacity: 0.29
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#294370",
    fillOpacity: 0.31
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#28416c",
    fillOpacity: 0.349
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#213f66",
    fillOpacity: 0.392
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#345a86",
    fillOpacity: 0.663
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#38679b"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#32639a"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#33649c"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#32639d"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#32649d"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#32659e"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#32659f"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#3366a0"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#3466a0"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#3365a0"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#3466a1"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#3366a1"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#3467a4"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#3568a5"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#3064a0"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#3268a7"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#3771b7"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#336db6"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#346db6"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#356db6"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#356db7"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#356fb7"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#346fb6"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#336fb7"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#3370b8"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#3571b8"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#3570b8"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#3470ba"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#3570ba"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#3870b7"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#3871ba"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#3771bb"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#3772bb"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#3a72bd"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#3771bd"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#447bbb"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#5682b4"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#517eb9"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#4e80b8"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#4a7cb7"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#487dba"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#3d78bd"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M86 74v-1h1v1z",
    fill: "#4e82bd"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h-1v-1h1z",
    fill: "#4f84be"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74v-1h1v1z",
    fill: "#5081bd"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73h1v1h-1z",
    fill: "#4e83be"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74h-1v-1h1z",
    fill: "#4a81c1"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v-1h1v1z",
    fill: "#4982c0"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M93 74h-1v-1h1z",
    fill: "#4b84c5"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74h-1v-1h1z",
    fill: "#4c84c2"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M94 73h1v1h-1z",
    fill: "#4882c8"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74v-1h1v1z",
    fill: "#3d7bc5"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M99 73v1h-1v-1z",
    fill: "#3d7dc9"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M100 73v1h-1v-1z",
    fill: "#3c7dca"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74h-1v-1h1z",
    fill: "#3d7dc8"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73v1h-1v-1z",
    fill: "#3d7cc7"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73h1v1h-1z",
    fill: "#3d7dcb"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74h-1v-1h1z",
    fill: "#3f7dca"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74h-1v-1h1z",
    fill: "#3f7dc9"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74v-1h1v1z",
    fill: "#3e80ce"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M106 74v-1h1v1z",
    fill: "#3d82cf"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M108 74h-1v-1h1z",
    fill: "#4183cd"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M108 73h1v1h-1z",
    fill: "#3f83d0"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M109 73h1v1h-1z",
    fill: "#3f83d3"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73h1v1h-1z",
    fill: "#4083d1"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M112 73v1h-1v-1z",
    fill: "#4084d1"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M112 73h1v1h-1z",
    fill: "#4185d3"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M113 74v-1h1v1z",
    fill: "#4086d3"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M114 73h1v1h-1z",
    fill: "#4285d1"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M118 74h-1v-1h1z",
    fill: "#438cda"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M119 73v1h-1v-1z",
    fill: "#315371"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M120 73v1h-1v-1z",
    fill: "#141312"
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M123 73h1v1h-1z",
    fill: "#1a1a17",
    fillOpacity: 0.298
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#484848",
    fillOpacity: 0.055
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#2e4963",
    fillOpacity: 0.341
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#254566",
    fillOpacity: 0.373
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v1h-1z",
    fill: "#244464",
    fillOpacity: 0.408
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#274461",
    fillOpacity: 0.451
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#264460",
    fillOpacity: 0.498
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#254361",
    fillOpacity: 0.533
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#254461",
    fillOpacity: 0.553
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#264662",
    fillOpacity: 0.569
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#284661",
    fillOpacity: 0.592
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#294661",
    fillOpacity: 0.627
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#274461",
    fillOpacity: 0.655
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#284460",
    fillOpacity: 0.675
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#284461",
    fillOpacity: 0.69
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#26435f",
    fillOpacity: 0.722
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#274560",
    fillOpacity: 0.737
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#27445f",
    fillOpacity: 0.741
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1z",
    fill: "#27455f",
    fillOpacity: 0.765
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#27445e",
    fillOpacity: 0.792
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#27445f",
    fillOpacity: 0.816
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#284560",
    fillOpacity: 0.835
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#26435f",
    fillOpacity: 0.859
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#26415e",
    fillOpacity: 0.89
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#203d5b",
    fillOpacity: 0.918
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#28496e",
    fillOpacity: 0.969
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#2d5482"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#275181"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#275180"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#285280"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#285281"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#2a5383"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#2b5484"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#295484"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1z",
    fill: "#295686"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#2b5789"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#2b578a"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#2b578b"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#2a588b"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#2a588c"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#2c5b8c"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#2b5a8e"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#2b5a90"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#2b5a91"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#2b5b90"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#2f5d90"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#315c8d"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#37608e"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#36608e"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1z",
    fill: "#365e90"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1z",
    fill: "#365f91"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#376090"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1z",
    fill: "#3d6790"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-1h1z",
    fill: "#3a648f"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1z",
    fill: "#3d6693"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#3e6893"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v1h-1v-1z",
    fill: "#3a6393"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75h-1v-1h1z",
    fill: "#406996"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75v-1h1v1z",
    fill: "#426994"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h-1v-1h1z",
    fill: "#416897"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75v-1h1v1z",
    fill: "#3e679c"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M96 74v1h-1v-1z",
    fill: "#31619b"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v-1h1v1z",
    fill: "#2f62a2"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74v1h-1v-1z",
    fill: "#3161a3"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75v-1h1v1z",
    fill: "#3062a1"
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M100 75h-1v-1h1z",
    fill: "#2f63a1"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74v1h-1v-1z",
    fill: "#3064a3"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v-1h1v1z",
    fill: "#3063a5"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M103 74v1h-1v-1z",
    fill: "#3165a5"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M106 75h-1v-1h1z",
    fill: "#3265a7"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M106 74h1v1h-1z",
    fill: "#3166a6"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75h-1v-1h1z",
    fill: "#3167a7"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75v-1h1v1z",
    fill: "#3267a9"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M110 74v1h-1v-1z",
    fill: "#3468ab"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M110 74h1v1h-1z",
    fill: "#3369ab"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M113 75v-1h1v1z",
    fill: "#3169ac"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M114 74h1v1h-1z",
    fill: "#326aab"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M116 74v1h-1v-1z",
    fill: "#306cb1"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M117 75h-1v-1h1z",
    fill: "#356cae"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M118 75h-1v-1h1z",
    fill: "#3773b2"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M119 75h-1v-1h1z",
    fill: "#253b50"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M120 74v1h-1v-1z",
    fill: "#131211"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M123 74v1h-1v-1z",
    fill: "#151616",
    fillOpacity: 0.922
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M123 75v-1h1v1z",
    fill: "#231a23",
    fillOpacity: 0.114
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#7f7f00",
    fillOpacity: 0.016
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fillOpacity: 0.047
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#0f0000",
    fillOpacity: 0.063
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fillOpacity: 0.11
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#2c3c41",
    fillOpacity: 0.38
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#2b434a",
    fillOpacity: 0.98
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#273d47"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#293d46"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#283c45"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#283c46"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#263c45"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#253c46"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#253b45"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#253c45"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#243a45"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#243948"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#263b48"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#223b48"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#233b49"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#223a4a"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#233a4b"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#233b4c"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#243b4d"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#243b4f"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#273e51"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#263f4f"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#263e51"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#273f53"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#284153"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1z",
    fill: "#264053"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75v1h-1v-1z",
    fill: "#284157"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76v-1h1v1z",
    fill: "#274158"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75v1h-1v-1z",
    fill: "#274057"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M91 76h-1v-1h1z",
    fill: "#28435a"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h1v1h-1z",
    fill: "#264458"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M93 75v1h-1v-1z",
    fill: "#26445a"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v-1h1v1z",
    fill: "#24435c"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h1v1h-1z",
    fill: "#24435d"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v1h-1v-1z",
    fill: "#234461"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76h-1v-1h1z",
    fill: "#234564"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h-1v-1h1z",
    fill: "#264765"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v1h-1v-1z",
    fill: "#264866"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M102 76h-1v-1h1z",
    fill: "#264868"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M103 75v1h-1v-1z",
    fill: "#284966"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M103 76v-1h1v1z",
    fill: "#284864"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M104 75h1v1h-1z",
    fill: "#284867"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M105 76v-1h1v1z",
    fill: "#29496a"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M107 75v1h-1v-1z",
    fill: "#284a6b"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M107 76v-1h1v1z",
    fill: "#284b6c"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M108 76v-1h1v1z",
    fill: "#294b6e"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M110 76h-1v-1h1z",
    fill: "#2a4c70"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M110 75h1v1h-1z",
    fill: "#2b4d72"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75v1h-1v-1z",
    fill: "#2b4e74"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75h1v1h-1z",
    fill: "#2b4f75"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M114 75v1h-1v-1z",
    fill: "#2b5077"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M115 75v1h-1v-1z",
    fill: "#2d5276"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M115 76v-1h1v1z",
    fill: "#2a537b"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M117 76h-1v-1h1z",
    fill: "#2e527b"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M117 76v-1h1v1z",
    fill: "#2d5276",
    fillOpacity: 0.937
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M119 75v1h-1v-1z",
    fill: "#121b24",
    fillOpacity: 0.663
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M119 76v-1h1v1z",
    fill: "#060805",
    fillOpacity: 0.588
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M121 76h-1v-1h1z",
    fill: "#070907",
    fillOpacity: 0.541
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M122 76h-1v-1h1z",
    fill: "#070705",
    fillOpacity: 0.522
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M123 76h-1v-1h1z",
    fill: "#0f0f0b",
    fillOpacity: 0.263
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#99b299",
    fillOpacity: 0.039
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h1v1h-1z",
    fill: "#859b90",
    fillOpacity: 0.09
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-1v-1z",
    fill: "#839183",
    fillOpacity: 0.137
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1z",
    fill: "#758975",
    fillOpacity: 0.196
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#6e7f6e",
    fillOpacity: 0.235
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#6e7d6e",
    fillOpacity: 0.2
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#667a66",
    fillOpacity: 0.204
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#6c7e6c",
    fillOpacity: 0.396
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#78907b",
    fillOpacity: 0.808
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#738e77",
    fillOpacity: 0.863
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#708c73",
    fillOpacity: 0.847
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#708c74",
    fillOpacity: 0.835
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#6c8870",
    fillOpacity: 0.82
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#6b866e",
    fillOpacity: 0.812
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#6e8970",
    fillOpacity: 0.824
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#6d8870",
    fillOpacity: 0.82
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#6c8770",
    fillOpacity: 0.82
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#6d8771",
    fillOpacity: 0.812
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#6c8671",
    fillOpacity: 0.808
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#6d8771",
    fillOpacity: 0.804
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#6e8770",
    fillOpacity: 0.8
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#6d866f",
    fillOpacity: 0.788
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#6c856e",
    fillOpacity: 0.776
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#68826a",
    fillOpacity: 0.776
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#68816a",
    fillOpacity: 0.788
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#647e68",
    fillOpacity: 0.784
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#5f7862",
    fillOpacity: 0.788
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#627d6a",
    fillOpacity: 0.788
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#647e6b",
    fillOpacity: 0.773
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1z",
    fill: "#69806b",
    fillOpacity: 0.855
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#758d75",
    fillOpacity: 0.996
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#6f8b72"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#6e8a71"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#6f8971"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#6e8871"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#6d876f"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#6c866f"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#6a856d"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#68856e"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#698472"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#67826f"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#688371"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#678170"
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1z",
    fill: "#657f69"
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#647e68"
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#68816e"
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#657e6a"
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#607965"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#607865"
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#5e7763"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#5e7762"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#5c7562"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#597361"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#587160"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1z",
    fill: "#5a725f"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#597161"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#5b7263"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#576e5e"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#526c5b"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#526b5a"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#506959"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#4f685a"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77h-1v-1h1z",
    fill: "#4f6558"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M92 76v1h-1v-1z",
    fill: "#4d6255"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77h-1v-1h1z",
    fill: "#4b6256"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77h-1v-1h1z",
    fill: "#4a6155"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77v-1h1v1z",
    fill: "#4a6056"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76v1h-1v-1z",
    fill: "#485f55"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h-1v-1h1z",
    fill: "#475e54"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M98 77h-1v-1h1z",
    fill: "#475d53"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h-1v-1h1z",
    fill: "#445b52"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77v-1h1v1z",
    fill: "#435953"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h1v1h-1z",
    fill: "#425852"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M102 77h-1v-1h1z",
    fill: "#425752"
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M103 77h-1v-1h1z",
    fill: "#415750"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h-1v-1h1z",
    fill: "#3f564e"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77v-1h1v1z",
    fill: "#3e544e"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M106 77h-1v-1h1z",
    fill: "#3d534f"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M107 77h-1v-1h1z",
    fill: "#3c524f"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M107 76h1v1h-1z",
    fill: "#3b514e"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M108 76h1v1h-1z",
    fill: "#3c514f"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77h-1v-1h1z",
    fill: "#3b5150"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77v-1h1v1z",
    fill: "#3a4f4f"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M112 76v1h-1v-1z",
    fill: "#39504f"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M113 76v1h-1v-1z",
    fill: "#395151"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M113 76h1v1h-1z",
    fill: "#385151"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M115 77h-1v-1h1z",
    fill: "#375051"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M115 76h1v1h-1z",
    fill: "#354f50"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M116 76h1v1h-1z",
    fill: "#365151"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M118 77h-1v-1h1z",
    fill: "#3a4e52",
    fillOpacity: 0.494
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.047
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77h1v1h-1z",
    fill: "#696969",
    fillOpacity: 0.067
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77h1v1h-1z",
    fill: "#879884",
    fillOpacity: 0.467
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#849a82",
    fillOpacity: 0.757
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#80997e",
    fillOpacity: 0.835
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#7e977d",
    fillOpacity: 0.906
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#7d957c",
    fillOpacity: 0.949
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M27 78v-1h1v1z",
    fill: "#7c957b",
    fillOpacity: 0.988
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1z",
    fill: "#819a81"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#7e9980",
    fillOpacity: 0.988
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#7c977c",
    fillOpacity: 0.992
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#7f987d"
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#93b093"
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#8eab8c"
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#8fab8c"
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#90ac8e"
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#8eaa8b"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#8dac8b"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#8dab8a"
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#8baa8a"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#8caa8b"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#87a585"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#84a283"
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#82a082"
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#809d7f"
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#819f7f"
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#85a384"
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#7f9b7d"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#82a17e"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#82a27f"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#83a281"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#84a281"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#82a080"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#88a48b"
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#9fbaa8"
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#9db8a7"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#94b09f"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#a4c1b0"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#85a38b"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#809f83"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#92af96"
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#8ca88f"
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#84a188"
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#8fac94"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#88a68e"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#8ba78f"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#88a38c"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#8ca890"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#81a083"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#8ead92"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#85a388"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#83a184"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#88a48a"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#85a285"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#88a589"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#87a38a"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77v1h-1v-1z",
    fill: "#88a68d"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v-1h1v1z",
    fill: "#88a58d"
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78v-1h1v1z",
    fill: "#86a288"
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M95 77v1h-1v-1z",
    fill: "#82a083"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M96 77v1h-1v-1z",
    fill: "#84a385"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78v-1h1v1z",
    fill: "#809f7f"
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h1v1h-1z",
    fill: "#7f9f7f"
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78v-1h1v1z",
    fill: "#7f9e7f"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h1v1h-1z",
    fill: "#809f80"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78v-1h1v1z",
    fill: "#7f9e82"
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M103 78v-1h1v1z",
    fill: "#7e9d82"
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h1v1h-1z",
    fill: "#7e9c81"
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M106 77v1h-1v-1z",
    fill: "#7d9c81"
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M108 78v-1h1v1z",
    fill: "#7e9b81"
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77v1h-1v-1z",
    fill: "#7e9b82"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M110 78v-1h1v1z",
    fill: "#7d9b80"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M112 78h-1v-1h1z",
    fill: "#7c9b7e"
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M113 77v1h-1v-1z",
    fill: "#7b9a80"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M113 78v-1h1v1z",
    fill: "#79997f"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M115 77v1h-1v-1z",
    fill: "#78987f"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M115 78v-1h1v1z",
    fill: "#79977c"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M117 77v1h-1v-1z",
    fill: "#76997b"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M117 78v-1h1v1z",
    fill: "#708873",
    fillOpacity: 0.906
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M118 77h1v1h-1z",
    fill: "#262d2c",
    fillOpacity: 0.702
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M119 77h1v1h-1z",
    fill: "#212222",
    fillOpacity: 0.659
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M120 78v-1h1v1z",
    fill: "#212121",
    fillOpacity: 0.624
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M121 77h1v1h-1z",
    fill: "#242420",
    fillOpacity: 0.58
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M122 77h1v1h-1z",
    fill: "#31312c",
    fillOpacity: 0.224
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79h-1v-1h1z",
    fill: "#30302b",
    fillOpacity: 0.208
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79v-1h1v1z",
    fill: "#282c26",
    fillOpacity: 0.624
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1z",
    fill: "#2a342a",
    fillOpacity: 0.82
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79v-1h1v1z",
    fill: "#293329",
    fillOpacity: 0.906
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78v1h-1v-1z",
    fill: "#38443a",
    fillOpacity: 0.925
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79h-1v-1h1z",
    fill: "#9db29b"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v-1h1v1z",
    fill: "#abc5a5"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M25 78v1h-1v-1z",
    fill: "#abc5a7"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1z",
    fill: "#a6c0a2"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1z",
    fill: "#acc5a8"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#9fb89b"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1z",
    fill: "#9bb398"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#a5baa4"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#a7bba5"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#9cb197"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#9fb799"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#9fba99"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#9eba97"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#9bb796"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#9db898"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#9bb797"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#98b594"
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#97b592"
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#98b694"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#9ab896"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#9cb796"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#9cb795"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#98b494"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#96b392"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#8ba684"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#839e79"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#829d7a"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#85a17e"
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#85a07e"
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1z",
    fill: "#849e7e"
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#92ac93"
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#a5bdaa"
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#8ea890"
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#8aa488"
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#a5bea9"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#9ab49b"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#86a084"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#98b199"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-1v-1z",
    fill: "#8ea88e"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#9bb69c"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#92ad95"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#9fb8a2"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#99b29c"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#97b098"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#97b099"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#a0b9a3"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#8ca68d"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M83 79v-1h1v1z",
    fill: "#97b299"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#86a186"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#8aa687"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1z",
    fill: "#9db7a0"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1z",
    fill: "#93ac96"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78h1v1h-1z",
    fill: "#96af96"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M89 79v-1h1v1z",
    fill: "#91ab91"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79v-1h1v1z",
    fill: "#93ad95"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78h1v1h-1z",
    fill: "#96af99"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h-1v-1h1z",
    fill: "#91aa94"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1z",
    fill: "#95ae97"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#8aa58b"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M96 79h-1v-1h1z",
    fill: "#90ab8f"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h-1v-1h1z",
    fill: "#839e7f"
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78h1v1h-1z",
    fill: "#839f7d"
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h-1v-1h1z",
    fill: "#819e7c"
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79v-1h1v1z",
    fill: "#809d7b"
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M105 78h1v1h-1z",
    fill: "#7e9c7b"
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M107 78v1h-1v-1z",
    fill: "#7e9c7a"
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M107 78h1v1h-1z",
    fill: "#7e9d7a"
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M109 79h-1v-1h1z",
    fill: "#7f9d7b"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79h-1v-1h1z",
    fill: "#7e9d78"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M114 79h-1v-1h1z",
    fill: "#7e9e78"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M114 78h1v1h-1z",
    fill: "#7c9d79"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M117 78v1h-1v-1z",
    fill: "#7c9e77"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M117 78h1v1h-1z",
    fill: "#809c7c"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M118 79v-1h1v1z",
    fill: "#313c34"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M119 78h1v1h-1z",
    fill: "#191b1b"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M123 79h-1v-1h1z",
    fill: "#1e1e1e",
    fillOpacity: 0.847
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M123 79v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.059
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M17 80v-1h1v1z",
    fill: "#2f2f2f",
    fillOpacity: 0.063
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79v1h-1v-1z",
    fill: "#1b1f1b",
    fillOpacity: 0.22
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#191f16",
    fillOpacity: 0.349
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79h1v1h-1z",
    fill: "#181f18",
    fillOpacity: 0.482
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M21 79h1v1h-1z",
    fill: "#273029",
    fillOpacity: 0.58
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v1h-1v-1z",
    fill: "#6d7c68",
    fillOpacity: 0.871
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#73876b"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79h1v1h-1z",
    fill: "#758c70"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80h-1v-1h1z",
    fill: "#778e70"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#7b9273"
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#799170"
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#718b69"
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h-1v-1h1z",
    fill: "#748d6c"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#73896c"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#728a6a"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#819a77"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#819b77"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#849d7a"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#8aa481"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#849e7b"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#859f7c"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#8ba582"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#88a280"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1z",
    fill: "#7e9773"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#7e9874"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#7f9973"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#7f9978"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#7e9973"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#829c7c"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#809a78"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#7f9a76"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#87a082"
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#8ba486"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#8da78a"
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#8ea68b"
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#8ea789"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#91aa8c"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#96af92"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#94ad8e"
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#99b294"
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#98b194"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#9cb598"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v-1h1v1z",
    fill: "#9fb99d"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80v-1h1v1z",
    fill: "#a5bfa4"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79h1v1h-1z",
    fill: "#a8c0a8"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M92 79v1h-1v-1z",
    fill: "#a9c2aa"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80v-1h1v1z",
    fill: "#abc3ab"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h1v1h-1z",
    fill: "#afc7b0"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M95 80h-1v-1h1z",
    fill: "#abc1ab"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80h-1v-1h1z",
    fill: "#acc2aa"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80v-1h1v1z",
    fill: "#abc1a7"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h1v1h-1z",
    fill: "#adc3ab"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M99 79v1h-1v-1z",
    fill: "#adc4ac"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M99 80v-1h1v1z",
    fill: "#acc3ab"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M101 80h-1v-1h1z",
    fill: "#a9c0a7"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80h-1v-1h1z",
    fill: "#a9c0a8"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h1v1h-1z",
    fill: "#a7bea6"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M106 79v1h-1v-1z",
    fill: "#a5bca6"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M106 80v-1h1v1z",
    fill: "#a4baa4"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M107 79h1v1h-1z",
    fill: "#a4bba2"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M108 79h1v1h-1z",
    fill: "#a3baa0"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M110 80v-1h1v1z",
    fill: "#a3baa2"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79h1v1h-1z",
    fill: "#a1b7a2"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M113 80h-1v-1h1z",
    fill: "#9fb69f"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80h-1v-1h1z",
    fill: "#a0b89c"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M116 79v1h-1v-1z",
    fill: "#a0b59f"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M117 80h-1v-1h1z",
    fill: "#9db69b"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M118 80h-1v-1h1z",
    fill: "#a2baa2"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M118 79h1v1h-1z",
    fill: "#414b45"
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80h-1v-1h1z",
    fill: "#0b0d0d"
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M122 80v-1h1v1z",
    fill: "#131312",
    fillOpacity: 0.992
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81h-1v-1h1z",
    fill: "#374237",
    fillOpacity: 0.09
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1z",
    fill: "#45523b",
    fillOpacity: 0.302
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#495740",
    fillOpacity: 0.478
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#4d5b43",
    fillOpacity: 0.604
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#505f46",
    fillOpacity: 0.694
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#556349",
    fillOpacity: 0.776
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M28 80h1v1h-1z",
    fill: "#526349",
    fillOpacity: 0.831
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80v1h-1v-1z",
    fill: "#4f6047",
    fillOpacity: 0.925
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#4c5b43",
    fillOpacity: 0.992
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#58694e"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#687c5e"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#677c5c"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#677c5d"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#687c5d"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#697d5e"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#6a7e5f"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#6b7f60"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#6b7f5e"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#6b805e"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#6c8262"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#6d8362"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#6f8563"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#6e8564"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#708665"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#6c8362"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#6c8361"
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#6f8564"
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#6d8361"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#6a805f"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#718967"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#728967"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#728b68"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#738b69"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#738c69"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#748d6a"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#758d6a"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#758e6a"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#768f6c"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#839b7d"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#7c9374"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#7b9373"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#788f6e"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#788f6f"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#7b9174"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#778e6d"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#7a926f"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#778f6e"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#79906f"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#78906f"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#7f9677"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v1h-1v-1z",
    fill: "#7d9477"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1z",
    fill: "#78906e"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1z",
    fill: "#79916e"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v-1h1v1z",
    fill: "#7a9270"
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h1v1h-1z",
    fill: "#7d9572"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80v1h-1v-1z",
    fill: "#7b9371"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80h1v1h-1z",
    fill: "#7c9472"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80h1v1h-1z",
    fill: "#7c9473"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h-1v-1h1z",
    fill: "#7e9675"
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M94 80h1v1h-1z",
    fill: "#7f987a"
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M95 81v-1h1v1z",
    fill: "#7f9878"
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M97 80v1h-1v-1z",
    fill: "#829b78"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80v1h-1v-1z",
    fill: "#839c7c"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80h1v1h-1z",
    fill: "#879d7c"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M99 80h1v1h-1z",
    fill: "#8a9f7e"
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81v-1h1v1z",
    fill: "#8ca180"
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80v1h-1v-1z",
    fill: "#8fa483"
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81v-1h1v1z",
    fill: "#91a686"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M103 80h1v1h-1z",
    fill: "#94a88b"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81h-1v-1h1z",
    fill: "#97ac8f"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81v-1h1v1z",
    fill: "#99ad92"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M106 81v-1h1v1z",
    fill: "#9caf96"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M107 81v-1h1v1z",
    fill: "#9fb197"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M108 81v-1h1v1z",
    fill: "#9db095"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M110 81h-1v-1h1z",
    fill: "#9fb19b"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M111 81h-1v-1h1z",
    fill: "#adbeac"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M112 80v1h-1v-1z",
    fill: "#aec0b1"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81h-1v-1h1z",
    fill: "#afc1af"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81v-1h1v1z",
    fill: "#a7baa1"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M115 80v1h-1v-1z",
    fill: "#adc0a8"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M115 81v-1h1v1z",
    fill: "#b0bfaa"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M117 80v1h-1v-1z",
    fill: "#b4c4ad"
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M117 80h1v1h-1z",
    fill: "#b8c9b3"
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M119 80v1h-1v-1z",
    fill: "#515850"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M123 81v-1h1v1z",
    fill: "#1d1d19",
    fillOpacity: 0.275
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M29 82v-1h1v1z",
    fill: "#313129",
    fillOpacity: 0.122
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#323628",
    fillOpacity: 0.22
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#464e3f",
    fillOpacity: 0.522
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#4a5541",
    fillOpacity: 0.98
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#4e5b45"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#4f5c46"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#4e5d46"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#505f47"
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#526349"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#53634a"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#53644a"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#54654b"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1z",
    fill: "#54664a"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#55674a"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#56694c"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#576a4c"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#56694b"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#57694c"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#596b4d"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#55684a"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#586b4d"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#5f7354"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#607656"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#5f7756"
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#607857"
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#617857"
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#627a55"
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#637b58"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1z",
    fill: "#637b5a"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#647b5a"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#647b5c"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#698062"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#748a73"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#72866f"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#768a72"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#70836b"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#72866e"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#7b8f79"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#748871"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#788c72"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#798d74"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#7c9078"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#71856b"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#7a8e75"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1z",
    fill: "#7c9079"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1z",
    fill: "#80917c"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v1h-1v-1z",
    fill: "#7f907a"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h-1v-1h1z",
    fill: "#74866d"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82v-1h1v1z",
    fill: "#829479"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M90 81h1v1h-1z",
    fill: "#7c9177"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v-1h1v1z",
    fill: "#7a8f75"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v-1h1v1z",
    fill: "#7b9076"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M93 81h1v1h-1z",
    fill: "#7f947b"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h1v1h-1z",
    fill: "#81967c"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M96 82h-1v-1h1z",
    fill: "#748a6a"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h-1v-1h1z",
    fill: "#718862"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82v-1h1v1z",
    fill: "#718765"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81h1v1h-1z",
    fill: "#718964"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h-1v-1h1z",
    fill: "#708964"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M105 82h-1v-1h1z",
    fill: "#718965"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M107 82h-1v-1h1z",
    fill: "#758a68"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M107 81h1v1h-1z",
    fill: "#758966"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M108 81h1v1h-1z",
    fill: "#768a65"
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M109 82v-1h1v1z",
    fill: "#758969"
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82h-1v-1h1z",
    fill: "#84977c"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82v-1h1v1z",
    fill: "#879b84"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81v1h-1v-1z",
    fill: "#84997d"
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M114 81v1h-1v-1z",
    fill: "#758b69"
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M114 82v-1h1v1z",
    fill: "#748c69"
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M116 82v-1h1v1z",
    fill: "#768d6a"
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M118 81v1h-1v-1z",
    fill: "#7b9272"
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M118 82v-1h1v1z",
    fill: "#404a3c"
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M123 82h-1v-1h1z",
    fill: "#141212"
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M123 82v-1h1v1z",
    fill: "#1d1919",
    fillOpacity: 0.271
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#3b3b32",
    fillOpacity: 0.22
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#393c31",
    fillOpacity: 0.365
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#3c3e34",
    fillOpacity: 0.4
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#3b3d33",
    fillOpacity: 0.424
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#3a3c33",
    fillOpacity: 0.443
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#3b3f32",
    fillOpacity: 0.455
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#3c4033",
    fillOpacity: 0.467
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#3e4235",
    fillOpacity: 0.482
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#3e4234",
    fillOpacity: 0.514
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#3c4233",
    fillOpacity: 0.541
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#3d4234",
    fillOpacity: 0.569
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#3d4536",
    fillOpacity: 0.604
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#3e4436",
    fillOpacity: 0.627
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#3c4534",
    fillOpacity: 0.647
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#3d4534",
    fillOpacity: 0.686
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#3c4534",
    fillOpacity: 0.722
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#3e4635",
    fillOpacity: 0.741
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#3e4734",
    fillOpacity: 0.757
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#3e4733",
    fillOpacity: 0.78
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#3e4633",
    fillOpacity: 0.812
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#3f4734",
    fillOpacity: 0.851
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#3f4836",
    fillOpacity: 0.882
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#3a4431",
    fillOpacity: 0.91
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#435039"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#48573e"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#48563e"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#49573f"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#49583f"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#4a593f"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#4a5a40"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#4a5b40"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#4b5c41"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#4b5d40"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#4c5e40"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#4d5f43"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#4e6043"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#4f5f43"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#4f6045"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#506247"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#506249"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#4f6148"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#51634a"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#52644a"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#52644b"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#56674f"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#576850"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1z",
    fill: "#576950"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1z",
    fill: "#57694f"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#5d6d55"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h-1v-1h1z",
    fill: "#5c6d54"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M89 83h-1v-1h1z",
    fill: "#5b6b52"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h1v1h-1z",
    fill: "#5f7057"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v1h-1v-1z",
    fill: "#5f7059"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v1h-1v-1z",
    fill: "#5f705a"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M92 83v-1h1v1z",
    fill: "#62735c"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83v-1h1v1z",
    fill: "#64755e"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82h1v1h-1z",
    fill: "#62735b"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M96 83h-1v-1h1z",
    fill: "#617256"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83h-1v-1h1z",
    fill: "#5f7153"
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h1v1h-1z",
    fill: "#627155"
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82h1v1h-1z",
    fill: "#617255"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M99 82h1v1h-1z",
    fill: "#617456"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h1v1h-1z",
    fill: "#637758"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M106 83h-1v-1h1z",
    fill: "#657759"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M106 82h1v1h-1z",
    fill: "#65795a"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83v-1h1v1z",
    fill: "#647a5a"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M108 83v-1h1v1z",
    fill: "#657b5b"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M109 82h1v1h-1z",
    fill: "#657a5b"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M110 82h1v1h-1z",
    fill: "#667a5b"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82h1v1h-1z",
    fill: "#66795c"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83h-1v-1h1z",
    fill: "#677a5c"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83v-1h1v1z",
    fill: "#697c5e"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M115 83h-1v-1h1z",
    fill: "#697d5d"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M116 83h-1v-1h1z",
    fill: "#687f5f"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M117 83h-1v-1h1z",
    fill: "#68805d"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M117 83v-1h1v1z",
    fill: "#6e8063"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M119 83h-1v-1h1z",
    fill: "#3a4237"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M123 82v1h-1v-1z",
    fill: "#1d1c1c",
    fillOpacity: 0.984
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M123 82h1v1h-1z",
    fill: "#262626",
    fillOpacity: 0.18
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#2a2a2a",
    fillOpacity: 0.071
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#2c2c21",
    fillOpacity: 0.09
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#3f4134",
    fillOpacity: 0.533
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#3e4233",
    fillOpacity: 0.525
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#3e4433",
    fillOpacity: 0.541
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#3c4131",
    fillOpacity: 0.565
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#3d4433",
    fillOpacity: 0.588
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#3c4333",
    fillOpacity: 0.624
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#3d4534",
    fillOpacity: 0.651
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#3b4433",
    fillOpacity: 0.675
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#3d4434",
    fillOpacity: 0.702
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#3d4434",
    fillOpacity: 0.729
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#3c4533",
    fillOpacity: 0.745
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#3c4533",
    fillOpacity: 0.761
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#3b4333",
    fillOpacity: 0.784
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#3c4432",
    fillOpacity: 0.812
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#3e4533",
    fillOpacity: 0.831
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#3d4635",
    fillOpacity: 0.839
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#3f4738",
    fillOpacity: 0.851
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#444b3c",
    fillOpacity: 0.863
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#43493b",
    fillOpacity: 0.878
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M76 83v1h-1v-1z",
    fill: "#41493a",
    fillOpacity: 0.882
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#424a3b",
    fillOpacity: 0.902
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#434a3c",
    fillOpacity: 0.914
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#3f4736",
    fillOpacity: 0.933
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#424b3a",
    fillOpacity: 0.941
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#414a39",
    fillOpacity: 0.949
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1z",
    fill: "#424b3a",
    fillOpacity: 0.957
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#434b3b",
    fillOpacity: 0.965
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#434b3a",
    fillOpacity: 0.973
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h-1v-1h1z",
    fill: "#414837",
    fillOpacity: 0.984
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84h-1v-1h1z",
    fill: "#444b3b",
    fillOpacity: 0.992
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M87 83v1h-1v-1z",
    fill: "#434b39"
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M87 84v-1h1v1z",
    fill: "#444d3a"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h1v1h-1z",
    fill: "#444d39"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M90 83v1h-1v-1z",
    fill: "#444c39"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M90 84v-1h1v1z",
    fill: "#464e3b"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M91 83h1v1h-1z",
    fill: "#464f3b"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M92 84v-1h1v1z",
    fill: "#434c39"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83h1v1h-1z",
    fill: "#434b38"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84v-1h1v1z",
    fill: "#434d3b"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h-1v-1h1z",
    fill: "#444f3b"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83v1h-1v-1z",
    fill: "#46503b"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M98 84h-1v-1h1z",
    fill: "#47503c"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M98 83h1v1h-1z",
    fill: "#47513c"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83v1h-1v-1z",
    fill: "#47523c"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83h1v1h-1z",
    fill: "#48533d"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "M102 83v1h-1v-1z",
    fill: "#49533e"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "M102 84v-1h1v1z",
    fill: "#49553f"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84h-1v-1h1z",
    fill: "#4a563f"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84v-1h1v1z",
    fill: "#4a5640"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "M105 83h1v1h-1z",
    fill: "#4b5641"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83h1v1h-1z",
    fill: "#4b5942"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "M112 83h1v1h-1z",
    fill: "#4e5c45"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83h1v1h-1z",
    fill: "#505e47"
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "M115 83v1h-1v-1z",
    fill: "#515e48"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "M115 83h1v1h-1z",
    fill: "#525f4a"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "M117 84h-1v-1h1z",
    fill: "#536149"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "M117 83h1v1h-1z",
    fill: "#58634e"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "M118 84v-1h1v1z",
    fill: "#23251f"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "M119 83h1v1h-1z",
    fill: "#121312",
    fillOpacity: 0.976
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "M120 83h1v1h-1z",
    fill: "#161515",
    fillOpacity: 0.976
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "M121 83h1v1h-1z",
    fill: "#171516",
    fillOpacity: 0.973
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "M123 84h-1v-1h1z",
    fill: "#1a171a",
    fillOpacity: 0.671
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "M123 84v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.02
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#636",
    fillOpacity: 0.02
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#3f3f3f",
    fillOpacity: 0.031
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.035
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#4c4c4c",
    fillOpacity: 0.039
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#4e3a3a",
    fillOpacity: 0.051
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#4f3f3f",
    fillOpacity: 0.063
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#4b4b3c",
    fillOpacity: 0.067
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#48483c",
    fillOpacity: 0.082
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#473d3d",
    fillOpacity: 0.098
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#414139",
    fillOpacity: 0.122
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#41413a",
    fillOpacity: 0.137
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#434335",
    fillOpacity: 0.149
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#464639",
    fillOpacity: 0.157
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#47473b",
    fillOpacity: 0.169
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1z",
    fill: "#46463b",
    fillOpacity: 0.184
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85v-1h1v1z",
    fill: "#434339",
    fillOpacity: 0.208
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h1v1h-1z",
    fill: "#414139",
    fillOpacity: 0.227
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85v-1h1v1z",
    fill: "#404038",
    fillOpacity: 0.247
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "M88 85h-1v-1h1z",
    fill: "#404439",
    fillOpacity: 0.263
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "M89 84v1h-1v-1z",
    fill: "#404039",
    fillOpacity: 0.278
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1z",
    fill: "#3c3f35",
    fillOpacity: 0.298
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84h1v1h-1z",
    fill: "#3c3f34",
    fillOpacity: 0.345
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "M92 85v-1h1v1z",
    fill: "#3d3f35",
    fillOpacity: 0.376
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "M93 85v-1h1v1z",
    fill: "#3c3e32",
    fillOpacity: 0.4
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84h1v1h-1z",
    fill: "#393e30",
    fillOpacity: 0.416
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "M95 84h1v1h-1z",
    fill: "#3c3f33",
    fillOpacity: 0.443
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h1v1h-1z",
    fill: "#3b3d32",
    fillOpacity: 0.475
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "M98 85h-1v-1h1z",
    fill: "#393b2f",
    fillOpacity: 0.506
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "M98 85v-1h1v1z",
    fill: "#393b2e",
    fillOpacity: 0.557
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "M100 85h-1v-1h1z",
    fill: "#3b3d31",
    fillOpacity: 0.588
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "M101 84v1h-1v-1z",
    fill: "#3c3d30",
    fillOpacity: 0.6
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85h-1v-1h1z",
    fill: "#3a3c2f",
    fillOpacity: 0.627
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "M103 84v1h-1v-1z",
    fill: "#3a3d31",
    fillOpacity: 0.647
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85v-1h1v1z",
    fill: "#3a3c30",
    fillOpacity: 0.663
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "M104 85v-1h1v1z",
    fill: "#3b3c30",
    fillOpacity: 0.694
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "M105 84h1v1h-1z",
    fill: "#383b2f",
    fillOpacity: 0.722
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "M107 85h-1v-1h1z",
    fill: "#393c2f",
    fillOpacity: 0.733
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "M108 85h-1v-1h1z",
    fill: "#383c2f",
    fillOpacity: 0.761
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "M109 85h-1v-1h1z",
    fill: "#393c30",
    fillOpacity: 0.776
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "M109 84h1v1h-1z",
    fill: "#3b3e31",
    fillOpacity: 0.788
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "M110 85v-1h1v1z",
    fill: "#3b3f33",
    fillOpacity: 0.804
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "M111 85v-1h1v1z",
    fill: "#393e31",
    fillOpacity: 0.835
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "M113 84v1h-1v-1z",
    fill: "#393e31",
    fillOpacity: 0.867
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "M113 85v-1h1v1z",
    fill: "#3a3f31",
    fillOpacity: 0.871
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "M115 85h-1v-1h1z",
    fill: "#3b4032",
    fillOpacity: 0.875
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "M116 84v1h-1v-1z",
    fill: "#3c3f34",
    fillOpacity: 0.855
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "M116 85v-1h1v1z",
    fill: "#3c3f33",
    fillOpacity: 0.804
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "M118 85h-1v-1h1z",
    fill: "#3f4334",
    fillOpacity: 0.596
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "M118 84h1v1h-1z",
    fill: "#16160f",
    fillOpacity: 0.263
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "M119 84h1v1h-1z",
    fill: "#050505",
    fillOpacity: 0.192
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "M121 85h-1v-1h1z",
    fill: "#0f0f0f",
    fillOpacity: 0.188
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "M122 84v1h-1v-1z",
    fill: "#101010",
    fillOpacity: 0.18
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "M122 85v-1h1v1z",
    fill: "#191919",
    fillOpacity: 0.039
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86h-1v-1h1z",
    fill: "#483636",
    fillOpacity: 0.055
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "M115 85h1v1h-1z",
    fill: "#553f3f",
    fillOpacity: 0.047
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.027
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91v-1h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.047
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#919191",
    fillOpacity: 0.055
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#888",
    fillOpacity: 0.059
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#788778",
    fillOpacity: 0.067
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#6b786b",
    fillOpacity: 0.075
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#8f9f8f",
    fillOpacity: 0.063
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.059
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#999",
    fillOpacity: 0.059
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#7f8f7f",
    fillOpacity: 0.063
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#887",
    fillOpacity: 0.059
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#899c89",
    fillOpacity: 0.051
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#9c9c89",
    fillOpacity: 0.051
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#999",
    fillOpacity: 0.039
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.035
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#9f9f9f",
    fillOpacity: 0.031
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#d4aad4",
    fillOpacity: 0.024
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#bfbfff",
    fillOpacity: 0.016
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "M114 91v-1h1v1z",
    fill: "#dab6b6",
    fillOpacity: 0.027
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "M116 91h-1v-1h1z",
    fill: "#a2a2a2",
    fillOpacity: 0.043
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "M117 90v1h-1v-1z",
    fill: "#737373",
    fillOpacity: 0.086
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "M117 90h1v1h-1z",
    fill: "#3f3f3f",
    fillOpacity: 0.22
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "M118 90h1v1h-1z",
    fill: "#454545",
    fillOpacity: 0.259
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "M119 91v-1h1v1z",
    fill: "#494949",
    fillOpacity: 0.259
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "M121 91h-1v-1h1z",
    fill: "#505049",
    fillOpacity: 0.149
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "M24 91v1h-1v-1z",
    fill: "#8d8d8d",
    fillOpacity: 0.035
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-1v-1z",
    fill: "#333738",
    fillOpacity: 0.616
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#37373a",
    fillOpacity: 0.816
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h-1v-1h1z",
    fill: "#333436",
    fillOpacity: 0.843
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#313233",
    fillOpacity: 0.855
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91h1v1h-1z",
    fill: "#2f3131",
    fillOpacity: 0.855
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1z",
    fill: "#2d2f2e",
    fillOpacity: 0.859
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#2d2f2e",
    fillOpacity: 0.863
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#2f3130",
    fillOpacity: 0.867
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#2c302f",
    fillOpacity: 0.871
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91h1v1h-1z",
    fill: "#3c4c33",
    fillOpacity: 0.863
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#4e6b36",
    fillOpacity: 0.882
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#537046",
    fillOpacity: 0.894
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#81a08f",
    fillOpacity: 0.878
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-1h1z",
    fill: "#88a093",
    fillOpacity: 0.875
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#5d754b",
    fillOpacity: 0.871
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#516b34",
    fillOpacity: 0.878
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#4f6a35",
    fillOpacity: 0.871
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#4c6733",
    fillOpacity: 0.859
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#51693e",
    fillOpacity: 0.863
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#4e6838",
    fillOpacity: 0.855
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#4f6a38",
    fillOpacity: 0.851
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#506b39",
    fillOpacity: 0.855
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#4f6a3e",
    fillOpacity: 0.843
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#506b41",
    fillOpacity: 0.835
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#4e6939",
    fillOpacity: 0.824
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#506937",
    fillOpacity: 0.812
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#506737",
    fillOpacity: 0.8
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#4f6836",
    fillOpacity: 0.788
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#506838",
    fillOpacity: 0.784
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#4f6836",
    fillOpacity: 0.784
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#4e6736",
    fillOpacity: 0.773
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#4f6836",
    fillOpacity: 0.769
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#4f6836",
    fillOpacity: 0.765
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#51693f",
    fillOpacity: 0.761
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#526a41",
    fillOpacity: 0.761
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#51683e",
    fillOpacity: 0.765
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#51683d",
    fillOpacity: 0.765
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#526b3d",
    fillOpacity: 0.765
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#526a3b",
    fillOpacity: 0.761
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#51693c",
    fillOpacity: 0.761
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#526a3d",
    fillOpacity: 0.761
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#536b3f",
    fillOpacity: 0.753
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#536b3e",
    fillOpacity: 0.753
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#536c3d",
    fillOpacity: 0.753
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#536b3e",
    fillOpacity: 0.757
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h-1v-1h1z",
    fill: "#556b40",
    fillOpacity: 0.745
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v1h-1v-1z",
    fill: "#556a42",
    fillOpacity: 0.741
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v1h-1v-1z",
    fill: "#566c43",
    fillOpacity: 0.737
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#566d45",
    fillOpacity: 0.737
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fill: "#586d45",
    fillOpacity: 0.737
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#566e44",
    fillOpacity: 0.725
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#5a7048",
    fillOpacity: 0.718
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#5a7049",
    fillOpacity: 0.71
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#5b7048",
    fillOpacity: 0.702
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1z",
    fill: "#5a7149",
    fillOpacity: 0.706
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#5b704a",
    fillOpacity: 0.702
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#5b734a",
    fillOpacity: 0.686
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91h1v1h-1z",
    fill: "#5d734c",
    fillOpacity: 0.682
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92h-1v-1h1z",
    fill: "#5c724b",
    fillOpacity: 0.663
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h1v1h-1z",
    fill: "#597048",
    fillOpacity: 0.647
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h-1v-1h1z",
    fill: "#748a6f",
    fillOpacity: 0.627
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "M88 92h-1v-1h1z",
    fill: "#62765c",
    fillOpacity: 0.608
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "M89 91v1h-1v-1z",
    fill: "#394132",
    fillOpacity: 0.612
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92v-1h1v1z",
    fill: "#312f31",
    fillOpacity: 0.584
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91h1v1h-1z",
    fill: "#2f2f2f",
    fillOpacity: 0.565
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92h-1v-1h1z",
    fill: "#303030",
    fillOpacity: 0.541
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92v-1h1v1z",
    fill: "#323232",
    fillOpacity: 0.514
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1z",
    fill: "#363636",
    fillOpacity: 0.494
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92v-1h1v1z",
    fill: "#3a3a3a",
    fillOpacity: 0.459
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#434343",
    fillOpacity: 0.427
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v1z",
    fill: "#4a4a4a",
    fillOpacity: 0.416
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h-1v-1h1z",
    fill: "#474949",
    fillOpacity: 0.408
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "M99 91v1h-1v-1z",
    fill: "#424242",
    fillOpacity: 0.404
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v1h-1v-1z",
    fill: "#454545",
    fillOpacity: 0.388
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92h-1v-1h1z",
    fill: "#414141",
    fillOpacity: 0.412
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92v-1h1v1z",
    fill: "#282a28",
    fillOpacity: 0.467
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h-1v-1h1z",
    fill: "#272929",
    fillOpacity: 0.506
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v-1h1v1z",
    fill: "#2d2d2d",
    fillOpacity: 0.51
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92v-1h1v1z",
    fill: "#313131",
    fillOpacity: 0.486
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h-1v-1h1z",
    fill: "#323232",
    fillOpacity: 0.494
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "M107 92h-1v-1h1z",
    fill: "#313131",
    fillOpacity: 0.506
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "M107 92v-1h1v1z",
    fill: "#313131",
    fillOpacity: 0.529
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91v1h-1v-1z",
    fill: "#333",
    fillOpacity: 0.549
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91v1h-1v-1z",
    fill: "#303030",
    fillOpacity: 0.573
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91h1v1h-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.639
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92h-1v-1h1z",
    fill: "#2e2e2e",
    fillOpacity: 0.69
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "M113 91v1h-1v-1z",
    fill: "#2c2c2c",
    fillOpacity: 0.725
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "M114 92h-1v-1h1z",
    fill: "#2b2b2b",
    fillOpacity: 0.761
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "M114 91h1v1h-1z",
    fill: "#282828",
    fillOpacity: 0.816
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "M116 91v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.851
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "M117 92h-1v-1h1z",
    fill: "#2b2c2c",
    fillOpacity: 0.894
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "M118 92h-1v-1h1z",
    fill: "#2d2d2d",
    fillOpacity: 0.996
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "M120 92h-1v-1h1z",
    fill: "#2f2f2f"
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "M121 91v1h-1v-1z",
    fill: "#2d2d2c",
    fillOpacity: 0.949
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "M121 92v-1h1v1z",
    fill: "#2a2927",
    fillOpacity: 0.706
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "M123 92h-1v-1h1z",
    fill: "#2b2b2b",
    fillOpacity: 0.114
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1z",
    fill: "#4e534e",
    fillOpacity: 0.192
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v-1h1v1z",
    fill: "#3c4040",
    fillOpacity: 0.51
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "M22 93h-1v-1h1z",
    fill: "#393c3c",
    fillOpacity: 0.647
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1z",
    fill: "#3a3b3b",
    fillOpacity: 0.686
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#2e2f2e",
    fillOpacity: 0.773
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92h1v1h-1z",
    fill: "#161719"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#101213"
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#070b09"
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#344b1f"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#3f6616"
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#557b43"
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#88ae9d"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#7da386"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#416820"
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#40641c"
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#527642"
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#608356"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#557a44"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#678a62"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#4f7539"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#3a6114"
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#53773b"
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#517439"
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#45692c"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#476c2a"
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#466b29"
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#476c2c"
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#456b22"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#476c2f"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#416721"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#426821"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#4d7230"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#466c21"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#41671f"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#436824"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#456a27"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#446828"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#446929"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#446821"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#43671f"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#42671f"
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#3f661b"
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h1v1h-1z",
    fill: "#3d6415"
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#3d6316"
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#3d6417"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#406419"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#3f641a"
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h1v1h-1z",
    fill: "#406519"
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92v1h-1v-1z",
    fill: "#3d6116"
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92h1v1h-1z",
    fill: "#658757"
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h1v1h-1z",
    fill: "#5d7d53"
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "M89 93h-1v-1h1z",
    fill: "#1f2e13"
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v1h-1z",
    fill: "#0d0e0e"
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "M107 93v-1h1v1z",
    fill: "#0f100f"
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "M108 93v-1h1v1z",
    fill: "#0e0f0f"
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "M109 92h1v1h-1z",
    fill: "#111211"
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "M110 92h1v1h-1z",
    fill: "#0d0e0d"
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "M122 92h1v1h-1z",
    fill: "#191917",
    fillOpacity: 0.592
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93h1v1h-1z",
    fill: "#4a5252",
    fillOpacity: 0.122
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "M12 94v-1h1v1z",
    fill: "#474a47",
    fillOpacity: 0.349
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "M13 94v-1h1v1z",
    fill: "#454845",
    fillOpacity: 0.388
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "M15 93v1h-1v-1z",
    fill: "#464646",
    fillOpacity: 0.38
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93v1h-1v-1z",
    fill: "#474747",
    fillOpacity: 0.376
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h-1v-1h1z",
    fill: "#434345",
    fillOpacity: 0.373
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "M17 93h1v1h-1z",
    fill: "#47474a",
    fillOpacity: 0.376
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94h-1v-1h1z",
    fill: "#434545",
    fillOpacity: 0.533
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1z",
    fill: "#262827",
    fillOpacity: 0.953
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93h1v1h-1z",
    fill: "#1e2121"
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v-1h1v1z",
    fill: "#181c1d"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1z",
    fill: "#050608"
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1z",
    fill: "#070c07"
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#415e20"
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#3f6715"
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#678c5d"
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#91b6a7"
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#779f79"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93v1h-1v-1z",
    fill: "#3c6214"
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#4f7332"
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#799e79"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#6c9165"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#52783f"
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#789b77"
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#769a72"
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#40681f"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#5a8045"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#5d824d"
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#587e44"
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#5e8350"
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#5f8552"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#608555"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#4e7534"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#6d9062"
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#547a3c"
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#53793c"
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#4e7633"
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#39640e"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#507734"
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#60864b"
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#557b41"
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#557c3e"
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#4d7336"
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#61874f"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#507736"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#517636"
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#517938"
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#456f24"
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#3d660d"
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93h1v1h-1z",
    fill: "#3e6611"
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#3e6610"
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#3a6309"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93h1v1h-1z",
    fill: "#5c8547"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93v1h-1v-1z",
    fill: "#658c58"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94h-1v-1h1z",
    fill: "#223710"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "M102 94h-1v-1h1z",
    fill: "#060707"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "M120 93v1h-1v-1z",
    fill: "#060a09"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "M123 93v1h-1v-1z",
    fill: "#0f1010",
    fillOpacity: 0.886
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "M123 94v-1h1v1z",
    fill: "#2d2d2d",
    fillOpacity: 0.067
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "M9 95H8v-1h1z",
    fill: "#363d3d",
    fillOpacity: 0.129
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "M9 94h1v1H9z",
    fill: "#222b26",
    fillOpacity: 0.231
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "M11 95h-1v-1h1z",
    fill: "#2a312a",
    fillOpacity: 0.306
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "M11 94h1v1h-1z",
    fill: "#1c1d1d",
    fillOpacity: 0.82
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "M14 94v1h-1v-1z",
    fill: "#161717"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94v1h-1v-1z",
    fill: "#16181a"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h1v1h-1z",
    fill: "#1d1e20"
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94h1v1h-1z",
    fill: "#0a0c0e"
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94v1h-1v-1z",
    fill: "#1b1f20"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#181e1f"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#282f31"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#3d4141"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1z",
    fill: "#3a3b3b"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1z",
    fill: "#333536"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94v1h-1v-1z",
    fill: "#24292c"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#101419"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#141f17"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#517337"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#467022"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#7ba17b"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#a0c6b6"
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#85ab8b"
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#557d3c"
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#597f42"
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#5d864c"
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#507936"
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#4f7932"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#567f41"
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#557d41"
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#477028"
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#547b3c"
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#4d7531"
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#4c7433"
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#517839"
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#557b3e"
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#4f7637"
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#557b3b"
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#4f7430"
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#577b3a"
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#4f752b"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#43691d"
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#527934"
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#4f7831"
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#517936"
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#51793a"
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#547a39"
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#517734"
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#547a34"
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#4a712b"
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#598041"
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#527a37"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#577e3f"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#567d41"
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#547c36"
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#426a17"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#426a15"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#426b16"
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#416b13"
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#406c14"
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1z",
    fill: "#416c13"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#416914"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95h-1v-1h1z",
    fill: "#416814"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-1v-1z",
    fill: "#456c16"
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#426a13"
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#3e660e"
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#5a8342"
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#709666"
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94v1h-1v-1z",
    fill: "#2c4214"
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "M122 95v-1h1v1z",
    fill: "#131514",
    fillOpacity: 0.992
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "M124 94v1h-1v-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.231
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "M4 96v-1h1v1z",
    fill: "#444",
    fillOpacity: 0.059
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "M6 95v1H5v-1z",
    fill: "#282b28",
    fillOpacity: 0.298
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "M6 95h1v1H6z",
    fill: "#1f261f",
    fillOpacity: 0.596
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "M7 95h1v1H7z",
    fill: "#1a241d",
    fillOpacity: 0.824
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "M9 95v1H8v-1z",
    fill: "#19231c",
    fillOpacity: 0.941
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "M9 96v-1h1v1z",
    fill: "#1b251e"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "M11 95v1h-1v-1z",
    fill: "#1f2722"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "M12 96h-1v-1h1z",
    fill: "#1d221e"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "M14 96h-1v-1h1z",
    fill: "#3a4243"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "M15 95v1h-1v-1z",
    fill: "#333b3c"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "M15 96v-1h1v1z",
    fill: "#2d3636"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "M17 96h-1v-1h1z",
    fill: "#252c29"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h-1v-1h1z",
    fill: "#1b201e"
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96v-1h1v1z",
    fill: "#0c100f"
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "M19 95h1v1h-1z",
    fill: "#292b24"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "M21 95v1h-1v-1z",
    fill: "#464a43"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95v1h-1v-1z",
    fill: "#595e5b"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "M22 96v-1h1v1z",
    fill: "#676e6d"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#5f6866"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#616b67"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1z",
    fill: "#6d7771"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95h1v1h-1z",
    fill: "#7a827d"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#7f8482"
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#7c807e"
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95v1h-1v-1z",
    fill: "#686f6d"
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96h-1v-1h1z",
    fill: "#3e4849"
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#182323"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#27382b"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#668a50"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#507a32"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#8cb397"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#aad0c4"
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#8aaf90"
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#699053"
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#688e50"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#5e8645"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#5d8441"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#5c833d"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#597f3d"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#557c37"
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#4c742a"
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#567c3e"
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#517836"
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#497127"
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#456f21"
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#456f1f"
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#466e23"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#416a18"
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#456c1f"
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#416819"
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#42691a"
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#456c1c"
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#4a7125"
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#456d22"
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#3f691a"
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#3f6919"
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#436c20"
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#487027"
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#416b1a"
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#416b17"
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#416a1b"
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#426c1d"
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#466f23"
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#487127"
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1z",
    fill: "#456e1e"
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95v1h-1v-1z",
    fill: "#436d1c"
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#456f1e"
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#426b1d"
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#426c1b"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95h1v1h-1z",
    fill: "#436e1a"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "M75 95h1v1h-1z",
    fill: "#45701a"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95h1v1h-1z",
    fill: "#476e20"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#476e1f"
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#476f1c"
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#486f1d"
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v1h-1v-1z",
    fill: "#49701b"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "M84 96h-1v-1h1z",
    fill: "#49711c"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#49701c"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96v-1h1v1z",
    fill: "#466d18"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#5c8246"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95h1v1h-1z",
    fill: "#7a9f74"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "M89 96h-1v-1h1z",
    fill: "#3b5323"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95h1v1h-1z",
    fill: "#0d110c"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "M124 95v1h-1v-1z",
    fill: "#252523",
    fillOpacity: 0.396
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "M3 96h1v1H3z",
    fill: "#252925",
    fillOpacity: 0.239
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "M5 97H4v-1h1z",
    fill: "#181e18",
    fillOpacity: 0.851
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "M5 96h1v1H5z",
    fill: "#151e16"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "M7 97H6v-1h1z",
    fill: "#131f14"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "M7 97v-1h1v1z",
    fill: "#132014"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "M8 96h1v1H8z",
    fill: "#19261b"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "M10 97H9v-1h1z",
    fill: "#202c23"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "M10 96h1v1h-1z",
    fill: "#2c372f"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "M11 96h1v1h-1z",
    fill: "#606761"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "M13 97h-1v-1h1z",
    fill: "#3a3f3b"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "M13 96h1v1h-1z",
    fill: "#484e4a"
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "M15 97h-1v-1h1z",
    fill: "#4e5451"
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "M16 96v1h-1v-1z",
    fill: "#545c58"
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "M16 96h1v1h-1z",
    fill: "#646d66"
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "M17 97v-1h1v1z",
    fill: "#39413d"
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h1v1h-1z",
    fill: "#010505"
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "M19 96h1v1h-1z",
    fill: "#61645c"
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97v-1h1v1z",
    fill: "#7f8476"
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "M21 96h1v1h-1z",
    fill: "#636a60"
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "M23 96v1h-1v-1z",
    fill: "#485049"
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#5e685e"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#697369"
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96v1h-1v-1z",
    fill: "#515951"
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v-1h1v1z",
    fill: "#373e37"
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-1z",
    fill: "#2f3530"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96h1v1h-1z",
    fill: "#2c312d"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1z",
    fill: "#242925"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96v1h-1v-1z",
    fill: "#111614"
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#040908"
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#263420"
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96v1h-1v-1z",
    fill: "#567c35"
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#4a7329"
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#87ae91"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#9dc4b1"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#709566"
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#497122"
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#4d7425"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#4c7525"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#4a7121"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#4a711f"
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#4b7223"
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#4a701f"
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#4b7129"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#6d905d"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#638557"
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#698b5a"
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#5c8046"
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#567b3c"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#688b56"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#5b8043"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#618450"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#60834c"
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#63864d"
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#507434"
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#6b8f57"
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#628655"
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#60854d"
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#5b8140"
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#507737"
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#678c55"
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#5b8046"
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#5a7f48"
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#658953"
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#51773a"
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#698d59"
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#709367"
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#668958"
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#62874e"
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#6d925a"
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#638752"
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#688d55"
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v-1h1v1z",
    fill: "#5c8242"
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1z",
    fill: "#567c32"
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#5d8338"
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#5e8439"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#618641"
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#658a45"
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#668b46"
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#6a8f4b"
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "M83 97h-1v-1h1z",
    fill: "#6f9351"
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "M83 96h1v1h-1z",
    fill: "#739756"
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1z",
    fill: "#769b5c"
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96v1h-1v-1z",
    fill: "#749857"
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96v1h-1v-1z",
    fill: "#796"
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "M87 97v-1h1v1z",
    fill: "#8bae89"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96h1v1h-1z",
    fill: "#627a4f"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h1v1h-1z",
    fill: "#3d3f3f"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97h-1v-1h1z",
    fill: "#4f5150"
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h-1v-1h1z",
    fill: "#565857"
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97v-1h1v1z",
    fill: "#5a5c5b"
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "M99 97v-1h1v1z",
    fill: "#474948"
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97h-1v-1h1z",
    fill: "#585a59"
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "M109 96v1h-1v-1z",
    fill: "#414342"
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "M118 96v1h-1v-1z",
    fill: "#454746"
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "M123 97v-1h1v1z",
    fill: "#333331",
    fillOpacity: 0.545
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "M5 97v1H4v-1z",
    fill: "#181b14",
    fillOpacity: 0.29
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "M5 97h1v1H5z",
    fill: "#121c12",
    fillOpacity: 0.639
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "M6 98v-1h1v1z",
    fill: "#101a11",
    fillOpacity: 0.902
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "M8 98H7v-1h1z",
    fill: "#0f1911"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "M9 97v1H8v-1z",
    fill: "#111b12"
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "M9 98v-1h1v1z",
    fill: "#101c12"
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "M11 98h-1v-1h1z",
    fill: "#0b130d"
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "M12 97v1h-1v-1z",
    fill: "#010503"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "M22 97h1v1h-1z",
    fill: "#06080a"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97v1h-1v-1z",
    fill: "#0c0e10"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#0b0c0d"
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v1h-1v-1z",
    fill: "#070a07"
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h-1v-1h1z",
    fill: "#040405"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#1c2811"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#476c1d"
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#446b20"
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#80a388"
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#90b4a0"
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#5f8452"
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#3c6210"
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#3e6410"
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#3d6511"
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#406615"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#446a1e"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#446a1b"
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#426817"
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#446921"
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#456a24"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97h1v1h-1z",
    fill: "#4b6f2e"
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#486d26"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#476d24"
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#4c712a"
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#476c24"
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#4b6f2f"
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#507437"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#4f7333"
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#456b23"
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#486e24"
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#4c7030"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#52763a"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#4c7131"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#496d2b"
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#54773a"
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#537637"
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#577a3e"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#5a7d41"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#466b28"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#53763a"
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#567842"
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#5c7e47"
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#557740"
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#567840"
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#5a7c45"
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#577b3f"
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1z",
    fill: "#446923"
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98v-1h1v1z",
    fill: "#416817"
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#426918"
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1z",
    fill: "#436a18"
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98h-1v-1h1z",
    fill: "#426917"
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#406814"
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98v-1h1v1z",
    fill: "#456b1a"
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97h1v1h-1z",
    fill: "#486f20"
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97v1h-1v-1z",
    fill: "#456b1d"
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97h1v1h-1z",
    fill: "#557a3f"
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "M88 97v1h-1v-1z",
    fill: "#7ba076"
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v1h-1v-1z",
    fill: "#445b2d"
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98h-1v-1h1z",
    fill: "#0c1110"
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v-1h1v1z",
    fill: "#111314"
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h-1v-1h1z",
    fill: "#191a1b"
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "M93 97h1v1h-1z",
    fill: "#1e2021"
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h1v1h-1z",
    fill: "#2b2d2d"
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "M99 98h-1v-1h1z",
    fill: "#1f2120"
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "M123 97v1h-1v-1z",
    fill: "#363836"
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "M123 97h1v1h-1z",
    fill: "#2e2e2c",
    fillOpacity: 0.608
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "M6 98h1v1H6z",
    fill: "#222",
    fillOpacity: 0.086
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "M8 98v1H7v-1z",
    fill: "#121912",
    fillOpacity: 0.271
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "M9 99H8v-1h1z",
    fill: "#080f08",
    fillOpacity: 0.459
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "M10 98v1H9v-1z",
    fill: "#060b05",
    fillOpacity: 0.588
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "M10 99v-1h1v1z",
    fill: "#090c08",
    fillOpacity: 0.714
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "M20 98v1h-1v-1z",
    fill: "#000103"
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v1h-1z",
    fill: "#18230c"
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#416011"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#40601a"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#78987c"
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#84a697"
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#577747"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#3a5c08"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#486b2b"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#618758"
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#739872"
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#5d7e53"
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#7a9c79"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#587a42"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#395e12"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#456923"
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#42661e"
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#3c6115"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#3d6113"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#3d6013"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#3d6114"
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#3e6216"
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#3d6010"
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#3c5e11"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#3e5f14"
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#3c5f0d"
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#3a5e0a"
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#3c5f0f"
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#3a5d0f"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#3b5f0f"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#3d5f10"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#3d5e0e"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#3b5e08"
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#3b5e0a"
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#3a5d0d"
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#3b600d"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98h1v1h-1z",
    fill: "#3b5e0e"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#3a5f0c"
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#3a5f0b"
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#3a5e0d"
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#3b600e"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#3e6312"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#406414"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#3c6311"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#3e6411"
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#3f6514"
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#3e6413"
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#3b630b"
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1z",
    fill: "#476e27"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#688e59"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98h1v1h-1z",
    fill: "#43671b"
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "M82 98h1v1h-1z",
    fill: "#3b600b"
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98h1v1h-1z",
    fill: "#3c600f"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "M85 98v1h-1v-1z",
    fill: "#3e6111"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h-1v-1h1z",
    fill: "#3d600c"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "M86 98h1v1h-1z",
    fill: "#507335"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "M88 98v1h-1v-1z",
    fill: "#72976a"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#344c1a"
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#040804"
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h-1v-1h1z",
    fill: "#070708"
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "M123 99v-1h1v1z",
    fill: "#1c1c19",
    fillOpacity: 0.627
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "M12 100h-1v-1h1z",
    fill: "#0b0b0b",
    fillOpacity: 0.361
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "M12 99h1v1h-1z",
    fill: "#070907",
    fillOpacity: 0.502
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100h-1v-1h1z",
    fill: "#060805",
    fillOpacity: 0.573
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100v-1h1v1z",
    fill: "#060805",
    fillOpacity: 0.6
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "M15 99h1v1h-1z",
    fill: "#060804",
    fillOpacity: 0.62
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "M17 99v1h-1v-1z",
    fill: "#030403",
    fillOpacity: 0.612
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "M17 100v-1h1v1z",
    fill: "#141414",
    fillOpacity: 0.624
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "M19 99v1h-1v-1z",
    fill: "#0c0d0c",
    fillOpacity: 0.973
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#131d08"
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99v1h-1v-1z",
    fill: "#39580a"
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#385813"
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#6b8a6f"
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#779888"
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#4b6e39"
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#406124"
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#739175"
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#7d9e8c"
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#7d9e8f"
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#65856d"
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#789988"
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#587b50"
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#375913"
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#49692f"
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#4d6b38"
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1z",
    fill: "#4e6c37"
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1z",
    fill: "#4a6a33"
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100v-1h1v1z",
    fill: "#4c6d36"
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#4d6e37"
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#4b6c34"
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#496b30"
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#4c6c34"
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#507038"
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#3d5f20"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1z",
    fill: "#4b6c35"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#4c6d37"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#4f7037"
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#4f703b"
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#4e6f3a"
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#47682c"
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#416323"
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#4d6f34"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#47682e"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v1z",
    fill: "#507034"
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#3c5d19"
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#4b6c2b"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#4d6c34"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#51733b"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#476a2c"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#456824"
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#44681e"
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#345808"
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h1v1h-1z",
    fill: "#53783c"
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1z",
    fill: "#85a793"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100h-1v-1h1z",
    fill: "#708f71"
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100v-1h1v1z",
    fill: "#678962"
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-1v-1z",
    fill: "#67895e"
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99h1v1h-1z",
    fill: "#537642"
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "M85 99h1v1h-1z",
    fill: "#507232"
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h1v1h-1z",
    fill: "#4b6b30"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1z",
    fill: "#688a5d"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "M89 99v1h-1v-1z",
    fill: "#2e4515"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "M122 99h1v1h-1z",
    fill: "#0a0c0a"
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "M124 100h-1v-1h1z",
    fill: "#0c0c0b",
    fillOpacity: 0.624
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v1h-1v-1z",
    fill: "#181815",
    fillOpacity: 0.322
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100v1h-1v-1z",
    fill: "#060704",
    fillOpacity: 0.804
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100h1v1h-1z",
    fill: "#010301",
    fillOpacity: 0.965
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "M21 101v-1h1v1z",
    fill: "#040604",
    fillOpacity: 0.996
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#0f1605"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#324e08"
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-1v-1z",
    fill: "#2d4e0c"
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#5c795d"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#6a8476"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#46613b"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#2b4905"
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#344f1a"
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#46603c"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#536d4e"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#445d3a"
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#587457"
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#415e31"
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#2c4907"
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#335112"
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#314d11"
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#304d0f"
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#324d12"
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#344f14"
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#324d10"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#334e10"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#355116"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#345017"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#334f15"
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "M56 101v-1h1v1z",
    fill: "#314e0f"
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#3f5b25"
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#36521b"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#355315"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#37541b"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#36521a"
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#335011"
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#355213"
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#3d581f"
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#3d5923"
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#3b5722"
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#3c5725"
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#405b28"
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#3c5723"
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#3d5a20"
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#32510b"
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1z",
    fill: "#365410"
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "M73 101v-1h1v1z",
    fill: "#365316"
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#3a5919"
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#32510e"
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100v1h-1v-1z",
    fill: "#31500a"
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#315108"
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101h-1v-1h1z",
    fill: "#305006"
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "M79 100h1v1h-1z",
    fill: "#496635"
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v1z",
    fill: "#6f8e7a"
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h1v1h-1z",
    fill: "#577457"
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100v1h-1v-1z",
    fill: "#52704c"
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101h-1v-1h1z",
    fill: "#54704b"
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101h-1v-1h1z",
    fill: "#476439"
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v1z",
    fill: "#43602b"
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#44622c"
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100v1h-1v-1z",
    fill: "#5b7a4e"
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100h1v1h-1z",
    fill: "#273a0f"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "M123 101v-1h1v1z",
    fill: "#0a0806",
    fillOpacity: 0.584
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "M20 102h-1v-1h1z",
    fill: "#38381c",
    fillOpacity: 0.035
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h-1v-1h1z",
    fill: "#060606",
    fillOpacity: 0.149
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101v1h-1v-1z",
    fill: "#0d0d0d",
    fillOpacity: 0.224
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101h1v1h-1z",
    fill: "#0b0b0b",
    fillOpacity: 0.267
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "M24 101v1h-1v-1z",
    fill: "#060606",
    fillOpacity: 0.733
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "M28 101h1v1h-1z",
    fill: "#030504",
    fillOpacity: 0.988
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "M30 101v1h-1v-1z",
    fill: "#030504",
    fillOpacity: 0.984
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#080e05"
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-1z",
    fill: "#274112"
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#244916"
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101v1h-1v-1z",
    fill: "#456a50"
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#567765"
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#3d613e"
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#224915"
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#2b531e"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#284f1e"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#264e1e"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#2b501e"
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#294f22"
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102h-1v-1h1z",
    fill: "#2c501e"
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102h-1v-1h1z",
    fill: "#2a4e1b"
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#284e1b"
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#2a501b"
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#264c14"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#234812"
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#284c17"
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#284c19"
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#2a4e1a"
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#294d15"
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#23470f"
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1z",
    fill: "#294d18"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#274c16"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#284c15"
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#264a12"
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1z",
    fill: "#264a15"
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#284b14"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1z",
    fill: "#274c12"
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#274b14"
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v1h-1z",
    fill: "#264a11"
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#294c14"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h1z",
    fill: "#274a15"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101v1h-1v-1z",
    fill: "#284c14"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1z",
    fill: "#284c12"
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#284c11"
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#274b10"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#264b0e"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1z",
    fill: "#25490c"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102v-1h1v1z",
    fill: "#254a0c"
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101v1h-1v-1z",
    fill: "#26490b"
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "M80 102h-1v-1h1z",
    fill: "#294918"
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101h1v1h-1z",
    fill: "#30542b"
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#315323"
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-1h1v1z",
    fill: "#31531d"
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101v1h-1v-1z",
    fill: "#30511d"
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v-1h1v1z",
    fill: "#33541f"
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "M86 101v1h-1v-1z",
    fill: "#2c4d14"
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h-1v-1h1z",
    fill: "#39592e"
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "M88 102h-1v-1h1z",
    fill: "#486642"
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101v1h-1v-1z",
    fill: "#1c2e0c"
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "M124 102h-1v-1h1z",
    fill: "#0b0b08",
    fillOpacity: 0.447
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "M24 102v1h-1v-1z",
    fill: "#0e0e07",
    fillOpacity: 0.137
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "M24 103v-1h1v1z",
    fill: "#080806",
    fillOpacity: 0.447
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#060806",
    fillOpacity: 0.475
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h-1v-1h1z",
    fill: "#080a08",
    fillOpacity: 0.478
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "M28 103h-1v-1h1z",
    fill: "#0b0e0b",
    fillOpacity: 0.424
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "M29 103h-1v-1h1z",
    fill: "#0e0e0e",
    fillOpacity: 0.341
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1z",
    fill: "#0e110e",
    fillOpacity: 0.349
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "M31 103h-1v-1h1z",
    fill: "#060808",
    fillOpacity: 0.498
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1z",
    fill: "#010301",
    fillOpacity: 0.627
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#020502",
    fillOpacity: 0.906
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#142714"
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v1h-1z",
    fill: "#1b4325"
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103v-1h1v1z",
    fill: "#29513f"
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#395f50"
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#305a44"
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#1a492e"
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#204f33"
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#1f5037"
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#1e5136"
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#205138"
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#224f35"
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#215035"
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#225137"
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#1c4d2f"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#225335"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#225336"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#235237"
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#205234"
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#235436"
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#245535"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#1f502f"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#225433"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#245537"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#235635"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#235636"
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#26583a"
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#235335"
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#265638"
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#255838"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#255839"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#27583b"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#265739"
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#275737"
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1z",
    fill: "#285837"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v-1h1v1z",
    fill: "#29593a"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h1v1h-1z",
    fill: "#2a5a3a"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#245633"
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#20522c"
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#21522b"
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#20532a"
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "M79 102h1v1h-1z",
    fill: "#225327"
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v-1h1v1z",
    fill: "#21512b"
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#255430"
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1z",
    fill: "#235532"
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v1h-1v-1z",
    fill: "#255532"
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103h-1v-1h1z",
    fill: "#255631"
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v-1h1v1z",
    fill: "#23522a"
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "M87 103h-1v-1h1z",
    fill: "#376042"
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h1v1h-1z",
    fill: "#375a41"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "M88 103v-1h1v1z",
    fill: "#0f210d"
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "M124 102v1h-1v-1z",
    fill: "#151511",
    fillOpacity: 0.231
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "M25 103v1h-1v-1z",
    fill: "#090909",
    fillOpacity: 0.42
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.698
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "M26 104v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.737
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h1v1h-1z",
    fill: "#010101",
    fillOpacity: 0.753
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104h-1v-1h1z",
    fill: "#010101",
    fillOpacity: 0.788
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104h-1v-1h1z",
    fill: "#010101",
    fillOpacity: 0.827
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103h1v1h-1z",
    fill: "#010101",
    fillOpacity: 0.812
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#010101",
    fillOpacity: 0.792
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1z",
    fill: "#020000",
    fillOpacity: 0.941
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h-1v-1h1z",
    fill: "#081a15"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "M35 104h-1v-1h1z",
    fill: "#155e4c"
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h1v1h-1z",
    fill: "#165d4e"
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#33675a"
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#316a5b"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#11604d"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#0b5f48"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#0a5e4a"
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#0a5c48"
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1z",
    fill: "#0a5946"
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1z",
    fill: "#095744"
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#0a5643"
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v1h-1v-1z",
    fill: "#095643"
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#085542"
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#085540"
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#08533f"
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#08523e"
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#09523e"
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#08503c"
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#084f3c"
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#0a503c"
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#0a4f3d"
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#094f3b"
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#094d39"
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#084b37"
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1z",
    fill: "#094a37"
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#0b4937"
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#0a4836"
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#0a4735"
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#0c4534"
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#0b4433"
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#0a4432"
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#08432f"
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#08422e"
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104v-1h1v1z",
    fill: "#08402c"
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104h-1v-1h1z",
    fill: "#063f2b"
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#073f2b"
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1z",
    fill: "#083f2c"
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#083e2b"
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#093d29"
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h1z",
    fill: "#093c27"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "M85 104h-1v-1h1z",
    fill: "#093b27"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#0d3b27"
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104h-1v-1h1z",
    fill: "#1a4736"
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104v-1h1v1z",
    fill: "#0f392c"
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "M89 103v1h-1v-1z",
    fill: "#0a100b"
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v-1h1v1z",
    fill: "#0c0709"
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104h-1v-1h1z",
    fill: "#0c0a0a"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v1h-1v-1z",
    fill: "#141414",
    fillOpacity: 0.988
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "M97 104v-1h1v1z",
    fill: "#121212",
    fillOpacity: 0.941
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h-1v-1h1z",
    fill: "#101210",
    fillOpacity: 0.776
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h1v1h-1z",
    fill: "#0e0f0f",
    fillOpacity: 0.565
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "M101 104h-1v-1h1z",
    fill: "#0e0f0e",
    fillOpacity: 0.627
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "M102 104h-1v-1h1z",
    fill: "#090b0a",
    fillOpacity: 0.925
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "M121 104v-1h1v1z",
    fill: "#060705",
    fillOpacity: 0.949
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "M123 103v1h-1v-1z",
    fill: "#151311",
    fillOpacity: 0.565
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.098
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "M21 105h-1v-1h1z",
    fill: "#171a17",
    fillOpacity: 0.38
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104v1h-1v-1z",
    fill: "#0f0f0d",
    fillOpacity: 0.529
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104v1h-1v-1z",
    fill: "#0a0a0a",
    fillOpacity: 0.565
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104h1v1h-1z",
    fill: "#0a0a0a",
    fillOpacity: 0.647
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "M25 105h-1v-1h1z",
    fill: "#030303",
    fillOpacity: 0.988
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104v1h-1v-1z",
    fill: "#2e6e65"
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#4cdbca"
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#62d9c7"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#95e1d0"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#7de0cc"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "M38 104h1v1h-1z",
    fill: "#46d6bf"
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#41dac1"
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#42dac4"
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#3fd9c1"
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#3fd8c0"
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#40d8c0"
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#3fd6bf"
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#3cd4bc"
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#3dd6be"
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#3cd5bd"
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#3ad3bb"
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1z",
    fill: "#3ad2b9"
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#3ad1b9"
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#38d0b7"
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#38cfb6"
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#37cdb4"
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#37cbb2"
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#38cdb3"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#38cbb2"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#34c9b0"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#33c8b0"
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#34c7af"
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#34c6af"
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#32c6ad"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1z",
    fill: "#33c5ad"
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1z",
    fill: "#33c4ac"
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#30c3aa"
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#32c2aa"
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#35c0a9"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#32bfa8"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h-1v-1h1z",
    fill: "#30bda5"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "M71 104h1v1h-1z",
    fill: "#2dbba2"
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "M73 104v1h-1v-1z",
    fill: "#2cb9a1"
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104v1h-1v-1z",
    fill: "#2bb9a0"
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#27b79e"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#26b69d"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "M76 105v-1h1v1z",
    fill: "#27b59c"
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v1h-1z",
    fill: "#28b39b"
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104v1h-1v-1z",
    fill: "#24b198"
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105h-1v-1h1z",
    fill: "#23ae96"
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#24ad94"
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#24ab94"
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#24ab93"
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#25a892"
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105h-1v-1h1z",
    fill: "#24a48d"
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#28a08a"
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105v-1h1v1z",
    fill: "#51af9c"
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105h-1v-1h1z",
    fill: "#329684"
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v1h-1v-1z",
    fill: "#0d2421"
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105h-1v-1h1z",
    fill: "#030303",
    fillOpacity: 0.996
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "M98 104v1h-1v-1z",
    fill: "#030303",
    fillOpacity: 0.984
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "M98 105v-1h1v1z",
    fill: "#010202",
    fillOpacity: 0.941
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h1v1h-1z",
    fill: "#010302",
    fillOpacity: 0.906
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105v-1h1v1z",
    fill: "#010403",
    fillOpacity: 0.945
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "M102 105h-1v-1h1z",
    fill: "#010201",
    fillOpacity: 0.992
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "M122 105h-1v-1h1z",
    fill: "#050504",
    fillOpacity: 0.867
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "M12 105h1v1h-1z",
    fill: "#373c3c",
    fillOpacity: 0.2
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "M13 106v-1h1v1z",
    fill: "#2b3030",
    fillOpacity: 0.227
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "M15 105v1h-1v-1z",
    fill: "#2f2f2f",
    fillOpacity: 0.212
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "M16 105v1h-1v-1z",
    fill: "#252529",
    fillOpacity: 0.216
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "M17 105v1h-1v-1z",
    fill: "#232323",
    fillOpacity: 0.227
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "M18 105v1h-1v-1z",
    fill: "#222622",
    fillOpacity: 0.231
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106h-1v-1h1z",
    fill: "#323532",
    fillOpacity: 0.357
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105h1v1h-1z",
    fill: "#111212",
    fillOpacity: 0.871
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1z",
    fill: "#4eab9f"
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#5ef4e6"
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#8aefe2"
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#b2f1e7"
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#87efdf"
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#5aefde"
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#5cf3e1"
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#5cf3df"
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#5df2df"
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#5af3df"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#59f1dd"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#5af0de"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#59f2de"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#57f0dd"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#55efdb"
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#51f0db"
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1z",
    fill: "#51efdb"
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v-1h1v1z",
    fill: "#51efda"
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#52efda"
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#56efdb"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#56eeda"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105h1v1h-1z",
    fill: "#53eedb"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#54edd9"
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105v1h-1v-1z",
    fill: "#54ecd8"
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1z",
    fill: "#54e8d4"
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105h1v1h-1z",
    fill: "#87efe1"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105v1h-1v-1z",
    fill: "#69e5d4"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106v-1h1v1z",
    fill: "#235651"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105h1v1h-1z",
    fill: "#010001"
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "M121 106v-1h1v1z",
    fill: "#060705"
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "M123 105v1h-1v-1z",
    fill: "#131311",
    fillOpacity: 0.353
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106v1H8v-1z",
    fill: "#3f7f6a",
    fillOpacity: 0.047
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106h1v1H9z",
    fill: "#286256",
    fillOpacity: 0.173
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "M11 107h-1v-1h1z",
    fill: "#23665a",
    fillOpacity: 0.255
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "M12 106v1h-1v-1z",
    fill: "#141d18",
    fillOpacity: 0.643
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "M12 107v-1h1v1z",
    fill: "#111",
    fillOpacity: 0.984
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "M14 106v1h-1v-1z",
    fill: "#0a0c0c",
    fillOpacity: 0.992
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "M14 107v-1h1v1z",
    fill: "#0a0c0d",
    fillOpacity: 0.988
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "M15 106h1v1h-1z",
    fill: "#09090b",
    fillOpacity: 0.988
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "M17 106v1h-1v-1z",
    fill: "#080908",
    fillOpacity: 0.996
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "M17 106h1v1h-1z",
    fill: "#0d0e0d",
    fillOpacity: 0.996
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106v1h-1v-1z",
    fill: "#1e1f1f"
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "M24 107v-1h1v1z",
    fill: "#0e1212"
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v-1h1v1z",
    fill: "#171a1d"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "M26 107v-1h1v1z",
    fill: "#1c1e21"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "M29 106v1h-1v-1z",
    fill: "#1c1d1f"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "M29 107v-1h1v1z",
    fill: "#161a1c"
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "M30 106h1v1h-1z",
    fill: "#0b1011"
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "M32 107h-1v-1h1z",
    fill: "#06090b"
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "M33 107h-1v-1h1z",
    fill: "#081514"
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106v1h-1v-1z",
    fill: "#63cbbd"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#6af5e4"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fill: "#9cf3e7"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106v1h-1v-1z",
    fill: "#b8f4ec"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#8cefe2"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#63f1e2"
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#75f1df"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#70f1de"
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#78f2e2"
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v1h-1v-1z",
    fill: "#77f1e0"
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107h-1v-1h1z",
    fill: "#6cf2e2"
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106v1h-1v-1z",
    fill: "#6ef1e3"
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#78f3e6"
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#6af1e2"
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h1v1h-1z",
    fill: "#6bf2e2"
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#6af2e2"
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#67f3e2"
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#68f2e1"
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#64f2e0"
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#66f2e1"
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#6af1e1"
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#6ef3e5"
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#68f1e2"
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#65f3e2"
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1z",
    fill: "#67f2e3"
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#68f2e2"
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#67f1e2"
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#63f2e2"
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "M77 107v-1h1v1z",
    fill: "#63f3e2"
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#64f3e2"
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106h1v1h-1z",
    fill: "#65f3e1"
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106v1h-1v-1z",
    fill: "#65f2e0"
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106h1v1h-1z",
    fill: "#62efdc"
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "M87 106v1h-1v-1z",
    fill: "#90f3e5"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#30766e"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "M101 107v-1h1v1z",
    fill: "#060808"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "M121 107v-1h1v1z",
    fill: "#0c0e0c"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "M122 107v-1h1v1z",
    fill: "#121210",
    fillOpacity: 0.667
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "M6 107v1H5v-1z",
    fill: "#397f72",
    fillOpacity: 0.157
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "M6 107h1v1H6z",
    fill: "#197160",
    fillOpacity: 0.424
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "M7 108v-1h1v1z",
    fill: "#116e5b",
    fillOpacity: 0.686
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "M9 108H8v-1h1z",
    fill: "#096d5b",
    fillOpacity: 0.855
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "M9 107h1v1H9z",
    fill: "#077060",
    fillOpacity: 0.969
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "M11 108h-1v-1h1z",
    fill: "#0c6256"
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "M12 108h-1v-1h1z",
    fill: "#142220"
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "M12 107h1v1h-1z",
    fill: "#1b1e1b"
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "M13 108v-1h1v1z",
    fill: "#202624"
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "M14 107h1v1h-1z",
    fill: "#1c211f"
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "M15 108v-1h1v1z",
    fill: "#1e2321"
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "M17 107v1h-1v-1z",
    fill: "#141a18"
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "M19 108h-1v-1h1z",
    fill: "#111213"
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h-1v-1h1z",
    fill: "#2c3331"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "M22 108h-1v-1h1z",
    fill: "#4e5557"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "M23 107v1h-1v-1z",
    fill: "#636569"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "M23 108v-1h1v1z",
    fill: "#555c5d"
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v1h-1v-1z",
    fill: "#626e6c"
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107h1v1h-1z",
    fill: "#737e7a"
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "M27 108h-1v-1h1z",
    fill: "#8f9896"
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "M28 107v1h-1v-1z",
    fill: "#919898"
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "M29 108h-1v-1h1z",
    fill: "#788080"
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "M30 107v1h-1v-1z",
    fill: "#657172"
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107v1h-1v-1z",
    fill: "#414d4e"
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107h1v1h-1z",
    fill: "#1b2628"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1z",
    fill: "#1f3537"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "M34 108h-1v-1h1z",
    fill: "#81e3da"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#78f4e5"
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v-1h1v1z",
    fill: "#acf8ef"
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108h-1v-1h1z",
    fill: "#c3faf5"
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "M38 107v1h-1v-1z",
    fill: "#93f4e8"
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#70f4e6"
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#87f6e9"
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#a5f6ed"
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#99f4e9"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#98f3e7"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#aff7ee"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#88f5e8"
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#8af6e9"
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1z",
    fill: "#77f1e3"
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "M49 107v1h-1v-1z",
    fill: "#84f4e6"
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1z",
    fill: "#7af1e2"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1z",
    fill: "#85f4e9"
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108v-1h1v1z",
    fill: "#7df1e4"
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108h-1v-1h1z",
    fill: "#7ef3e6"
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#7cf3e5"
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#83f3e7"
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#71f2e0"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#7ff4e7"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#70f2e3"
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "M59 108h-1v-1h1z",
    fill: "#6ef2e3"
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#7af4e7"
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#77f3e4"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#7df6e7"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h-1v-1h1z",
    fill: "#7bf4e6"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107h1v1h-1z",
    fill: "#7cf3e7"
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#74f3e4"
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#7bf6e9"
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "M72 108v-1h1v1z",
    fill: "#6ef5e6"
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#6df5e5"
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v1h-1z",
    fill: "#6bf5e4"
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107h1v1h-1z",
    fill: "#6cf5e4"
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108h-1v-1h1z",
    fill: "#6bf5e3"
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#6bf5e5"
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#6df4e6"
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#6af2e4"
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "M83 107v1h-1v-1z",
    fill: "#69f4e3"
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#6cf4e3"
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "M84 107h1v1h-1z",
    fill: "#6bf3e1"
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v-1h1v1z",
    fill: "#69f0de"
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#94f5e6"
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "M88 107v1h-1v-1z",
    fill: "#8af9ea"
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h-1v-1h1z",
    fill: "#418982"
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "M101 108v-1h1v1z",
    fill: "#0d0f10"
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "M102 108v-1h1v1z",
    fill: "#161818"
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "M113 108v-1h1v1z",
    fill: "#1b1d1c"
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "M122 107h1v1h-1z",
    fill: "#171817",
    fillOpacity: 0.867
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "M124 107v1h-1v-1z",
    fill: "#3f2a2a",
    fillOpacity: 0.047
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "M3 109v-1h1v1z",
    fill: "#58756b",
    fillOpacity: 0.102
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "M5 108v1H4v-1z",
    fill: "#1e6253",
    fillOpacity: 0.682
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "M5 109v-1h1v1z",
    fill: "#0a6351",
    fillOpacity: 0.984
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "M6 108h1v1H6z",
    fill: "#026956"
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "M7 108h1v1H7z",
    fill: "#02695a"
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "M8 108h1v1H8z",
    fill: "#026d5d"
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "M10 108v1H9v-1z",
    fill: "#027c69"
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "M10 109v-1h1v1z",
    fill: "#13695b"
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "M12 109h-1v-1h1z",
    fill: "#616665"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "M12 108h1v1h-1z",
    fill: "#49514c"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "M13 108h1v1h-1z",
    fill: "#5e6663"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "M15 108v1h-1v-1z",
    fill: "#656c6a"
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "M16 108v1h-1v-1z",
    fill: "#636b68"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "M16 109v-1h1v1z",
    fill: "#606966"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "M17 109v-1h1v1z",
    fill: "#434a48"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "M20 109h-1v-1h1z",
    fill: "#62645e"
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "M20 108h1v1h-1z",
    fill: "#8c938b"
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h1v1h-1z",
    fill: "#616963"
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "M22 108h1v1h-1z",
    fill: "#555a55"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "M24 108v1h-1v-1z",
    fill: "#646b65"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "M25 108v1h-1v-1z",
    fill: "#69736b"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "M25 109v-1h1v1z",
    fill: "#57635a"
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "M27 109h-1v-1h1z",
    fill: "#46504a"
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "M27 109v-1h1v1z",
    fill: "#3e4644"
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "M28 108h1v1h-1z",
    fill: "#303937"
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "M30 109h-1v-1h1z",
    fill: "#28312e"
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "M31 108v1h-1v-1z",
    fill: "#1c2625"
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "M31 109v-1h1v1z",
    fill: "#111a1c"
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "M32 108h1v1h-1z",
    fill: "#233d3e"
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h1v1h-1z",
    fill: "#86ece2"
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v1h-1v-1z",
    fill: "#7bf2e4"
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108h1v1h-1z",
    fill: "#abf4eb"
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#b6f5ec"
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#86eee0"
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#70f0e1"
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#8cf6e7"
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#98f3e5"
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#7cf0e1"
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#7bf2e1"
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#9ff4e9"
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#8df4e7"
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#85f3e4"
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#7ff1e2"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#89f4e4"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#82f3e2"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#8ef3e7"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#87f1e4"
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h-1v-1z",
    fill: "#88f1e4"
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#82f2e4"
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#93f2ea"
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#76f2e0"
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#7df5e4"
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108h1v1h-1z",
    fill: "#74f2e2"
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "M58 109v-1h1v1z",
    fill: "#74f3e3"
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v-1h1v1z",
    fill: "#84f4e7"
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109v-1h1v1z",
    fill: "#83f3e2"
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h-1v-1h1z",
    fill: "#84f0e2"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "M63 109v-1h1v1z",
    fill: "#84f2e5"
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h1v1h-1z",
    fill: "#7df2e2"
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h-1v-1h1z",
    fill: "#87f5e8"
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#74f5e3"
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#79f8e9"
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#7ef8e9"
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#80f8ea"
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108v1h-1v-1z",
    fill: "#82f7ea"
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1z",
    fill: "#85f8ec"
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#8af9ee"
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#8bf9ef"
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#8ef9f0"
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#91f9f1"
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "M82 109v-1h1v1z",
    fill: "#94f9f1"
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108h1v1h-1z",
    fill: "#98faf2"
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v1h-1v-1z",
    fill: "#99faf1"
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108h1v1h-1z",
    fill: "#92f6ec"
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#a4f7ed"
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v-1h1v1z",
    fill: "#99fbee"
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109h-1v-1h1z",
    fill: "#64a9a2"
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h1v1h-1z",
    fill: "#2e2e2f"
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h1v1h-1z",
    fill: "#323334"
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109h-1v-1h1z",
    fill: "#343636"
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109v-1h1v1z",
    fill: "#323434"
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "M94 108v1h-1v-1z",
    fill: "#2d2f2f"
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "M95 109v-1h1v1z",
    fill: "#2a2c2c"
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "M97 108h1v1h-1z",
    fill: "#242626"
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "M99 108v1h-1v-1z",
    fill: "#242624"
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "M102 108v1h-1v-1z",
    fill: "#292a2b"
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "M106 108h1v1h-1z",
    fill: "#2c2e2d"
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "M123 108v1h-1v-1z",
    fill: "#303130",
    fillOpacity: 0.953
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "M123 109v-1h1v1z",
    fill: "#3e3737",
    fillOpacity: 0.145
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "M4 109v1H3v-1z",
    fill: "#6d916d",
    fillOpacity: 0.027
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "M4 109h1v1H4z",
    fill: "#1d5849",
    fillOpacity: 0.271
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "M5 109h1v1H5z",
    fill: "#0c5342",
    fillOpacity: 0.631
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "M6 110v-1h1v1z",
    fill: "#075242",
    fillOpacity: 0.914
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "M8 110H7v-1h1z",
    fill: "#035546"
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "M9 110H8v-1h1z",
    fill: "#025c4b"
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "M9 110v-1h1v1z",
    fill: "#036451"
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "M10 110v-1h1v1z",
    fill: "#064437"
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "M12 109v1h-1v-1z",
    fill: "#0e0c0c"
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "M17 109v1h-1v-1z",
    fill: "#0c110f"
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "M17 110v-1h1v1z",
    fill: "#0a0e0c"
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "M26 109v1h-1v-1z",
    fill: "#191c19"
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109v1h-1v-1z",
    fill: "#0d1110"
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109h1v1h-1z",
    fill: "#0e1110"
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "M30 109h1v1h-1z",
    fill: "#0b0e0e"
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "M32 109v1h-1v-1z",
    fill: "#030607"
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "M33 109v1h-1v-1z",
    fill: "#1c3c39"
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v-1h1v1z",
    fill: "#70ebdc"
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110v-1h1v1z",
    fill: "#71f1df"
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "M36 110h-1v-1h1z",
    fill: "#a6f2e7"
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "M36 109h1v1h-1z",
    fill: "#adf3e8"
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109h1v1h-1z",
    fill: "#79eedc"
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h-1v-1h1z",
    fill: "#67f1e0"
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#6ef0dd"
  })), _path6374 || (_path6374 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#6ff1dd"
  })), _path6375 || (_path6375 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#6df2e2"
  })), _path6376 || (_path6376 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#6df0e3"
  })), _path6377 || (_path6377 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#6ff1df"
  })), _path6378 || (_path6378 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#6ef2e1"
  })), _path6379 || (_path6379 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#74f0e4"
  })), _path6380 || (_path6380 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#73f0e0"
  })), _path6381 || (_path6381 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#70f1e2"
  })), _path6382 || (_path6382 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#70f0df"
  })), _path6383 || (_path6383 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#73f2e2"
  })), _path6384 || (_path6384 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110v-1h1v1z",
    fill: "#75f0e2"
  })), _path6385 || (_path6385 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110h-1v-1h1z",
    fill: "#70f2e1"
  })), _path6386 || (_path6386 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v-1h1v1z",
    fill: "#73f0e2"
  })), _path6387 || (_path6387 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#72f2e3"
  })), _path6388 || (_path6388 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#76efe2"
  })), _path6389 || (_path6389 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110v-1h1v1z",
    fill: "#75f2e5"
  })), _path6390 || (_path6390 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1z",
    fill: "#74f4e6"
  })), _path6391 || (_path6391 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#71efe0"
  })), _path6392 || (_path6392 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#76f0e1"
  })), _path6393 || (_path6393 = /*#__PURE__*/React.createElement("path", {
    d: "M62 110h-1v-1h1z",
    fill: "#73f2e1"
  })), _path6394 || (_path6394 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h1v1h-1z",
    fill: "#6ff2e0"
  })), _path6395 || (_path6395 = /*#__PURE__*/React.createElement("path", {
    d: "M64 109v1h-1v-1z",
    fill: "#76f2e3"
  })), _path6396 || (_path6396 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#73f3e1"
  })), _path6397 || (_path6397 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#77f2e3"
  })), _path6398 || (_path6398 = /*#__PURE__*/React.createElement("path", {
    d: "M66 109h1v1h-1z",
    fill: "#7cf1e3"
  })), _path6399 || (_path6399 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109v1h-1v-1z",
    fill: "#82f2e6"
  })), _path6400 || (_path6400 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#73f6e6"
  })), _path6401 || (_path6401 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#71f5e5"
  })), _path6402 || (_path6402 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109h1v1h-1z",
    fill: "#70f4e4"
  })), _path6403 || (_path6403 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#71f4e5"
  })), _path6404 || (_path6404 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#72f4e5"
  })), _path6405 || (_path6405 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#74f3e6"
  })), _path6406 || (_path6406 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#76f3e6"
  })), _path6407 || (_path6407 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#78f4e7"
  })), _path6408 || (_path6408 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#7cf6e7"
  })), _path6409 || (_path6409 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#7ef6e7"
  })), _path6410 || (_path6410 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#80f5e9"
  })), _path6411 || (_path6411 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-1h1z",
    fill: "#86f6eb"
  })), _path6412 || (_path6412 = /*#__PURE__*/React.createElement("path", {
    d: "M84 109v1h-1v-1z",
    fill: "#88f5ea"
  })), _path6413 || (_path6413 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110h-1v-1h1z",
    fill: "#89f5e9"
  })), _path6414 || (_path6414 = /*#__PURE__*/React.createElement("path", {
    d: "M85 109h1v1h-1z",
    fill: "#83f3e5"
  })), _path6415 || (_path6415 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v1h-1v-1z",
    fill: "#9af4e8"
  })), _path6416 || (_path6416 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h1v1h-1z",
    fill: "#9afaed"
  })), _path6417 || (_path6417 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109v1h-1v-1z",
    fill: "#6ab0a7"
  })), _path6418 || (_path6418 = /*#__PURE__*/React.createElement("path", {
    d: "M89 110v-1h1v1z",
    fill: "#4b4c4d"
  })), _path6419 || (_path6419 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#4c4c4f"
  })), _path6420 || (_path6420 = /*#__PURE__*/React.createElement("path", {
    d: "M91 109h1v1h-1z",
    fill: "#454648"
  })), _path6421 || (_path6421 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110v-1h1v1z",
    fill: "#626365"
  })), _path6422 || (_path6422 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110h-1v-1h1z",
    fill: "#737476"
  })), _path6423 || (_path6423 = /*#__PURE__*/React.createElement("path", {
    d: "M98 109h1v1h-1z",
    fill: "#383a38"
  })), _path6424 || (_path6424 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110h-1v-1h1z",
    fill: "#595b5a"
  })), _path6425 || (_path6425 = /*#__PURE__*/React.createElement("path", {
    d: "M100 109h1v1h-1z",
    fill: "#5e605f"
  })), _path6426 || (_path6426 = /*#__PURE__*/React.createElement("path", {
    d: "M102 110h-1v-1h1z",
    fill: "#505253"
  })), _path6427 || (_path6427 = /*#__PURE__*/React.createElement("path", {
    d: "M103 109v1h-1v-1z",
    fill: "#363738"
  })), _path6428 || (_path6428 = /*#__PURE__*/React.createElement("path", {
    d: "M104 109v1h-1v-1z",
    fill: "#3a3c3a"
  })), _path6429 || (_path6429 = /*#__PURE__*/React.createElement("path", {
    d: "M105 110h-1v-1h1z",
    fill: "#3b3d3c"
  })), _path6430 || (_path6430 = /*#__PURE__*/React.createElement("path", {
    d: "M105 110v-1h1v1z",
    fill: "#333634"
  })), _path6431 || (_path6431 = /*#__PURE__*/React.createElement("path", {
    d: "M108 110h-1v-1h1z",
    fill: "#3f4140"
  })), _path6432 || (_path6432 = /*#__PURE__*/React.createElement("path", {
    d: "M117 110v-1h1v1z",
    fill: "#484a49"
  })), _path6433 || (_path6433 = /*#__PURE__*/React.createElement("path", {
    d: "M122 110h-1v-1h1z",
    fill: "#494b4a"
  })), _path6434 || (_path6434 = /*#__PURE__*/React.createElement("path", {
    d: "M122 109h1v1h-1z",
    fill: "#444544",
    fillOpacity: 0.992
  })), _path6435 || (_path6435 = /*#__PURE__*/React.createElement("path", {
    d: "M123 109h1v1h-1z",
    fill: "#44443f",
    fillOpacity: 0.22
  })), _path6436 || (_path6436 = /*#__PURE__*/React.createElement("path", {
    d: "M7 111H6v-1h1z",
    fill: "#27443a",
    fillOpacity: 0.102
  })), _path6437 || (_path6437 = /*#__PURE__*/React.createElement("path", {
    d: "M7 110h1v1H7z",
    fill: "#12483b",
    fillOpacity: 0.318
  })), _path6438 || (_path6438 = /*#__PURE__*/React.createElement("path", {
    d: "M8 111v-1h1v1z",
    fill: "#094637",
    fillOpacity: 0.537
  })), _path6439 || (_path6439 = /*#__PURE__*/React.createElement("path", {
    d: "M10 111H9v-1h1z",
    fill: "#0b4338",
    fillOpacity: 0.714
  })), _path6440 || (_path6440 = /*#__PURE__*/React.createElement("path", {
    d: "M11 110v1h-1v-1z",
    fill: "#092a24",
    fillOpacity: 0.816
  })), _path6441 || (_path6441 = /*#__PURE__*/React.createElement("path", {
    d: "M12 111h-1v-1h1z",
    fill: "#000403"
  })), _path6442 || (_path6442 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111h-1v-1h1z",
    fill: "#050507"
  })), _path6443 || (_path6443 = /*#__PURE__*/React.createElement("path", {
    d: "M23 110h1v1h-1z",
    fill: "#010502"
  })), _path6444 || (_path6444 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v1h-1v-1z",
    fill: "#163a33"
  })), _path6445 || (_path6445 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111h-1v-1h1z",
    fill: "#60e6d4"
  })), _path6446 || (_path6446 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#68ebd7"
  })), _path6447 || (_path6447 = /*#__PURE__*/React.createElement("path", {
    d: "M35 111v-1h1v1z",
    fill: "#a2ece0"
  })), _path6448 || (_path6448 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v-1h1v1z",
    fill: "#a7eee3"
  })), _path6449 || (_path6449 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#6de9d5"
  })), _path6450 || (_path6450 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1z",
    fill: "#5decda"
  })), _path6451 || (_path6451 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h1v1h-1z",
    fill: "#62eddc"
  })), _path6452 || (_path6452 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111h-1v-1h1z",
    fill: "#62eedd"
  })), _path6453 || (_path6453 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-1v-1z",
    fill: "#60efde"
  })), _path6454 || (_path6454 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#63efdc"
  })), _path6455 || (_path6455 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h-1v-1h1z",
    fill: "#66efdd"
  })), _path6456 || (_path6456 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#6defdd"
  })), _path6457 || (_path6457 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#6ceddd"
  })), _path6458 || (_path6458 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111v-1h1v1z",
    fill: "#65eddc"
  })), _path6459 || (_path6459 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110v1h-1v-1z",
    fill: "#67ecdd"
  })), _path6460 || (_path6460 = /*#__PURE__*/React.createElement("path", {
    d: "M51 111v-1h1v1z",
    fill: "#62eddb"
  })), _path6461 || (_path6461 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1z",
    fill: "#65eddb"
  })), _path6462 || (_path6462 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#67ebda"
  })), _path6463 || (_path6463 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111v-1h1v1z",
    fill: "#69ecdd"
  })), _path6464 || (_path6464 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110h1v1h-1z",
    fill: "#6deddd"
  })), _path6465 || (_path6465 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v-1h1v1z",
    fill: "#60eedb"
  })), _path6466 || (_path6466 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110h1v1h-1z",
    fill: "#64ecdd"
  })), _path6467 || (_path6467 = /*#__PURE__*/React.createElement("path", {
    d: "M62 111h-1v-1h1z",
    fill: "#65eedd"
  })), _path6468 || (_path6468 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1z",
    fill: "#66eedc"
  })), _path6469 || (_path6469 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fill: "#63eddb"
  })), _path6470 || (_path6470 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111h-1v-1h1z",
    fill: "#63efdd"
  })), _path6471 || (_path6471 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111v-1h1v1z",
    fill: "#64f0dc"
  })), _path6472 || (_path6472 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#64efdb"
  })), _path6473 || (_path6473 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#65efde"
  })), _path6474 || (_path6474 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1z",
    fill: "#64f0de"
  })), _path6475 || (_path6475 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110h1v1h-1z",
    fill: "#65f0df"
  })), _path6476 || (_path6476 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#64f0e1"
  })), _path6477 || (_path6477 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#65f0e2"
  })), _path6478 || (_path6478 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111v-1h1v1z",
    fill: "#65f0e1"
  })), _path6479 || (_path6479 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#65efe0"
  })), _path6480 || (_path6480 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#64f1e1"
  })), _path6481 || (_path6481 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h1v1h-1z",
    fill: "#66f0e1"
  })), _path6482 || (_path6482 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#61eedd"
  })), _path6483 || (_path6483 = /*#__PURE__*/React.createElement("path", {
    d: "M86 110h1v1h-1z",
    fill: "#89f1e0"
  })), _path6484 || (_path6484 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110v1h-1v-1z",
    fill: "#8bf6e6"
  })), _path6485 || (_path6485 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110h1v1h-1z",
    fill: "#4c9c90"
  })), _path6486 || (_path6486 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111v-1h1v1z",
    fill: "#07080a"
  })), _path6487 || (_path6487 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111h-1v-1h1z",
    fill: "#08090a"
  })), _path6488 || (_path6488 = /*#__PURE__*/React.createElement("path", {
    d: "M94 110h1v1h-1z",
    fill: "#0a0b0c"
  })), _path6489 || (_path6489 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111h-1v-1h1z",
    fill: "#0a0a0b"
  })), _path6490 || (_path6490 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110v1h-1v-1z",
    fill: "#0b0b0c"
  })), _path6491 || (_path6491 = /*#__PURE__*/React.createElement("path", {
    d: "M99 111v-1h1v1z",
    fill: "#0e0f0e"
  })), _path6492 || (_path6492 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110h1v1h-1z",
    fill: "#131413"
  })), _path6493 || (_path6493 = /*#__PURE__*/React.createElement("path", {
    d: "M102 111h-1v-1h1z",
    fill: "#161718"
  })), _path6494 || (_path6494 = /*#__PURE__*/React.createElement("path", {
    d: "M103 111h-1v-1h1z",
    fill: "#1f2020"
  })), _path6495 || (_path6495 = /*#__PURE__*/React.createElement("path", {
    d: "M103 110h1v1h-1z",
    fill: "#222323"
  })), _path6496 || (_path6496 = /*#__PURE__*/React.createElement("path", {
    d: "M111 111h-1v-1h1z",
    fill: "#232423"
  })), _path6497 || (_path6497 = /*#__PURE__*/React.createElement("path", {
    d: "M112 111h-1v-1h1z",
    fill: "#2b2c2c"
  })), _path6498 || (_path6498 = /*#__PURE__*/React.createElement("path", {
    d: "M112 110h1v1h-1z",
    fill: "#2a2b2a"
  })), _path6499 || (_path6499 = /*#__PURE__*/React.createElement("path", {
    d: "M118 111h-1v-1h1z",
    fill: "#2a2b2b"
  })), _path6500 || (_path6500 = /*#__PURE__*/React.createElement("path", {
    d: "M120 110h1v1h-1z",
    fill: "#2c2d2d"
  })), _path6501 || (_path6501 = /*#__PURE__*/React.createElement("path", {
    d: "M121 111v-1h1v1z",
    fill: "#2b2c2b"
  })), _path6502 || (_path6502 = /*#__PURE__*/React.createElement("path", {
    d: "M124 110v1h-1v-1z",
    fill: "#322e2e",
    fillOpacity: 0.259
  })), _path6503 || (_path6503 = /*#__PURE__*/React.createElement("path", {
    d: "M10 111h1v1h-1z",
    fill: "#362424",
    fillOpacity: 0.055
  })), _path6504 || (_path6504 = /*#__PURE__*/React.createElement("path", {
    d: "M11 111h1v1h-1z",
    fill: "#0a0c08",
    fillOpacity: 0.569
  })), _path6505 || (_path6505 = /*#__PURE__*/React.createElement("path", {
    d: "M12 112v-1h1v1z",
    fill: "#0a0805",
    fillOpacity: 0.678
  })), _path6506 || (_path6506 = /*#__PURE__*/React.createElement("path", {
    d: "M13 112v-1h1v1z",
    fill: "#070704",
    fillOpacity: 0.667
  })), _path6507 || (_path6507 = /*#__PURE__*/React.createElement("path", {
    d: "M15 111v1h-1v-1z",
    fill: "#060704",
    fillOpacity: 0.659
  })), _path6508 || (_path6508 = /*#__PURE__*/React.createElement("path", {
    d: "M15 111h1v1h-1z",
    fill: "#060604",
    fillOpacity: 0.647
  })), _path6509 || (_path6509 = /*#__PURE__*/React.createElement("path", {
    d: "M17 111v1h-1v-1z",
    fill: "#030603",
    fillOpacity: 0.635
  })), _path6510 || (_path6510 = /*#__PURE__*/React.createElement("path", {
    d: "M17 111h1v1h-1z",
    fill: "#101210",
    fillOpacity: 0.604
  })), _path6511 || (_path6511 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111v1h-1v-1z",
    fill: "#0c0d0c",
    fillOpacity: 0.945
  })), _path6512 || (_path6512 = /*#__PURE__*/React.createElement("path", {
    d: "M33 111v1h-1v-1z",
    fill: "#133530"
  })), _path6513 || (_path6513 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111v1h-1v-1z",
    fill: "#53dac8"
  })), _path6514 || (_path6514 = /*#__PURE__*/React.createElement("path", {
    d: "M34 112v-1h1v1z",
    fill: "#5be2cc"
  })), _path6515 || (_path6515 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v1h-1v-1z",
    fill: "#95e6d6"
  })), _path6516 || (_path6516 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112h-1v-1h1z",
    fill: "#9ce6d7"
  })), _path6517 || (_path6517 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#63dfca"
  })), _path6518 || (_path6518 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-1h1z",
    fill: "#4fe3cf"
  })), _path6519 || (_path6519 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112h-1v-1h1z",
    fill: "#51e6d1"
  })), _path6520 || (_path6520 = /*#__PURE__*/React.createElement("path", {
    d: "M42 111h1v1h-1z",
    fill: "#52e6d1"
  })), _path6521 || (_path6521 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#51e6cd"
  })), _path6522 || (_path6522 = /*#__PURE__*/React.createElement("path", {
    d: "M44 112v-1h1v1z",
    fill: "#53e4cf"
  })), _path6523 || (_path6523 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v-1h1v1z",
    fill: "#62e4d0"
  })), _path6524 || (_path6524 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h1v1h-1z",
    fill: "#70e4d3"
  })), _path6525 || (_path6525 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111v1h-1v-1z",
    fill: "#6ae2d0"
  })), _path6526 || (_path6526 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111h1v1h-1z",
    fill: "#70e4d4"
  })), _path6527 || (_path6527 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112h-1v-1h1z",
    fill: "#63e3cf"
  })), _path6528 || (_path6528 = /*#__PURE__*/React.createElement("path", {
    d: "M50 111h1v1h-1z",
    fill: "#70e5d4"
  })), _path6529 || (_path6529 = /*#__PURE__*/React.createElement("path", {
    d: "M52 112h-1v-1h1z",
    fill: "#69e3cf"
  })), _path6530 || (_path6530 = /*#__PURE__*/React.createElement("path", {
    d: "M52 111h1v1h-1z",
    fill: "#6be3cf"
  })), _path6531 || (_path6531 = /*#__PURE__*/React.createElement("path", {
    d: "M53 112v-1h1v1z",
    fill: "#6ce4cf"
  })), _path6532 || (_path6532 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111v1h-1v-1z",
    fill: "#72e5d3"
  })), _path6533 || (_path6533 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111h1v1h-1z",
    fill: "#69e7d1"
  })), _path6534 || (_path6534 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h1v1h-1z",
    fill: "#67e2ce"
  })), _path6535 || (_path6535 = /*#__PURE__*/React.createElement("path", {
    d: "M58 112h-1v-1h1z",
    fill: "#71e6d3"
  })), _path6536 || (_path6536 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1z",
    fill: "#6de7d2"
  })), _path6537 || (_path6537 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111v1h-1v-1z",
    fill: "#71e6d4"
  })), _path6538 || (_path6538 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v1h-1v-1z",
    fill: "#66e4d1"
  })), _path6539 || (_path6539 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111h1v1h-1z",
    fill: "#6be5d2"
  })), _path6540 || (_path6540 = /*#__PURE__*/React.createElement("path", {
    d: "M63 111v1h-1v-1z",
    fill: "#73e6d4"
  })), _path6541 || (_path6541 = /*#__PURE__*/React.createElement("path", {
    d: "M63 112v-1h1v1z",
    fill: "#6de6d2"
  })), _path6542 || (_path6542 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v1h-1v-1z",
    fill: "#6fe8d5"
  })), _path6543 || (_path6543 = /*#__PURE__*/React.createElement("path", {
    d: "M66 112h-1v-1h1z",
    fill: "#6ee7d5"
  })), _path6544 || (_path6544 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111h1v1h-1z",
    fill: "#68e1ce"
  })), _path6545 || (_path6545 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111v1h-1v-1z",
    fill: "#76ead8"
  })), _path6546 || (_path6546 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111h1v1h-1z",
    fill: "#73e6d5"
  })), _path6547 || (_path6547 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h-1v-1h1z",
    fill: "#71e7d5"
  })), _path6548 || (_path6548 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1z",
    fill: "#6ee7d4"
  })), _path6549 || (_path6549 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#6cead7"
  })), _path6550 || (_path6550 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#5ee9d6"
  })), _path6551 || (_path6551 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v1h-1v-1z",
    fill: "#5cead6"
  })), _path6552 || (_path6552 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h-1v-1h1z",
    fill: "#5cebd7"
  })), _path6553 || (_path6553 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v1h-1v-1z",
    fill: "#5debd8"
  })), _path6554 || (_path6554 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h1v1h-1z",
    fill: "#5becd9"
  })), _path6555 || (_path6555 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#5cedd9"
  })), _path6556 || (_path6556 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112h-1v-1h1z",
    fill: "#5aecd6"
  })), _path6557 || (_path6557 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#5cecd6"
  })), _path6558 || (_path6558 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#5cebd6"
  })), _path6559 || (_path6559 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#58e9d3"
  })), _path6560 || (_path6560 = /*#__PURE__*/React.createElement("path", {
    d: "M86 112v-1h1v1z",
    fill: "#83ebd8"
  })), _path6561 || (_path6561 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112v-1h1v1z",
    fill: "#7ff0df"
  })), _path6562 || (_path6562 = /*#__PURE__*/React.createElement("path", {
    d: "M89 111v1h-1v-1z",
    fill: "#419489"
  })), _path6563 || (_path6563 = /*#__PURE__*/React.createElement("path", {
    d: "M124 112h-1v-1h1z",
    fill: "#1c1c19",
    fillOpacity: 0.278
  })), _path6564 || (_path6564 = /*#__PURE__*/React.createElement("path", {
    d: "M18 113v-1h1v1z",
    fill: "#1d1d16",
    fillOpacity: 0.306
  })), _path6565 || (_path6565 = /*#__PURE__*/React.createElement("path", {
    d: "M19 112h1v1h-1z",
    fill: "#0a0a06",
    fillOpacity: 0.788
  })), _path6566 || (_path6566 = /*#__PURE__*/React.createElement("path", {
    d: "M20 112h1v1h-1z",
    fill: "#050504",
    fillOpacity: 0.929
  })), _path6567 || (_path6567 = /*#__PURE__*/React.createElement("path", {
    d: "M21 113v-1h1v1z",
    fill: "#030503",
    fillOpacity: 0.949
  })), _path6568 || (_path6568 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v-1h1v1z",
    fill: "#030502",
    fillOpacity: 0.929
  })), _path6569 || (_path6569 = /*#__PURE__*/React.createElement("path", {
    d: "M24 113h-1v-1h1z",
    fill: "#020403",
    fillOpacity: 0.992
  })), _path6570 || (_path6570 = /*#__PURE__*/React.createElement("path", {
    d: "M32 113v-1h1v1z",
    fill: "#0f2925"
  })), _path6571 || (_path6571 = /*#__PURE__*/React.createElement("path", {
    d: "M34 113h-1v-1h1z",
    fill: "#47c1b0"
  })), _path6572 || (_path6572 = /*#__PURE__*/React.createElement("path", {
    d: "M35 112v1h-1v-1z",
    fill: "#4bcdb6"
  })), _path6573 || (_path6573 = /*#__PURE__*/React.createElement("path", {
    d: "M36 113h-1v-1h1z",
    fill: "#83d3c1"
  })), _path6574 || (_path6574 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112v1h-1v-1z",
    fill: "#8ad5c2"
  })), _path6575 || (_path6575 = /*#__PURE__*/React.createElement("path", {
    d: "M38 112v1h-1v-1z",
    fill: "#51ccb4"
  })), _path6576 || (_path6576 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112v1h-1v-1z",
    fill: "#40cfb7"
  })), _path6577 || (_path6577 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1z",
    fill: "#45d0b7"
  })), _path6578 || (_path6578 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1z",
    fill: "#4cd3ba"
  })), _path6579 || (_path6579 = /*#__PURE__*/React.createElement("path", {
    d: "M42 113h-1v-1h1z",
    fill: "#4fd6bc"
  })), _path6580 || (_path6580 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#4cd2b9"
  })), _path6581 || (_path6581 = /*#__PURE__*/React.createElement("path", {
    d: "M43 112h1v1h-1z",
    fill: "#53d7bc"
  })), _path6582 || (_path6582 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v1h-1v-1z",
    fill: "#47d3ba"
  })), _path6583 || (_path6583 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#43d2b9"
  })), _path6584 || (_path6584 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112h1v1h-1z",
    fill: "#46cfb7"
  })), _path6585 || (_path6585 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h-1v-1h1z",
    fill: "#46d1b9"
  })), _path6586 || (_path6586 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112v1h-1v-1z",
    fill: "#48d0b9"
  })), _path6587 || (_path6587 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112v1h-1v-1z",
    fill: "#46d2b9"
  })), _path6588 || (_path6588 = /*#__PURE__*/React.createElement("path", {
    d: "M51 112v1h-1v-1z",
    fill: "#49d0b9"
  })), _path6589 || (_path6589 = /*#__PURE__*/React.createElement("path", {
    d: "M51 113v-1h1v1z",
    fill: "#47d0b8"
  })), _path6590 || (_path6590 = /*#__PURE__*/React.createElement("path", {
    d: "M53 113h-1v-1h1z",
    fill: "#48d2ba"
  })), _path6591 || (_path6591 = /*#__PURE__*/React.createElement("path", {
    d: "M54 112v1h-1v-1z",
    fill: "#49d1ba"
  })), _path6592 || (_path6592 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v-1h1v1z",
    fill: "#4dd2bb"
  })), _path6593 || (_path6593 = /*#__PURE__*/React.createElement("path", {
    d: "M57 112v1h-1v-1z",
    fill: "#48d4ba"
  })), _path6594 || (_path6594 = /*#__PURE__*/React.createElement("path", {
    d: "M57 113v-1h1v1z",
    fill: "#44d4b9"
  })), _path6595 || (_path6595 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113v-1h1v1z",
    fill: "#51d3bc"
  })), _path6596 || (_path6596 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h-1v-1h1z",
    fill: "#4bd6bc"
  })), _path6597 || (_path6597 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112v1h-1v-1z",
    fill: "#4cd6bc"
  })), _path6598 || (_path6598 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112h1v1h-1z",
    fill: "#4fd4bc"
  })), _path6599 || (_path6599 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h-1v-1h1z",
    fill: "#51d7bd"
  })), _path6600 || (_path6600 = /*#__PURE__*/React.createElement("path", {
    d: "M65 113h-1v-1h1z",
    fill: "#53d6bc"
  })), _path6601 || (_path6601 = /*#__PURE__*/React.createElement("path", {
    d: "M65 112h1v1h-1z",
    fill: "#51d6bc"
  })), _path6602 || (_path6602 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112v1h-1v-1z",
    fill: "#4dd4bc"
  })), _path6603 || (_path6603 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112h1v1h-1z",
    fill: "#52d5be"
  })), _path6604 || (_path6604 = /*#__PURE__*/React.createElement("path", {
    d: "M69 112v1h-1v-1z",
    fill: "#54d4bd"
  })), _path6605 || (_path6605 = /*#__PURE__*/React.createElement("path", {
    d: "M69 113v-1h1v1z",
    fill: "#57d6c0"
  })), _path6606 || (_path6606 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h1v1h-1z",
    fill: "#55d4bd"
  })), _path6607 || (_path6607 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v-1h1v1z",
    fill: "#57d6bf"
  })), _path6608 || (_path6608 = /*#__PURE__*/React.createElement("path", {
    d: "M73 112v1h-1v-1z",
    fill: "#59d7c1"
  })), _path6609 || (_path6609 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#52d8c0"
  })), _path6610 || (_path6610 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#47dbc2"
  })), _path6611 || (_path6611 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#48dcc3"
  })), _path6612 || (_path6612 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112v1h-1v-1z",
    fill: "#49ddc4"
  })), _path6613 || (_path6613 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h1v1h-1z",
    fill: "#48ddc4"
  })), _path6614 || (_path6614 = /*#__PURE__*/React.createElement("path", {
    d: "M79 112v1h-1v-1z",
    fill: "#48ddc2"
  })), _path6615 || (_path6615 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113h-1v-1h1z",
    fill: "#4cdfc4"
  })), _path6616 || (_path6616 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112h1v1h-1z",
    fill: "#4ddec5"
  })), _path6617 || (_path6617 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#4adec5"
  })), _path6618 || (_path6618 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#49dec5"
  })), _path6619 || (_path6619 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#4cdec5"
  })), _path6620 || (_path6620 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#4cddc4"
  })), _path6621 || (_path6621 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113v-1h1v1z",
    fill: "#4adcc2"
  })), _path6622 || (_path6622 = /*#__PURE__*/React.createElement("path", {
    d: "M86 113v-1h1v1z",
    fill: "#74e1cb"
  })), _path6623 || (_path6623 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112h1v1h-1z",
    fill: "#6de3ce"
  })), _path6624 || (_path6624 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v-1h1v1z",
    fill: "#358478"
  })), _path6625 || (_path6625 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113v-1h1v1z",
    fill: "#030102"
  })), _path6626 || (_path6626 = /*#__PURE__*/React.createElement("path", {
    d: "M122 112h1v1h-1z",
    fill: "#0a0908"
  })), _path6627 || (_path6627 = /*#__PURE__*/React.createElement("path", {
    d: "M124 112v1h-1v-1z",
    fill: "#191515",
    fillOpacity: 0.275
  })), _path6628 || (_path6628 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114h-1v-1h1z",
    fill: "#181810",
    fillOpacity: 0.122
  })), _path6629 || (_path6629 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v1h-1v-1z",
    fill: "#15150e",
    fillOpacity: 0.141
  })), _path6630 || (_path6630 = /*#__PURE__*/React.createElement("path", {
    d: "M23 114h-1v-1h1z",
    fill: "#101810",
    fillOpacity: 0.122
  })), _path6631 || (_path6631 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114h-1v-1h1z",
    fill: "#070805",
    fillOpacity: 0.702
  })), _path6632 || (_path6632 = /*#__PURE__*/React.createElement("path", {
    d: "M32 114v-1h1v1z",
    fill: "#091a16"
  })), _path6633 || (_path6633 = /*#__PURE__*/React.createElement("path", {
    d: "M33 113h1v1h-1z",
    fill: "#359b88"
  })), _path6634 || (_path6634 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v-1h1v1z",
    fill: "#34aa91"
  })), _path6635 || (_path6635 = /*#__PURE__*/React.createElement("path", {
    d: "M35 113h1v1h-1z",
    fill: "#62ae9a"
  })), _path6636 || (_path6636 = /*#__PURE__*/React.createElement("path", {
    d: "M36 114v-1h1v1z",
    fill: "#6bb19e"
  })), _path6637 || (_path6637 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114h-1v-1h1z",
    fill: "#42aa91"
  })), _path6638 || (_path6638 = /*#__PURE__*/React.createElement("path", {
    d: "M38 113h1v1h-1z",
    fill: "#3aab96"
  })), _path6639 || (_path6639 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1z",
    fill: "#56b5a0"
  })), _path6640 || (_path6640 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#67b8a6"
  })), _path6641 || (_path6641 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#68b9a6"
  })), _path6642 || (_path6642 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#56b29b"
  })), _path6643 || (_path6643 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114h-1v-1h1z",
    fill: "#6ab9a5"
  })), _path6644 || (_path6644 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#44ae98"
  })), _path6645 || (_path6645 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#38ae96"
  })), _path6646 || (_path6646 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#3eb59d"
  })), _path6647 || (_path6647 = /*#__PURE__*/React.createElement("path", {
    d: "M47 113h1v1h-1z",
    fill: "#3db39b"
  })), _path6648 || (_path6648 = /*#__PURE__*/React.createElement("path", {
    d: "M49 113v1h-1v-1z",
    fill: "#3eb39b"
  })), _path6649 || (_path6649 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114v-1h1v1z",
    fill: "#3db59e"
  })), _path6650 || (_path6650 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h-1v-1h1z",
    fill: "#3ab49d"
  })), _path6651 || (_path6651 = /*#__PURE__*/React.createElement("path", {
    d: "M52 113v1h-1v-1z",
    fill: "#3ab39e"
  })), _path6652 || (_path6652 = /*#__PURE__*/React.createElement("path", {
    d: "M52 113h1v1h-1z",
    fill: "#39b49f"
  })), _path6653 || (_path6653 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v1h-1v-1z",
    fill: "#35b39c"
  })), _path6654 || (_path6654 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113h1v1h-1z",
    fill: "#38b59d"
  })), _path6655 || (_path6655 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114v-1h1v1z",
    fill: "#3bb69e"
  })), _path6656 || (_path6656 = /*#__PURE__*/React.createElement("path", {
    d: "M56 114v-1h1v1z",
    fill: "#3bb79e"
  })), _path6657 || (_path6657 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114h-1v-1h1z",
    fill: "#3ab79e"
  })), _path6658 || (_path6658 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114v-1h1v1z",
    fill: "#3ab8a0"
  })), _path6659 || (_path6659 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v-1h1v1z",
    fill: "#36bba0"
  })), _path6660 || (_path6660 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h1v1z",
    fill: "#36b8a0"
  })), _path6661 || (_path6661 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h1v1h-1z",
    fill: "#3dbaa4"
  })), _path6662 || (_path6662 = /*#__PURE__*/React.createElement("path", {
    d: "M63 113v1h-1v-1z",
    fill: "#3bbca4"
  })), _path6663 || (_path6663 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v-1h1v1z",
    fill: "#39baa2"
  })), _path6664 || (_path6664 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h1v1h-1z",
    fill: "#37bba2"
  })), _path6665 || (_path6665 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114v-1h1v1z",
    fill: "#39bba4"
  })), _path6666 || (_path6666 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114h-1v-1h1z",
    fill: "#38bca5"
  })), _path6667 || (_path6667 = /*#__PURE__*/React.createElement("path", {
    d: "M68 113v1h-1v-1z",
    fill: "#32baa2"
  })), _path6668 || (_path6668 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114h-1v-1h1z",
    fill: "#32bba2"
  })), _path6669 || (_path6669 = /*#__PURE__*/React.createElement("path", {
    d: "M70 113v1h-1v-1z",
    fill: "#31bba2"
  })), _path6670 || (_path6670 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v1h-1v-1z",
    fill: "#30bca2"
  })), _path6671 || (_path6671 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h-1v-1h1z",
    fill: "#31bda2"
  })), _path6672 || (_path6672 = /*#__PURE__*/React.createElement("path", {
    d: "M75 114h-1v-1h1z",
    fill: "#32bea2"
  })), _path6673 || (_path6673 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1z",
    fill: "#34bea3"
  })), _path6674 || (_path6674 = /*#__PURE__*/React.createElement("path", {
    d: "M76 113h1v1h-1z",
    fill: "#35c0a4"
  })), _path6675 || (_path6675 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114v-1h1v1z",
    fill: "#2ec0a2"
  })), _path6676 || (_path6676 = /*#__PURE__*/React.createElement("path", {
    d: "M78 114v-1h1v1z",
    fill: "#31bea1"
  })), _path6677 || (_path6677 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113v1h-1v-1z",
    fill: "#60c5af"
  })), _path6678 || (_path6678 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114v-1h1v1z",
    fill: "#66c8b3"
  })), _path6679 || (_path6679 = /*#__PURE__*/React.createElement("path", {
    d: "M82 114h-1v-1h1z",
    fill: "#48c4a9"
  })), _path6680 || (_path6680 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#48c6ab"
  })), _path6681 || (_path6681 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114h-1v-1h1z",
    fill: "#46c4ab"
  })), _path6682 || (_path6682 = /*#__PURE__*/React.createElement("path", {
    d: "M85 114h-1v-1h1z",
    fill: "#41c4ab"
  })), _path6683 || (_path6683 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#3ac1a8"
  })), _path6684 || (_path6684 = /*#__PURE__*/React.createElement("path", {
    d: "M87 113v1h-1v-1z",
    fill: "#62c8b2"
  })), _path6685 || (_path6685 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v1h-1v-1z",
    fill: "#58c6b0"
  })), _path6686 || (_path6686 = /*#__PURE__*/React.createElement("path", {
    d: "M89 114h-1v-1h1z",
    fill: "#27685e"
  })), _path6687 || (_path6687 = /*#__PURE__*/React.createElement("path", {
    d: "M123 113v1h-1v-1z",
    fill: "#080706",
    fillOpacity: 0.992
  })), _path6688 || (_path6688 = /*#__PURE__*/React.createElement("path", {
    d: "M124 114h-1v-1h1z",
    fill: "#1f1a16",
    fillOpacity: 0.224
  })), _path6689 || (_path6689 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114v1h-1v-1z",
    fill: "#181812",
    fillOpacity: 0.161
  })), _path6690 || (_path6690 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114h1v1h-1z",
    fill: "#161614",
    fillOpacity: 0.478
  })), _path6691 || (_path6691 = /*#__PURE__*/React.createElement("path", {
    d: "M26 114v1h-1v-1z",
    fill: "#141410",
    fillOpacity: 0.486
  })), _path6692 || (_path6692 = /*#__PURE__*/React.createElement("path", {
    d: "M27 115h-1v-1h1z",
    fill: "#12120e",
    fillOpacity: 0.49
  })), _path6693 || (_path6693 = /*#__PURE__*/React.createElement("path", {
    d: "M28 114v1h-1v-1z",
    fill: "#11110d",
    fillOpacity: 0.506
  })), _path6694 || (_path6694 = /*#__PURE__*/React.createElement("path", {
    d: "M29 114v1h-1v-1z",
    fill: "#0f110d",
    fillOpacity: 0.51
  })), _path6695 || (_path6695 = /*#__PURE__*/React.createElement("path", {
    d: "M30 115h-1v-1h1z",
    fill: "#0d0f0f",
    fillOpacity: 0.522
  })), _path6696 || (_path6696 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114v1h-1v-1z",
    fill: "#0e100e",
    fillOpacity: 0.549
  })), _path6697 || (_path6697 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114h1v1h-1z",
    fill: "#0d0d0d",
    fillOpacity: 0.58
  })), _path6698 || (_path6698 = /*#__PURE__*/React.createElement("path", {
    d: "M33 115h-1v-1h1z",
    fill: "#0d1614",
    fillOpacity: 0.573
  })), _path6699 || (_path6699 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v1h-1v-1z",
    fill: "#397264",
    fillOpacity: 0.745
  })), _path6700 || (_path6700 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115h-1v-1h1z",
    fill: "#387d6c",
    fillOpacity: 0.839
  })), _path6701 || (_path6701 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v-1h1v1z",
    fill: "#527b6e",
    fillOpacity: 0.851
  })), _path6702 || (_path6702 = /*#__PURE__*/React.createElement("path", {
    d: "M37 114v1h-1v-1z",
    fill: "#587d71",
    fillOpacity: 0.871
  })), _path6703 || (_path6703 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1z",
    fill: "#417e6d",
    fillOpacity: 0.875
  })), _path6704 || (_path6704 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v-1h1v1z",
    fill: "#387d6d",
    fillOpacity: 0.882
  })), _path6705 || (_path6705 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#447d6d",
    fillOpacity: 0.914
  })), _path6706 || (_path6706 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#4b7c6c",
    fillOpacity: 0.937
  })), _path6707 || (_path6707 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#4c7f6e",
    fillOpacity: 0.941
  })), _path6708 || (_path6708 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114h1v1h-1z",
    fill: "#4a7b6b",
    fillOpacity: 0.945
  })), _path6709 || (_path6709 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114v1h-1v-1z",
    fill: "#51806f",
    fillOpacity: 0.953
  })), _path6710 || (_path6710 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#417d6e",
    fillOpacity: 0.969
  })), _path6711 || (_path6711 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115v-1h1v1z",
    fill: "#367d6c",
    fillOpacity: 0.969
  })), _path6712 || (_path6712 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114h1v1h-1z",
    fill: "#35816d",
    fillOpacity: 0.969
  })), _path6713 || (_path6713 = /*#__PURE__*/React.createElement("path", {
    d: "M47 115v-1h1v1z",
    fill: "#37816e",
    fillOpacity: 0.969
  })), _path6714 || (_path6714 = /*#__PURE__*/React.createElement("path", {
    d: "M48 114h1v1h-1z",
    fill: "#39826f",
    fillOpacity: 0.976
  })), _path6715 || (_path6715 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114h1v1h-1z",
    fill: "#39816d",
    fillOpacity: 0.984
  })), _path6716 || (_path6716 = /*#__PURE__*/React.createElement("path", {
    d: "M50 115v-1h1v1z",
    fill: "#38826e",
    fillOpacity: 0.988
  })), _path6717 || (_path6717 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h1v1h-1z",
    fill: "#39826f",
    fillOpacity: 0.992
  })), _path6718 || (_path6718 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115v-1h1v1z",
    fill: "#398271",
    fillOpacity: 0.996
  })), _path6719 || (_path6719 = /*#__PURE__*/React.createElement("path", {
    d: "M53 114h1v1h-1z",
    fill: "#338370"
  })), _path6720 || (_path6720 = /*#__PURE__*/React.createElement("path", {
    d: "M55 115h-1v-1h1z",
    fill: "#378874"
  })), _path6721 || (_path6721 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114h1v1h-1z",
    fill: "#398572"
  })), _path6722 || (_path6722 = /*#__PURE__*/React.createElement("path", {
    d: "M57 114v1h-1v-1z",
    fill: "#398672"
  })), _path6723 || (_path6723 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115v-1h1v1z",
    fill: "#368974"
  })), _path6724 || (_path6724 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v1h-1v-1z",
    fill: "#398a75"
  })), _path6725 || (_path6725 = /*#__PURE__*/React.createElement("path", {
    d: "M60 115h-1v-1h1z",
    fill: "#348b76"
  })), _path6726 || (_path6726 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h-1v-1h1z",
    fill: "#2d8975"
  })), _path6727 || (_path6727 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114h1v1h-1z",
    fill: "#358d79"
  })), _path6728 || (_path6728 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v1h-1v-1z",
    fill: "#378e7a"
  })), _path6729 || (_path6729 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v-1h1v1z",
    fill: "#338d79"
  })), _path6730 || (_path6730 = /*#__PURE__*/React.createElement("path", {
    d: "M65 115h-1v-1h1z",
    fill: "#308e79"
  })), _path6731 || (_path6731 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114h1v1h-1z",
    fill: "#2f8e7a"
  })), _path6732 || (_path6732 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114v1h-1v-1z",
    fill: "#2e8f7b"
  })), _path6733 || (_path6733 = /*#__PURE__*/React.createElement("path", {
    d: "M67 115v-1h1v1z",
    fill: "#2d907b"
  })), _path6734 || (_path6734 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114v1h-1v-1z",
    fill: "#2e8f7a"
  })), _path6735 || (_path6735 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114v1h-1v-1z",
    fill: "#2e907a"
  })), _path6736 || (_path6736 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h1v1h-1z",
    fill: "#2e9079"
  })), _path6737 || (_path6737 = /*#__PURE__*/React.createElement("path", {
    d: "M75 115v-1h1v1z",
    fill: "#2f917b"
  })), _path6738 || (_path6738 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115v-1h1v1z",
    fill: "#2d9079"
  })), _path6739 || (_path6739 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114h1v1h-1z",
    fill: "#2a9079"
  })), _path6740 || (_path6740 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114v1h-1v-1z",
    fill: "#308d79"
  })), _path6741 || (_path6741 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114h1v1h-1z",
    fill: "#4d9683"
  })), _path6742 || (_path6742 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114h1v1h-1z",
    fill: "#569685"
  })), _path6743 || (_path6743 = /*#__PURE__*/React.createElement("path", {
    d: "M81 115v-1h1v1z",
    fill: "#509684"
  })), _path6744 || (_path6744 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115h-1v-1h1z",
    fill: "#509781"
  })), _path6745 || (_path6745 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114v1h-1v-1z",
    fill: "#4b9681"
  })), _path6746 || (_path6746 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115h-1v-1h1z",
    fill: "#469783"
  })), _path6747 || (_path6747 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114v1h-1v-1z",
    fill: "#3b937f"
  })), _path6748 || (_path6748 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114h1v1h-1z",
    fill: "#4f9d8a"
  })), _path6749 || (_path6749 = /*#__PURE__*/React.createElement("path", {
    d: "M88 114v1h-1v-1z",
    fill: "#469785"
  })), _path6750 || (_path6750 = /*#__PURE__*/React.createElement("path", {
    d: "M89 115h-1v-1h1z",
    fill: "#1d443e",
    fillOpacity: 0.957
  })), _path6751 || (_path6751 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115h-1v-1h1z",
    fill: "#030101",
    fillOpacity: 0.91
  })), _path6752 || (_path6752 = /*#__PURE__*/React.createElement("path", {
    d: "M91 114v1h-1v-1z",
    fill: "#030404",
    fillOpacity: 0.922
  })), _path6753 || (_path6753 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v1h-1v-1z",
    fill: "#020403",
    fillOpacity: 0.91
  })), _path6754 || (_path6754 = /*#__PURE__*/React.createElement("path", {
    d: "M92 115v-1h1v1z",
    fill: "#020403",
    fillOpacity: 0.906
  })), _path6755 || (_path6755 = /*#__PURE__*/React.createElement("path", {
    d: "M94 115h-1v-1h1z",
    fill: "#020403",
    fillOpacity: 0.918
  })), _path6756 || (_path6756 = /*#__PURE__*/React.createElement("path", {
    d: "M94 114h1v1h-1z",
    fill: "#040303",
    fillOpacity: 0.925
  })), _path6757 || (_path6757 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v-1h1v1z",
    fill: "#040403",
    fillOpacity: 0.922
  })), _path6758 || (_path6758 = /*#__PURE__*/React.createElement("path", {
    d: "M96 115v-1h1v1z",
    fill: "#050504",
    fillOpacity: 0.91
  })), _path6759 || (_path6759 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114v1h-1v-1z",
    fill: "#050504",
    fillOpacity: 0.914
  })), _path6760 || (_path6760 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114h1v1h-1z",
    fill: "#060605",
    fillOpacity: 0.918
  })), _path6761 || (_path6761 = /*#__PURE__*/React.createElement("path", {
    d: "M99 114h1v1h-1z",
    fill: "#050504",
    fillOpacity: 0.918
  })), _path6762 || (_path6762 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115v-1h1v1z",
    fill: "#050505",
    fillOpacity: 0.918
  })), _path6763 || (_path6763 = /*#__PURE__*/React.createElement("path", {
    d: "M102 115h-1v-1h1z",
    fill: "#060506",
    fillOpacity: 0.941
  })), _path6764 || (_path6764 = /*#__PURE__*/React.createElement("path", {
    d: "M103 114v1h-1v-1z",
    fill: "#050505",
    fillOpacity: 0.98
  })), _path6765 || (_path6765 = /*#__PURE__*/React.createElement("path", {
    d: "M108 115h-1v-1h1z",
    fill: "#030606"
  })), _path6766 || (_path6766 = /*#__PURE__*/React.createElement("path", {
    d: "M123 114v1h-1v-1z",
    fill: "#060606",
    fillOpacity: 0.937
  })), _path6767 || (_path6767 = /*#__PURE__*/React.createElement("path", {
    d: "M124 114v1h-1v-1z",
    fill: "#23231a",
    fillOpacity: 0.114
  })), _path6768 || (_path6768 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v1h-1v-1z",
    fill: "#735c5c",
    fillOpacity: 0.043
  })), _path6769 || (_path6769 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h-1v-1h1z",
    fill: "#62624e",
    fillOpacity: 0.051
  })), _path6770 || (_path6770 = /*#__PURE__*/React.createElement("path", {
    d: "M37 116h-1v-1h1z",
    fill: "#665",
    fillOpacity: 0.059
  })), _path6771 || (_path6771 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#5d6b5d",
    fillOpacity: 0.075
  })), _path6772 || (_path6772 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#4e6b58",
    fillOpacity: 0.102
  })), _path6773 || (_path6773 = /*#__PURE__*/React.createElement("path", {
    d: "M40 115h1v1h-1z",
    fill: "#4f6757",
    fillOpacity: 0.125
  })), _path6774 || (_path6774 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#4d645c",
    fillOpacity: 0.129
  })), _path6775 || (_path6775 = /*#__PURE__*/React.createElement("path", {
    d: "M43 115v1h-1v-1z",
    fill: "#526961",
    fillOpacity: 0.133
  })), _path6776 || (_path6776 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#4d6a63",
    fillOpacity: 0.141
  })), _path6777 || (_path6777 = /*#__PURE__*/React.createElement("path", {
    d: "M45 116h-1v-1h1z",
    fill: "#556d61",
    fillOpacity: 0.165
  })), _path6778 || (_path6778 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115h1v1h-1z",
    fill: "#53705e",
    fillOpacity: 0.169
  })), _path6779 || (_path6779 = /*#__PURE__*/React.createElement("path", {
    d: "M49 116h-1v-1h1z",
    fill: "#517161",
    fillOpacity: 0.184
  })), _path6780 || (_path6780 = /*#__PURE__*/React.createElement("path", {
    d: "M50 116h-1v-1h1z",
    fill: "#4c6b60",
    fillOpacity: 0.196
  })), _path6781 || (_path6781 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115v1h-1v-1z",
    fill: "#4b6e5f",
    fillOpacity: 0.2
  })), _path6782 || (_path6782 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115h1v1h-1z",
    fill: "#4b6c5e",
    fillOpacity: 0.212
  })), _path6783 || (_path6783 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115h1v1h-1z",
    fill: "#4d6d5f",
    fillOpacity: 0.22
  })), _path6784 || (_path6784 = /*#__PURE__*/React.createElement("path", {
    d: "M54 115v1h-1v-1z",
    fill: "#4b7064",
    fillOpacity: 0.239
  })), _path6785 || (_path6785 = /*#__PURE__*/React.createElement("path", {
    d: "M54 116v-1h1v1z",
    fill: "#456f62",
    fillOpacity: 0.243
  })), _path6786 || (_path6786 = /*#__PURE__*/React.createElement("path", {
    d: "M56 115v1h-1v-1z",
    fill: "#426c60",
    fillOpacity: 0.239
  })), _path6787 || (_path6787 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115v1h-1v-1z",
    fill: "#447161",
    fillOpacity: 0.247
  })), _path6788 || (_path6788 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115h1v1h-1z",
    fill: "#446e62",
    fillOpacity: 0.263
  })), _path6789 || (_path6789 = /*#__PURE__*/React.createElement("path", {
    d: "M59 115v1h-1v-1z",
    fill: "#447262",
    fillOpacity: 0.263
  })), _path6790 || (_path6790 = /*#__PURE__*/React.createElement("path", {
    d: "M59 116v-1h1v1z",
    fill: "#447264",
    fillOpacity: 0.278
  })), _path6791 || (_path6791 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115v1h-1v-1z",
    fill: "#407362",
    fillOpacity: 0.294
  })), _path6792 || (_path6792 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h1v1h-1z",
    fill: "#3f7262",
    fillOpacity: 0.314
  })), _path6793 || (_path6793 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v1h-1v-1z",
    fill: "#416f60",
    fillOpacity: 0.322
  })), _path6794 || (_path6794 = /*#__PURE__*/React.createElement("path", {
    d: "M64 115v1h-1v-1z",
    fill: "#427162",
    fillOpacity: 0.345
  })), _path6795 || (_path6795 = /*#__PURE__*/React.createElement("path", {
    d: "M69 115h1v1h-1z",
    fill: "#427365",
    fillOpacity: 0.345
  })), _path6796 || (_path6796 = /*#__PURE__*/React.createElement("path", {
    d: "M70 115h1v1h-1z",
    fill: "#447364",
    fillOpacity: 0.337
  })), _path6797 || (_path6797 = /*#__PURE__*/React.createElement("path", {
    d: "M73 116v-1h1v1z",
    fill: "#447264",
    fillOpacity: 0.349
  })), _path6798 || (_path6798 = /*#__PURE__*/React.createElement("path", {
    d: "M76 116h-1v-1h1z",
    fill: "#467264",
    fillOpacity: 0.357
  })), _path6799 || (_path6799 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115v1h-1v-1z",
    fill: "#467164",
    fillOpacity: 0.369
  })), _path6800 || (_path6800 = /*#__PURE__*/React.createElement("path", {
    d: "M79 116h-1v-1h1z",
    fill: "#437164",
    fillOpacity: 0.369
  })), _path6801 || (_path6801 = /*#__PURE__*/React.createElement("path", {
    d: "M80 116h-1v-1h1z",
    fill: "#467163",
    fillOpacity: 0.38
  })), _path6802 || (_path6802 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116h-1v-1h1z",
    fill: "#487164",
    fillOpacity: 0.388
  })), _path6803 || (_path6803 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v-1h1v1z",
    fill: "#436f60",
    fillOpacity: 0.384
  })), _path6804 || (_path6804 = /*#__PURE__*/React.createElement("path", {
    d: "M82 116v-1h1v1z",
    fill: "#447161",
    fillOpacity: 0.38
  })), _path6805 || (_path6805 = /*#__PURE__*/React.createElement("path", {
    d: "M83 116v-1h1v1z",
    fill: "#427161",
    fillOpacity: 0.388
  })), _path6806 || (_path6806 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115v1h-1v-1z",
    fill: "#427364",
    fillOpacity: 0.408
  })), _path6807 || (_path6807 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116v-1h1v1z",
    fill: "#437264",
    fillOpacity: 0.427
  })), _path6808 || (_path6808 = /*#__PURE__*/React.createElement("path", {
    d: "M86 116v-1h1v1z",
    fill: "#4d786b",
    fillOpacity: 0.475
  })), _path6809 || (_path6809 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115v1h-1v-1z",
    fill: "#487566",
    fillOpacity: 0.467
  })), _path6810 || (_path6810 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115h1v1h-1z",
    fill: "#2a4a3f",
    fillOpacity: 0.188
  })), _path6811 || (_path6811 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115v1h-1v-1z",
    fill: "#150a0a",
    fillOpacity: 0.094
  })), _path6812 || (_path6812 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116v-1h1v1z",
    fill: "#121212",
    fillOpacity: 0.11
  })), _path6813 || (_path6813 = /*#__PURE__*/React.createElement("path", {
    d: "M92 116h-1v-1h1z",
    fill: "#15150a",
    fillOpacity: 0.094
  })), _path6814 || (_path6814 = /*#__PURE__*/React.createElement("path", {
    d: "M94 116h-1v-1h1z",
    fill: "#121209",
    fillOpacity: 0.106
  })), _path6815 || (_path6815 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v1h-1v-1z",
    fill: "#111",
    fillOpacity: 0.114
  })), _path6816 || (_path6816 = /*#__PURE__*/React.createElement("path", {
    d: "M96 116h-1v-1h1z",
    fill: "#1c1212",
    fillOpacity: 0.106
  })), _path6817 || (_path6817 = /*#__PURE__*/React.createElement("path", {
    d: "M97 116h-1v-1h1z",
    fill: "#1f1f15",
    fillOpacity: 0.094
  })), _path6818 || (_path6818 = /*#__PURE__*/React.createElement("path", {
    d: "M99 115v1h-1v-1z",
    fill: "#131313",
    fillOpacity: 0.102
  })), _path6819 || (_path6819 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115v1h-1v-1z",
    fill: "#1d1d13",
    fillOpacity: 0.102
  })), _path6820 || (_path6820 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115h1v1h-1z",
    fill: "#1d1313",
    fillOpacity: 0.102
  })), _path6821 || (_path6821 = /*#__PURE__*/React.createElement("path", {
    d: "M102 115v1h-1v-1z",
    fill: "#0f0f0f",
    fillOpacity: 0.129
  })), _path6822 || (_path6822 = /*#__PURE__*/React.createElement("path", {
    d: "M103 116h-1v-1h1z",
    fill: "#0b0b0b",
    fillOpacity: 0.18
  })), _path6823 || (_path6823 = /*#__PURE__*/React.createElement("path", {
    d: "M104 115v1h-1v-1z",
    fill: "#0c0c0c",
    fillOpacity: 0.239
  })), _path6824 || (_path6824 = /*#__PURE__*/React.createElement("path", {
    d: "M104 116v-1h1v1z",
    fill: "#0c100c",
    fillOpacity: 0.31
  })), _path6825 || (_path6825 = /*#__PURE__*/React.createElement("path", {
    d: "M105 115h1v1h-1z",
    fill: "#0f0f0d",
    fillOpacity: 0.38
  })), _path6826 || (_path6826 = /*#__PURE__*/React.createElement("path", {
    d: "M107 115v1h-1v-1z",
    fill: "#121410",
    fillOpacity: 0.49
  })), _path6827 || (_path6827 = /*#__PURE__*/React.createElement("path", {
    d: "M107 116v-1h1v1z",
    fill: "#131313",
    fillOpacity: 0.557
  })), _path6828 || (_path6828 = /*#__PURE__*/React.createElement("path", {
    d: "M109 115v1h-1v-1z",
    fill: "#141412",
    fillOpacity: 0.647
  })), _path6829 || (_path6829 = /*#__PURE__*/React.createElement("path", {
    d: "M110 116h-1v-1h1z",
    fill: "#141313",
    fillOpacity: 0.718
  })), _path6830 || (_path6830 = /*#__PURE__*/React.createElement("path", {
    d: "M111 116h-1v-1h1z",
    fill: "#111",
    fillOpacity: 0.757
  })), _path6831 || (_path6831 = /*#__PURE__*/React.createElement("path", {
    d: "M112 115v1h-1v-1z",
    fill: "#0f0f0e",
    fillOpacity: 0.82
  })), _path6832 || (_path6832 = /*#__PURE__*/React.createElement("path", {
    d: "M112 116v-1h1v1z",
    fill: "#0f0f0f",
    fillOpacity: 0.855
  })), _path6833 || (_path6833 = /*#__PURE__*/React.createElement("path", {
    d: "M114 115v1h-1v-1z",
    fill: "#0e0e0f",
    fillOpacity: 0.894
  })), _path6834 || (_path6834 = /*#__PURE__*/React.createElement("path", {
    d: "M114 116v-1h1v1z",
    fill: "#0c0c0c",
    fillOpacity: 0.929
  })), _path6835 || (_path6835 = /*#__PURE__*/React.createElement("path", {
    d: "M115 115h1v1h-1z",
    fill: "#0c0d0a",
    fillOpacity: 0.965
  })), _path6836 || (_path6836 = /*#__PURE__*/React.createElement("path", {
    d: "M117 115v1h-1v-1z",
    fill: "#0d0d0b",
    fillOpacity: 0.996
  })), _path6837 || (_path6837 = /*#__PURE__*/React.createElement("path", {
    d: "M117 116v-1h1v1z",
    fill: "#0f100e"
  })), _path6838 || (_path6838 = /*#__PURE__*/React.createElement("path", {
    d: "M119 115v1h-1v-1z",
    fill: "#0e0e0d"
  })), _path6839 || (_path6839 = /*#__PURE__*/React.createElement("path", {
    d: "M121 115v1h-1v-1z",
    fill: "#100f0f"
  })), _path6840 || (_path6840 = /*#__PURE__*/React.createElement("path", {
    d: "M122 116h-1v-1h1z",
    fill: "#121010"
  })), _path6841 || (_path6841 = /*#__PURE__*/React.createElement("path", {
    d: "M122 115h1v1h-1z",
    fill: "#12100f",
    fillOpacity: 0.722
  })), _path6842 || (_path6842 = /*#__PURE__*/React.createElement("path", {
    d: "M113 117v-1h1v1z",
    fill: "#332626",
    fillOpacity: 0.078
  })), _path6843 || (_path6843 = /*#__PURE__*/React.createElement("path", {
    d: "M115 117h-1v-1h1z",
    fill: "#222",
    fillOpacity: 0.118
  })), _path6844 || (_path6844 = /*#__PURE__*/React.createElement("path", {
    d: "M115 117v-1h1v1z",
    fill: "#27271c",
    fillOpacity: 0.176
  })), _path6845 || (_path6845 = /*#__PURE__*/React.createElement("path", {
    d: "M116 117v-1h1v1z",
    fill: "#292920",
    fillOpacity: 0.243
  })), _path6846 || (_path6846 = /*#__PURE__*/React.createElement("path", {
    d: "M118 116v1h-1v-1z",
    fill: "#262320",
    fillOpacity: 0.624
  })), _path6847 || (_path6847 = /*#__PURE__*/React.createElement("path", {
    d: "M119 117h-1v-1h1z",
    fill: "#1f1d1b",
    fillOpacity: 0.886
  })), _path6848 || (_path6848 = /*#__PURE__*/React.createElement("path", {
    d: "M120 117h-1v-1h1z",
    fill: "#21201e",
    fillOpacity: 0.886
  })), _path6849 || (_path6849 = /*#__PURE__*/React.createElement("path", {
    d: "M121 116v1h-1v-1z",
    fill: "#242321",
    fillOpacity: 0.867
  })), _path6850 || (_path6850 = /*#__PURE__*/React.createElement("path", {
    d: "M122 116v1h-1v-1z",
    fill: "#302b2b",
    fillOpacity: 0.576
  })), _path6851 || (_path6851 = /*#__PURE__*/React.createElement("path", {
    d: "M122 117v-1h1v1z",
    fill: "#393131",
    fillOpacity: 0.122
  })), _path6852 || (_path6852 = /*#__PURE__*/React.createElement("path", {
    d: "M119 117v1h-1v-1z",
    fill: "#1e1e0f",
    fillOpacity: 0.067
  })), _path6853 || (_path6853 = /*#__PURE__*/React.createElement("path", {
    d: "M119 118v-1h1v1z",
    fill: "#1e1e1e",
    fillOpacity: 0.067
  })), _path6854 || (_path6854 = /*#__PURE__*/React.createElement("path", {
    d: "M120 117h1v1h-1z",
    fill: "#121212",
    fillOpacity: 0.055
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensAndMarkers);
export default __webpack_public_path__ + "static/media/pens_and_markers.f06b8abe390aa6c5f31146f0e4fc51a5.svg";
export { ForwardRef as ReactComponent };